{
  "auth": {
    "agree": "我同意",
    "createAccount": "创建账号",
    "createNewAccount": "创建新账号",
    "email": "电子邮箱",
    "tokenSuccess": "令牌验证成功",
    "tokenInvalid": "令牌无效或已过期",
    "login": "登录",
    "tokenMissing": "URL中缺少令牌",
    "password": "密码",
    "recover_password": "恢复密码",
    "sign_up": "注册",
    "keep_logged_in": "保持登录",
    "termsOfUse": "使用条款",
    "reset_password": "重置密码",
    "username": "用户名",
    "username_required": "用户名字段为必填项",
    "forgot_password": "忘记密码？",
    "new_to_vuestic": "Vuestic新手?",
    "welcome_back": "欢迎回来！请登录您的账户。",
    "create_account": "创建账号",
    "success_message": "认证成功",
    "login_error": "登录失败，请重试。",
    "have_account": "已有账号？",
    "repeat_password": "重复密码",
    "repeat_password_required": "需要重复密码",
    "passwords_do_not_match": "密码不匹配",
    "admin_created_success": "管理员创建成功",
    "create_admin_failed": "创建管理员失败",
    "password_required": "密码字段为必填项",
    "password_validation": "密码必须至少8个字符长, 并包含一个大写字母和一个特殊字符",
    "errors": {
      "password_not_valid": "密码无效。",
      "login_not_found": "未找到该登录账号。"
    },
    "forgot_password_title": "忘记密码了？",
    "forgot_password_description": "如果您忘记了密码，别担心。只需在下方输入您的电子邮件地址，我们会向您发送一封包含临时密码的电子邮件。恢复对您账户的访问从未如此简单。",
    "email_required": "电子邮件字段为必填项",
    "enter_email": "输入您的电子邮件",
    "email_valid": "电子邮件应该有效",
    "send_password": "发送密码",
    "go_back": "返回",
    "logout": "登出",
    "session_ended": "会话已结束",
    "agent_session_ended": "代理会话已结束",
    "admin_still_logged_in": "管理员仍在其标签页中登录",
    "window_closing_auto": "窗口正在自动关闭...",
    "closing": "正在关闭...",
    "demo": {
      "got_questions": "有问题吗？",
      "request_demo_desc": "请求免费演示，让专家回答您的所有问题。",
      "request_demo_button": "请求演示",
      "request_free_demo": "请求免费演示",
      "claim_spot": "立即预订您的位置，用我们卓越的软件解决方案点燃创新",
      "email_label": "电子邮箱",
      "email_valid": "电子邮箱应该有效",
      "demo_submitted": "演示请求已提交！",
      "expert_contact": "专家将很快与您联系"
    }
  },
  "404": {
    "title": "404页面",
    "text": "如果您觉得这不对，请给我们发送消息",
    "back_button": "返回仪表板"
  },
  "typography": {
    "primary": "主要文本样式",
    "secondary": "次要文本样式"
  },
  "versions": {
    "title": "版本管理",
    "description": "应用程序版本管理页面",
    "editVersion": "编辑版本",
    "linkTitle": "版本链接",
    "totalLinks": "总链接数",
    "addLink": "添加链接",
    "editLink": "编辑链接",
    "noLinks": "暂无链接",
    "addFirstLink": "添加您的第一个版本链接",
    "selectVersion": "选择版本",
    "uploadFile": "上传文件",
    "dragAndDropFile": "将文件拖放到此处",
    "linkCopied": "链接已复制到剪贴板",
    "failedToCopyLink": "复制链接失败",
    "deleteLink": "删除链接",
    "deleteLinkConfirm": "您确定要删除版本 \"{version}\" 的版本链接 \"{name}\" 吗？",
    "deleteLinkWarning": "此操作无法撤销。",
    "name": "名称",
    "url": "URL",
    "create": "创建",
    "update": "更新",
    "addNewVersion": "添加新版本",
    "versionNumber": "版本",
    "dateRelease": "发布日期",
    "versionDescription": "描述",
    "uploadAndroidFile": "上传Android文件",
    "uploadIosFile": "上传IOS文件",
    "otherIosFile": "其他IOS文件",
    "androidApk": "Android APK",
    "iosIpaZip": "iOS IPA/ZIP",
    "otherIosFileLabel": "其他IOS文件",
    "cancel": "取消",
    "uploading": "上传中...",
    "updateVersion": "更新版本",
    "createVersion": "已创建",
    "totalVersions": "总版本数",
    "latestVersion": "最新版本",
    "lastRelease": "最后发布",
    "searchVersions": "搜索版本...",
    "addVersion": "添加版本",
    "loadingVersions": "加载版本中...",
    "noVersionsYet": "暂无版本",
    "createFirstVersion": "创建您的第一个应用版本以开始",
    "createFirstVersionButton": "创建第一个版本",
    "noVersionsFound": "未找到版本",
    "adjustSearchCriteria": "尝试调整您的搜索条件",
    "clearSearch": "清除搜索",
    "id": "ID",
    "releaseDate": "发布日期",
    "android": "Android",
    "ios": "iOS",
    "ismultiple": "多重",
    "forceInstall": "强制安装",
    "actions": "操作",
    "edit": "编辑",
    "delete": "删除",
    "deleteVersion": "版本删除成功",
    "deleteVersionConfirm": "删除版本 {version}？",
    "versionPlaceholder": "例如：1.0.0",
    "datePlaceholder": "YYYY-MM-DD",
    "descriptionPlaceholder": "输入版本描述...",
    "fillRequiredFields": "请填写所有必填字段",
    "missingRequiredFields": "缺少必填字段：{fields}",
    "versionNumberRequired": "版本号为必填项",
    "releaseDateRequired": "发布日期为必填项",
    "descriptionRequired": "描述为必填项",
    "uploadAtLeastOneFile": "请至少上传一个文件：Android或iOS",
    "notAvailable": "不可用",
    "failedToLoadVersions": "加载版本失败",
    "failedToSubmitVersion": "提交版本失败",
    "failedToDeleteVersion": "删除版本失败",
    "widgets": {
      "counterWidget": {
        "title": "管理组件",
        "onlineUsers": "在线用户",
        "refresh": "刷新",
        "total": "总计",
        "web": "网页",
        "android": "安卓",
        "ios": "iOS",
        "refreshing": "刷新中...",
        "refreshNow": "立即刷新",
        "refreshInterval": "刷新间隔：",
        "seconds30": "30秒",
        "updatedSecondsAgo": "{diff}秒前更新",
        "updatedMinutesAgo": "{diff}分钟前更新",
        "updatedAt": "{time}更新"
      },
      "installWidget": {
        "title": "安装组件",
        "installManagement": "安装管理",
        "refresh": "刷新",
        "android": "安卓",
        "ios": "iOS",
        "refreshing": "刷新中...",
        "refreshNow": "立即刷新",
        "refreshInterval": "刷新间隔：",
        "seconds30": "30秒",
        "updatedSecondsAgo": "{diff}秒前更新",
        "updatedMinutesAgo": "{diff}分钟前更新",
        "updatedAt": "{time}更新"
      }
    }
  },
  "dashboard": {
    "title": "仪表板",
    "dataSection": {
      "openInvoices": "未结发票",
      "ongoingProjects": "进行中的项目",
      "employees": "员工",
      "newProfit": "新利润",
      "sinceLastMonth": "自上月以来"
    },
    "orderOverview": {
      "today": "今天",
      "yesterday": "昨天",
      "title": "订单概览",
      "subtitle": "订单概览",
      "count": "数量",
      "amount": "金额"
    },
    "monthlyOrder": {
      "thisMonth": "本月",
      "lastMonth": "上月",
      "title": "月度订单",
      "allTime": "全部时间",
      "subtitle": "月度订单概览",
      "count": "数量",
      "amount": "金额"
    },
    "deductionOverview": {
      "thisMonth": "本月",
      "lastMonth": "上月",
      "title": "扣款概览",
      "subtitle": "扣款概览",
      "count": "数量",
      "amount": "金额",
      "today": "今天",
      "yesterday": "昨天"
    },
    "monthlyDeduction": {
      "thisMonth": "本月",
      "lastMonth": "上月",
      "title": "月度扣款",
      "subtitle": "月度扣款概览",
      "count": "数量",
      "amount": "金额"
    },
    "reserved": {
      "title": "预留组件",
      "subtitle": "此组件为未来使用预留",
      "ofTotal": "占总数的"
    },
    "reserved_other": {
      "title": "预留组件"
    },
    "agentSalesRankingWidget": {
      "yesterdayTitle": "代理销售排行榜(昨日排行)",
      "yesterdaySubtitle": "Agent Sales Ranking (Yesterday)",
      "todayTitle": "代理销售排行榜(日排行)",
      "todaySubtitle": "Agent Sales Ranking (Today)",
      "loading": "加载中...",
      "noData": "暂无排行榜数据",
      "columns": {
        "rank": "排名",
        "agent": "代理",
        "sales": "销售额",
        "revenue": "实际收入",
        "orders": "订单数"
      }
    },
    "visitStatWidget": {
      "overview": "概览",
      "realtime": "实时",
      "today": "今天",
      "yesterday": "昨天",
      "allTime": "所有时间",
      "totalVisits": "总访问量",
      "avgTime": "总持续时间",
      "newUsers": "新用户",
      "online": "在线",
      "onlineRecently": "最近在线",
      "returningUsers": "老用户",
      "downloads": "着陆页点击",
      "installations": "安装量",
      "newUsers7Days": "新用户（7天）",
      "videoClicks": "视频点击",
      "postClicks": "帖子点击",
      "resourceClickDetails": "资源点击明细",
      "resourceClickSubtitle": "默认展示今日 Top 20",
      "allTypes": "全部类型",
      "allPlatforms": "全部平台",
      "title": "标题",
      "type": "类型",
      "resourceId": "资源ID",
      "total": "总点击",
      "sources": "来源",
      "emptyResourceClicks": "暂无点击数据",
      "previous": "上一页",
      "next": "下一页",
      "sourceVideoPage": "视频页",
      "sourcePostList": "帖子列表",
      "sourceSearchVideo": "搜索视频",
      "sourceSearchPost": "搜索帖子",
      "avgDurationAnalysis": "平均时长分析",
      "platformPerformanceAnalysis": "平台性能分析",
      "range0to1Min": "0-1分钟",
      "range1to3Min": "1-3分钟",
      "range3to10Min": "3-10分钟",
      "range10PlusMin": "10分钟以上",
      "byPlatform": "按平台",
      "globalAvgDuration": "全局平均时长",
      "allDevices": "所有设备",
      "platformComparison": "平台对比",
      "web": "H5",
      "android": "安卓",
      "ios": "iOS",
      "unknown": "未知",
      "users": "用户",
      "leadingPlatform": "领先平台",
      "totalTime": "总时间",
      "engagement": "参与度",
      "sessionDurationDistribution": "会话时长分布",
      "distribution": "分配",
      "usersByRange": "按范围用户数",
      "deviceStats": "设备统计",
      "globalDistribution": "全局分布",
      "vsYesterday": "对比昨天",
      "vsDayBefore": "对比前天",
      "vsAverage": "对比平均",
      "live": "实时",
      "onlineModeApi": "应用程序接口",
      "timeUnits": {
        "years": "年",
        "months": "月",
        "days": "天",
        "hours": "时",
        "minutes": "分",
        "seconds": "秒"
      }
    },
    "trafficDashboard": {
      "title": "流量分析",
      "subtitle": "实时流量监控和分析",
      "visits7Days": "访问量 - 最近7天",
      "weeklyTrend": "每周趋势",
      "todayYesterday": "今天与昨天",
      "today": "今天",
      "yesterday": "昨天",
      "visits30Days": "访问量 - 最近30天",
      "monthlyEvolution": "月度演变",
      "visits24Hours": "访问量 - 最近24小时",
      "byHour": "按小时",
      "visits60Minutes": "访问量 - 最近60分钟",
      "realTime": "实时",
      "loading": "加载中...",
      "total": "总计",
      "visits": "访问",
      "noData": "无可用数据",
      "noDataSubtitle": "此期间没有访问记录可显示",
      "purchases": "购买次数",
      "purchases24Hours": "最近24小时的购买"
    },
    "announcements": {
      "title": "公告",
      "subtitle": "管理和广播您的通信",
      "tableTitle": "公告列表",
      "newAnnouncement": "新公告",
      "emptyState": {
        "title": "暂无公告",
        "create": "点击添加按钮创建新公告"
      },
      "filters": {
        "all": "全部",
        "active": "活跃",
        "scheduled": "已计划",
        "inactive": "非活跃",
        "archived": "已归档"
      },
      "search": "搜索公告...",
      "status": {
        "active": "活跃",
        "scheduled": "已计划",
        "confirmation": "确认"
      },
      "actions": {
        "activate": "激活",
        "deactivate": "停用",
        "edit": "编辑",
        "delete": "删除"
      },
      "stats": {
        "total": "总计",
        "active": "活跃",
        "scheduled": "已计划"
      },
      "itemsPerPage": "每页显示条目",
      "table": {
        "status": "状态",
        "title": "标题",
        "content": "内容",
        "date": "日期",
        "recipients": "收件人",
        "progress": "进度",
        "actions": "操作"
      },
      "pagination": {
        "info": "显示第 {start} 到 {end} 条，共 {total} 条公告",
        "jump": "页面:",
        "jumpButton": "前往"
      },
      "modal": {
        "newTitle": "新公告",
        "createTitle": "新公告",
        "editTitle": "编辑公告",
        "title": "标题 *",
        "titleLabel": "标题 *",
        "titlePlaceholder": "输入公告标题...",
        "content": "内容 *",
        "contentLabel": "内容 *",
        "contentPlaceholder": "编写您的公告...",
        "targetType": "目标",
        "targetAll": "所有代理",
        "targetSpecific": "特定代理",
        "selectAgents": "选择代理",
        "agentsSelected": "已选择 {count} 个代理",
        "recipients": "收件人",
        "recipientsAll": "所有代理",
        "recipientsSpecific": "特定代理",
        "selectRecipients": "选择收件人",
        "recipientsSelected": "已选择 {count} 个代理",
        "recipientsAllInfo": "所有代理都将收到此公告",
        "recipientsAllInfoText": "{count} 个代理将收到此公告",
        "publishing": "发布",
        "publish": "发布",
        "publishNow": "立即发布",
        "publishLater": "稍后发布",
        "schedule": "计划",
        "scheduleAt": "计划时间",
        "publishDate": "发布日期",
        "forceConfirmation": "强制确认",
        "forceConfirm": "强制确认",
        "forceConfirmationDesc": "代理必须点击\"我理解\"才能关闭",
        "forceConfirmDesc": "代理必须点击\"我理解\"才能关闭",
        "cancel": "取消",
        "confirm": "确认 ({count})",
        "save": "保存",
        "sending": "发送中...",
        "bold": "粗体",
        "italic": "斜体",
        "underline": "下划线",
        "list": "列表",
        "numberedList": "编号列表"
      },
      "agentSelector": {
        "title": "选择代理",
        "search": "搜索代理...",
        "selectAll": "全选",
        "deselectAll": "取消全选",
        "selected": "已选择",
        "noResults": "未找到代理",
        "cancel": "取消",
        "confirm": "确认"
      },
      "progressModal": {
        "title": "发送公告",
        "sent": "已发送",
        "total": "总计",
        "success": "发送成功！",
        "done": "完成"
      },
      "messages": {
        "error": "错误",
        "success": "成功",
        "titleRequired": "标题是必需的",
        "contentRequired": "内容是必需的",
        "publishDateRequired": "发布日期是必需的",
        "selectAtLeastOneAgent": "请至少选择一个代理",
        "invalidDate": "无效日期",
        "dateInPast": "发布日期不能是过去的日期。",
        "dateInFuture": "发布日期不能超过未来一个月。",
        "loadingAgents": "无法加载代理列表",
        "loadingAnnouncements": "无法加载公告",
        "confirmAction": "确认操作",
        "confirmToggle": "您真的要{action}这个公告吗？",
        "confirmDelete": "确认删除",
        "deleteWarning": "此操作不可逆转",
        "deleteWarningText": "您真的要删除此公告吗？此操作不可逆转。",
        "announcementUpdated": "已更新！",
        "announcementUpdatedMessage": "公告已更新",
        "announcementActivated": "已激活",
        "announcementDeactivated": "已停用",
        "deleted": "已删除！",
        "announcementDeleted": "已删除！",
        "announcementDeletedMessage": "公告已删除",
        "sendingInProgress": "发布进行中！",
        "sendingMessage": "公告正在发送给代理...",
        "sendingComplete": "发送完成！",
        "sendingCompleteMessage": "所有 {count} 个通知已成功发送",
        "sendingPartial": "部分发送",
        "sendingPartialMessage": "{current}/{total} 个代理已收到通知",
        "scheduled": "已计划！",
        "scheduledMessage": "{title} 将于 {date} 发布",
        "published": "已发布！",
        "publishedMessage": "{title}",
        "buttonText": {
          "activate": "激活",
          "deactivate": "停用",
          "delete": "删除",
          "cancel": "取消"
        },
        "progressMessages": {
          "preparing": "准备发送...",
          "sending": "正在发送通知 ({current}/{total})...",
          "complete": "所有通知已发送！"
        }
      }
    },
    "cards": {
      "monthlyEarnings": {
        "title": "月收入",
        "lastMonth": "上月"
      },
      "regionRevenue": {
        "title": "按地区收入",
        "export": "导出",
        "topRegion": "热门地区",
        "revenue": "收入"
      },
      "revenueByLocation": {
        "title": "按位置收入"
      },
      "revenueReport": {
        "title": "收入报告",
        "export": "导出",
        "totalEarnings": "总收入",
        "earningsThisMonth": "本月收入"
      },
      "yearlyBreakup": {
        "title": "年度分布",
        "lastYear": "去年"
      },
      "timeline": {
        "title": "时间线"
      }
    },
    "versions": "版本 （技术使用）",
    "setupRemoteConnections": "设置远程连接",
    "currentVisitors": "当前访问者",
    "charts": {
      "trendyTrends": "流行趋势",
      "showInMoreDetail": "显示更多细节",
      "showInLessDetail": "显示较少细节",
      "loadingSpeed": "加载速度",
      "topContributors": "主要贡献者",
      "showNextFive": "显示接下来的五个",
      "commits": "提交"
    },
    "info": {
      "componentRichTheme": "组件丰富的主题",
      "completedPullRequests": "已完成的拉取请求",
      "users": "用户",
      "points": "点数",
      "units": "单位",
      "exploreGallery": "探索画廊",
      "viewLibrary": "查看库",
      "commits": "提交",
      "components": "组件",
      "teamMembers": "团队成员"
    },
    "tabs": {
      "overview": {
        "title": "概述",
        "built": "使用 Vue.js 框架构建",
        "free": "对所有人完全免费",
        "fresh": "新鲜和清新的设计",
        "mobile": "响应式且优化移动",
        "components": "大量有用的组件",
        "nojQuery": "完全不使用 jQuery"
      },
      "billingAddress": {
        "title": "账单地址",
        "personalInfo": "个人信息",
        "firstName": "名字 & 姓氏",
        "email": "电子邮箱",
        "address": "地址",
        "companyInfo": "公司信息",
        "game_platforms": "平台",
        "game_country_mapping": "国家映射",
        "game-platform-i18n": "平台I18n",
        "game-internationalization": "游戏国际化",
        "addConnection": "添加连接"
      },
      "bankDetails": {
        "title": "银行详情",
        "detailsFields": "详情字段",
        "bankName": "银行名称",
        "accountName": "账户名称",
        "sortCode": "排序代码",
        "accountNumber": "账号",
        "notes": "备注",
        "sendDetails": "发送详情"
      }
    },
    "navigationLayout": "导航布局",
    "topBarButton": "顶部按钮",
    "sideBarButton": "侧边按钮"
  },
  "language": {
    "brazilian_portuguese": "葡萄牙语",
    "english": "英语",
    "spanish": "西班牙语",
    "simplified_chinese": "简体中文",
    "persian": "波斯语"
  },
  "menu": {
    "price": "代理价格设置",
    "user-notification": "通知",
    "annonce_editor_dark": "公告编辑器深色模式",
    "dashboard": "仪表板",
    "system-settings": "系统设置",
    "domain_name_registration": "短域名解析申请",
    "purchase_history": "购买历史",
    "agents": "代理",
    "agents-revenue": "代理收入",
    "content": "内容管理",
    "annonce_editor": "开屏公告编辑",
    "admins": "管理员",
    "coming_soon": "暂未开放",
    "steal_stat": "盗窃统计",
    "movie-price": "视频 & 社区价格",
    "users_tab": "会员管理",
    "home": "首页",
    "users": "用户",
    "agents-list": "代理列表",
    "agents-commission": "代理佣金",
    "agent-incomes": "代理收入",
    "chat": "聊天",
    "chat_conversations": "聊天对话",
    "chat_log": "聊天记录",
    "versions": "版本 （技术使用）",
    "versions-link": "版本链接",
    "videos": "视频",
    "all-videos": "所有视频",
    "category": "分类",
    "tag": "标签",
    "post": "文章",
    "all-post": "所有文章",
    "category_p": "文章分类",
    "tag_p": "文章标签",
    "media": "推广",
    "all-emoji": "表情管理",
    "emoji": "表情",
    "banner": "横幅",
    "ads": "广告",
    "promotions": "链接制作",
    "promotion-platform": "推广平台",
    "promotion-link": "推广链接",
    "promotion-tracking": "广告参数对接",
    "mangas": "漫画",
    "country": "国家",
    "domain": "域名管理（暂未开放）",
    "domain_management": "域名管理",
    "domain_surveillance": "域名监控",
    "domain_mapping": "域名映射",
    "domain_failover": "域名故障转移",
    "domain_api_change_logs": "域名API变更日志",
    "domain_resource_change_logs": "域名资源变更日志",
    "config": "配置（暂未开放）",
    "game_reduce": "游戏减免",
    "gestion_traduction": "翻译管理",
    "gestion_jeux": "游戏管理",
    "game_catalog": "游戏目录",
    "game_platforms": "游戏平台",
    "game_country_mapping": "游戏国家映射",
    "game-platform-i18n": "平台翻译",
    "game-internationalization": "游戏国际化",
    "landing": "着陆页（暂未开放）",
    "landing-page": "首页",
    "landing-management": "落地页管理",
    "vip": "VIP & 产品价格设置",
    "vip-plans": "VIP计划",
    "vip-setting": "VIP设置",
    "orders": "订单管理",
    "vip-rights": "VIP权限（技术用）",
    "agents-vip": "VIP代理",
    "users-vip": "VIP用户",
    "wallet_management": "钱包管理（暂未开放）",
    "withdraw": "提现管理",
    "withdrawAgent": "提现",
    "announcements": "公告管理",
    "notice_management": "公告",
    "system_announcements": "系统公告",
    "exchange": "支付管理",
    "exchange-plans": "兑换计划",
    "payment-platforms": "支付平台配置",
    "payment-channels": "支付配置"
  },
  "messages": {
    "all": "查看所有消息",
    "new": "来自 {name} 的新消息",
    "mark_as_read": "标记为已读",
    "settings": "设置",
    "billing": "账单",
    "faq": "常见问题",
    "helpAndSupport": "帮助与支持",
    "projects": "项目",
    "account": "账户",
    "explore": "探索"
  },
  "treeView": {
    "basic": "基本型",
    "icons": "图标",
    "selectable": "可选择",
    "editable": "可编辑",
    "advanced": "高级"
  },
  "chat": {
    "title": "聊天",
    "chatConversation": {
      "header": "消息",
      "emptyTitle": "无消息",
      "emptySubtitle": "选择一个对话开始聊天",
      "users": "用户",
      "showMore": "显示更多",
      "defaultUser": "用户",
      "defaultUserWithId": "用户 {id}",
      "Nomessagesyet": "暂无消息",
      "loadingConversation": "正在加载对话...",
      "searchPlaceholder": "搜索对话...",
      "startConversation": "开始对话",
      "conversations": "对话",
      "noConversations": "未找到对话",
      "newConversation": "新建对话",
      "online": "在线",
      "messagePlaceholder": "输入消息...",
      "selectConversation": "选择对话开始",
      "contactName": "联系人名称",
      "enterContactName": "输入联系人名称",
      "create": "创建",
      "cancel": "取消",
      "timeFormat": {
        "instant": "刚才",
        "minutesMarker": "分钟",
        "hoursMarker": "小时",
        "daysMarker": "天"
      },
      "messageStatus": {
        "sending": "发送中...",
        "sent": "已发送",
        "received": "已送达",
        "failed": "发送失败"
      },
      "errors": {
        "missingRecipientId": "错误：缺少接收用户 ID，无法发送消息。"
      },
      "type": {
        "supportAgent": "客服支持",
        "supportReclamation": "申诉支持",
        "supportVideo": "视频支持",
        "supportGame": "游戏支持"
      },
      "sessionInfo": {
        "buttonLabel": "代理信息",
        "modalTitle": "代理会话信息",
        "noData": "暂无会话信息。",
        "errorLoad": "无法加载会话信息。",
        "yes": "是",
        "no": "否",
        "fields": {
          "sessionId": "会话 ID",
          "userId": "用户 ID",
          "chatId": "聊天 ID",
          "ip": "IP",
          "country": "国家",
          "region": "地区",
          "city": "城市",
          "platform": "平台",
          "osVersion": "系统版本",
          "sdkInt": "SDK 版本",
          "isPhysicalDevice": "物理设备",
          "brand": "品牌",
          "manufacturer": "厂商",
          "model": "型号",
          "appVersion": "应用版本",
          "buildNumber": "构建号",
          "packageName": "包名",
          "flavor": "渠道",
          "createdAt": "创建时间"
        }
      }
    }
  },
  "coming_soon": {
    "title": "敬请期待"
  },
  "cards": {
    "cards": "卡片",
    "fixed": "固定的",
    "floating": "浮动的",
    "contentText": "独特的斑马条纹使它们成为人们最熟悉的动物之一。",
    "rowHeight": "行高",
    "title": {
      "dark": "暗色背景",
      "bright": "亮色卡片",
      "titleOnImageNoOverlay": "图像上的标题，但没有叠加",
      "normal": "标准卡",
      "overlayAndTextOnImage": "图像上有覆盖和文本的卡片"
    },
    "button": {
      "main": "主要",
      "cancel": "取消",
      "showMore": "显示更多",
      "readMore": "显示更多",
      "select": {
        "dark": "深色",
        "light": "浅色"
      }
    },
    "link": {
      "edit": "编辑",
      "setAsDefault": "设为默认",
      "delete": "删除",
      "traveling": "Traveling",
      "france": "法国",
      "review": "评论",
      "feedback": "反馈信息",
      "readFull": "阅读全文",
      "secondaryAction": "第二行为",
      "action1": "行为 1",
      "action2": "行为 2"
    }
  },
  "helpAndSupport": "帮助与支持",
  "aboutVuesticAdmin": "关于 Vuestic Admin",
  "search": {
    "placeholder": "搜索..."
  },
  "paymentStats": {
    "title": "财务统计",
    "realtimeOverview": "实时概览",
    "live": "实时",
    "payers": "付款人",
    "totalUsers": "总用户",
    "vsYesterday": "对比昨天",
    "today": "今天",
    "yesterday": "昨天",
    "thisMonth": "本月",
    "lastMonth": "上月",
    "orders": "订单",
    "totalPurchases": "总购买",
    "revenue": "收入",
    "totalAmount": "总金额",
    "conversionFunnel": "转化漏斗",
    "todayPerformance": "今日表现",
    "visitToRegistration": "访问 → 注册",
    "registrationToPayment": "注册 → 付款",
    "visits": "访问",
    "registrations": "注册",
    "payments": "付款",
    "detailsByType": "按类型详细信息",
    "breakdownByPaymentType": "按付款类型分类",
    "allTime": "所有时间",
    "noDataForPeriod": "此期间无数据"
  },
  "vuestic": {
    "search": "搜索",
    "noOptions": "未找到项目",
    "ok": "确认",
    "cancel": "取消",
    "uploadFile": "上传文件",
    "undo": "撤销",
    "dropzone": "将文件拖到此处上传",
    "fileDeleted": "文件已删除",
    "closeAlert": "关闭警告",
    "backToTop": "回到顶部",
    "toggleDropdown": "切换下拉菜单",
    "carousel": "轮播",
    "goPreviousSlide": "上一张幻灯片",
    "goNextSlide": "下一张幻灯片",
    "goSlide": "跳转到第 {index} 张幻灯片",
    "slideOf": "第 {index} 张，共 {length} 张",
    "close": "关闭",
    "openColorPicker": "打开颜色选择器",
    "colorSelection": "颜色选择",
    "colorName": "颜色 {color}",
    "decreaseCounter": "减少计数",
    "increaseCounter": "增加计数",
    "selectAllRows": "选择所有行",
    "sortColumnBy": "按 {name} 排序",
    "selectRowByIndex": "选择第 {index} 行",
    "resetDate": "重置日期",
    "nextPeriod": "下一个时间段",
    "switchView": "切换视图",
    "previousPeriod": "上一个时间段",
    "removeFile": "删除文件",
    "reset": "重置",
    "pagination": "分页",
    "goToTheFirstPage": "跳转到第一页",
    "goToPreviousPage": "跳转到上一页",
    "goToSpecificPage": "跳转到第 {page} 页",
    "goToSpecificPageInput": "输入页码以跳转",
    "goNextPage": "跳转到下一页",
    "goLastPage": "跳转到最后一页",
    "currentRating": "当前评分 {value} / {max}",
    "voteRating": "评分 {value} / {max}",
    "optionsFilter": "选项筛选",
    "splitPanels": "分割面板",
    "movePaginationLeft": "分页向左移动",
    "movePaginationRight": "分页向右移动",
    "resetTime": "重置时间",
    "closeToast": "关闭提示",
    "selectedOption": "已选选项",
    "noSelectedOption": "未选择选项",
    "breadcrumbs": "面包屑导航",
    "counterValue": "计数值",
    "selectedDate": "选择的日期",
    "selectedTime": "选择的时间",
    "progressState": "进度状态",
    "color": "颜色",
    "next": "下一步",
    "back": "上一步",
    "finish": "完成",
    "step": "步骤",
    "progress": "进度",
    "loading": "加载中",
    "sliderValue": "当前滑块值为 {value}",
    "switch": "切换",
    "inputField": "输入框",
    "fileTypeIncorrect": "文件类型不正确",
    "select": "选择一个选项"
  },
  "notifications": {
    "title": "通知",
    "markAllAsRead": "全部标记为已读",
    "loading": "加载中...",
    "noNotifications": "无通知",
    "importantNotification": "重要通知",
    "actionRequired": "需要操作",
    "confirmReading": "请确认您已阅读此通知",
    "cancel": "取消",
    "iUnderstand": "我理解",
    "newNotificationReceived": "收到新通知！",
    "atTheInstant": "刚刚",
    "minutesAgo": "{count}分钟前",
    "hoursAgo": "{count}小时前",
    "yesterday": "昨天",
    "daysAgo": "{count}天前",
    "scheduledNotificationPublished": "预定通知已发布！",
    "view": "查看",
    "viewNotification": "查看通知",
    "close": "关闭",
    "markAsRead": "标记为已读",
    "notificationProgress": "第 {current} 条，共 {total} 条",
    "readToContinue": "请逐条阅读所有通知后再继续使用系统。",
    "viewAllBeforeMark": "请使用上一页/下一页浏览全部通知后再标记为已读。",
    "previous": "上一页",
    "next": "下一页",
    "jumpToNotification": "跳转到通知编号",
    "jumpPlaceholder": "编号",
    "goTo": "跳转",
    "confirmOnMarkAll": "标记全部已读时将一并确认重要通知。",
    "unreadInbox": "{count} 条未读通知",
    "viewedProgress": "已查看 {viewed}/{total}",
    "selectMessage": "跳转到消息",
    "allViewedReady": "已查看全部消息，现在可以标记为已读。",
    "footerLockedHint": "请查看每条消息以解锁此操作。",
    "confirmError": "无法确认此通知，请重试。",
    "readError": "无法将此通知标记为已读，请重试。",
    "newNotification": "新通知",
    "confirmToContinue": "必须确认此通知才能继续。",
    "readAllToContinue": "还有 {remaining} 条通知需要阅读"
  },
  "agentAnnouncements": {
    "title": "公告",
    "noAnnouncements": "暂无公告。",
    "loading": "加载公告中...",
    "markAsRead": "标记为已读",
    "markAsConfirmed": "已确认",
    "date": "发布日期",
    "page": "页",
    "prev": "上一页",
    "next": "下一页",
    "new": "新"
  },
  "translations": {
    "header": {
      "title": "翻译管理",
      "subtitle": "轻松管理您的多语言翻译",
      "importJson": "导入 JSON",
      "newTranslation": "新翻译",
      "translations": "翻译",
      "activeLanguages": "活跃语言",
      "languages": "语言",
      "configured": "已配置"
    },
    "modal": {
      "title": "新翻译",
      "editTitle": "编辑翻译",
      "keyLabel": "翻译键",
      "keyPlaceholder": "输入翻译键...",
      "valueLabel": "翻译值",
      "jsonPlaceholder": "@:example_json",
      "valuePlaceholder": "输入翻译...",
      "languageLabel": "语言",
      "cancel": "取消",
      "add": "添加",
      "update": "更新"
    },
    "search": {
      "placeholder": "搜索键或值..."
    },
    "pagination": {
      "showing": "显示",
      "to": "到",
      "of": "共",
      "entries": "条目",
      "first": "首页",
      "previous": "上一页",
      "next": "下一页",
      "last": "末页",
      "show": "显示"
    },
    "table": {
      "key": "键",
      "value": "值",
      "actions": "操作",
      "edit": "编辑",
      "delete": "删除",
      "noData": "无可用翻译"
    },
    "transactionModal": {
      "title": "新交易",
      "editTitle": "编辑交易",
      "importJson": "导入 JSON",
      "jsonScriptLabel": "JSON 脚本",
      "jsonPlaceholder": "@:example_json",
      "formatJson": "格式化 JSON",
      "format": "格式化",
      "jsonInvalid": "JSON 格式无效",
      "jsonHelp": "在此粘贴您的 JSON 脚本。文本区域支持复杂的 JSON 对象和数组。",
      "languageLabel": "语言",
      "cancel": "取消",
      "add": "添加",
      "update": "更新"
    },
    "messages": {
      "translationAdded": "翻译已添加",
      "translationUpdated": "翻译已更新",
      "translationDeleted": "翻译已删除",
      "translationsAdded": "个翻译已添加",
      "transactionsAdded": "个交易已成功导入",
      "jsonFormatted": "JSON 已成功格式化",
      "jsonInvalid": "JSON 格式无效",
      "errorAdd": "添加错误",
      "errorUpdate": "更新错误",
      "errorDelete": "删除错误",
      "errorImport": "导入错误",
      "jsonNotValid": "JSON 无效（必须是对象）",
      "noDataProvided": "未提供交易数据",
      "dataMustBeObject": "数据必须是 JSON 对象"
    },
    "errorMessages": {
      "saveError": "无法保存公告",
      "statusError": "无法修改状态",
      "deleteError": "无法删除公告",
      "fetchError": "无法加载公告"
    },
    "toastMessages": {
      "languageLoadError": "加载语言时出错",
      "noTransactionAvailable": "该语言没有可用的交易",
      "pleasePasteJsonData": "请粘贴 JSON 数据",
      "jsonNotValidObject": "JSON 无效（必须是对象）",
      "noDataProvided": "未提供交易数据",
      "dataMustBeObject": "数据必须是 JSON 对象"
    },
    "confirmDelete": "删除此翻译？",
    "importTransactions": {
      "title": "导入交易",
      "jsonDataLabel": "要导入的 JSON 数据",
      "formatButton": "格式化",
      "clearButton": "清除",
      "jsonHelpText": "在此粘贴您的 JSON 对象。示例: key: value, anotherKey: anotherValue",
      "targetLanguage": "目标语言：",
      "cancelButton": "取消",
      "importButton": "导入",
      "importing": "导入中..."
    }
  },
  "example_json": "key: value, nested: data: example",
  "posts": {
    "pageTitle": "帖子",
    "openVideo": "打开视频",
    "editPost": "编辑帖子",
    "addPost": "添加帖子",
    "titleLabel": "标题",
    "contentLabel": "内容",
    "categoryIdLabel": "分类ID",
    "timeJustNow": "刚刚",
    "timeMinute": "{count} 分钟前",
    "timeMinutes": "{count} 分钟前",
    "timeHour": "{count} 小时前",
    "timeHours": "{count} 小时前",
    "timeDay": "{count} 天前",
    "timeDays": "{count} 天前",
    "timeWeek": "{count} 周前",
    "timeWeeks": "{count} 周前",
    "timeMonth": "{count} 个月前",
    "timeMonths": "{count} 个月前",
    "timeYear": "{count} 年前",
    "timeYears": "{count} 年前",
    "priceLabel": "价格",
    "pinnedLabel": "置顶",
    "featuredLabel": "精选",
    "statusLabel": "状态",
    "normalStatus": "正常",
    "deletedStatus": "已删除",
    "hiddenStatus": "隐藏",
    "cancelButton": "取消",
    "saveButton": "保存",
    "postDetails": "帖子详情",
    "idLabel": "ID",
    "userIdLabel": "用户ID",
    "createdAtLabel": "创建时间",
    "viewsLabel": "浏览",
    "favoritesLabel": "收藏",
    "likesLabel": "点赞",
    "notPinned": "未置顶",
    "notFeatured": "未精选",
    "closeButton": "关闭",
    "loadingPosts": "加载帖子中...",
    "totalPosts": "总帖子数",
    "totalViews": "总浏览数",
    "totalLikes": "总点赞数",
    "totalDislikes": "总点踩数",
    "totalComments": "总评论数",
    "pinnedPosts": "置顶帖子",
    "featuredPosts": "精选帖子",
    "engagementRate": "Engagement Rate",
    "normalPosts": "正常帖子",
    "hiddenPosts": "隐藏帖子",
    "deletedPosts": "已删除帖子",
    "searchLabel": "搜索",
    "searchPlaceholder": "按标题或内容搜索...",
    "addNewPost": "添加新帖子",
    "showing": "显示",
    "of": "共",
    "posts": "个帖子",
    "filtered": "(已过滤)",
    "noPostsFound": "未找到帖子。",
    "noPostsMatch": "没有帖子匹配您的搜索或筛选条件。",
    "userLabel": "用户",
    "categoryLabel": "分类",
    "actionsLabel": "操作",
    "detailsButton": "详情",
    "editButton": "编辑",
    "deleteButton": "删除",
    "previousButton": "上一页",
    "nextButton": "下一页",
    "pageLabel": "页",
    "titleAndContentRequired": "标题和内容为必填项",
    "categoryIdPositive": "分类ID必须为正数",
    "priceZeroOrPositive": "价格必须为零或正数",
    "confirmDelete": "您确定要删除此帖子吗？",
    "errorLoading": "加载帖子时出现错误",
    "errorUpdating": "更新帖子时出现错误",
    "errorDeleting": "删除帖子时出现错误",
    "editAllPrices": "编辑所有价格",
    "randomPriceExplanation": "使用最小值和最大值之间的随机值更新所有帖子的价格",
    "minPrice": "最低价格",
    "maxPrice": "最高价格",
    "enterAtLeastOnePrice": "请至少输入一个价格",
    "updateBtn": "更新"
  },
  "categoryPost": {
    "pageTitle": "帖子分类",
    "editCategoryPost": "编辑帖子分类",
    "addNewCategoryPost": "添加新帖子分类",
    "nameLabel": "名称",
    "namePlaceholder": "帖子分类名称",
    "sortOrderLabel": "排序顺序",
    "sortOrderPlaceholder": "0",
    "showOnHomeLabel": "在首页显示",
    "cancelButton": "取消",
    "saveButton": "保存",
    "searchPlaceholder": "搜索帖子分类...",
    "addNewCategoryPostButton": "添加新帖子分类",
    "loadingCategoryPosts": "加载帖子分类中...请稍候",
    "noCategoryPostsFound": "未找到帖子分类。",
    "noResultsFound": "未找到结果。",
    "idLabel": "ID",
    "createdAtLabel": "创建时间",
    "actionsLabel": "操作",
    "nameIsRequired": "名称为必填项",
    "errorLoadingCategoryPosts": "加载帖子分类时出错",
    "errorSavingCategoryPost": "保存帖子分类时出错",
    "errorDeletingCategoryPost": "删除帖子分类时出错",
    "confirmDeleteCategoryPost": "您确定要删除此帖子分类吗？",
    "deleteCategoryPost": "删除帖子分类",
    "createFirstCategoryPost": "创建您的第一个帖子分类开始使用",
    "tryAdjustingSearch": "尝试调整搜索条件",
    "clearSearchButton": "清除搜索",
    "updateCategoryPostButton": "更新帖子分类",
    "createCategoryPostButton": "创建帖子分类",
    "createFirstCategoryPostButton": "创建第一个帖子分类",
    "badges": {
      "home": "首页"
    },
    "stats": {
      "totalCategoryPosts": "总分类帖子数",
      "thisWeek": "本周新增",
      "lastUpdated": "最后更新"
    }
  },
  "pagination": {
    "pageOf": "第 {current} 页，共 {total} 页",
    "show": "显示"
  },
  "currency": {
    "symbol": "¥"
  },
  "tagPost": {
    "pageTitle": "帖子标签管理",
    "editTag": "编辑标签",
    "addNewTag": "添加新标签",
    "tagNameLabel": "标签名称",
    "tagNamePlaceholder": "例如：突发新闻、特色、紧急...",
    "cancelButton": "取消",
    "createTag": "创建标签",
    "updateTag": "更新标签",
    "loadingTags": "加载标签中...",
    "totalTags": "总标签数",
    "thisWeek": "本周",
    "lastUpdated": "最后更新",
    "searchPlaceholder": "按名称搜索标签...",
    "addTag": "添加标签",
    "noTagsYet": "暂无标签",
    "createFirstTagDescription": "创建您的第一个帖子标签以开始使用",
    "createFirstTag": "创建第一个标签",
    "noTagsFound": "未找到标签",
    "tryAdjustingSearch": "尝试调整您的搜索条件",
    "clearSearch": "清除搜索",
    "idLabel": "ID",
    "tagNameHeader": "标签名称",
    "createdDate": "创建日期",
    "actionsLabel": "操作",
    "editTagTitle": "编辑标签",
    "deleteTagTitle": "删除标签",
    "tagNameRequired": "标签名称为必填项",
    "errorLoadingTags": "加载标签时出现错误",
    "errorSavingTag": "保存标签时出现错误",
    "errorDeletingTag": "删除标签时出现错误",
    "confirmDeleteTag": "删除\"{tagName}\"?"
  },
  "emoji": {
    "title": "表情符号管理",
    "addNew": "添加新表情符号",
    "addNewGroup": "添加新组",
    "updateEmoji": "更新表情符号",
    "confirmDelete": "确认删除",
    "code": "代码",
    "images": "图像（最多100个）",
    "single": "单个",
    "multiple": "多个",
    "group": "组",
    "type": "类型",
    "groupName": "组名",
    "description": "描述",
    "status": "状态",
    "newImage": "新图像",
    "cancel": "取消",
    "addEmojis": "添加{count}个表情符号",
    "createGroup": "创建组",
    "save": "保存",
    "newGroup": "新组",
    "totalEmojis": "表情符号总数",
    "groups": "组",
    "svgEmojis": "SVG表情符号",
    "gifEmojis": "GIF表情符号",
    "jpgEmojis": "JPG表情符号",
    "filterByGroup": "按组筛选",
    "filterByType": "按类型筛选",
    "allGroups": "所有组",
    "allTypes": "所有类型",
    "reset": "重置",
    "loading": "加载表情符号中...",
    "id": "ID",
    "image": "图像",
    "url": "URL",
    "actions": "操作",
    "selectAGroup": "选择一个组",
    "noGroupFound": "⚠️ 未找到组。请先创建一个",
    "filesSelected": "已选择{count}个文件",
    "keepCurrentImage": "如果未选择文件则保留当前图像",
    "areYouSureDelete": "您确定要删除这个表情符号吗",
    "emojiNumber": "表情符号 #{id}",
    "groupDescription": "群组描述",
    "codePlaceholder": "例如: smiley_face",
    "groupNamePlaceholder": "例如: 表情",
    "groupCodePlaceholder": "例如: emotions",
    "groupDescriptionPlaceholder": "群组描述",
    "svg": "SVG",
    "jpg": "JPG",
    "gif": "GIF",
    "imageRequired": "需要图片",
    "pleaseSelectImage": "请选择一张图片",
    "chooseFile": "选择文件",
    "noFileChosen": "未选择文件",
    "previous": "上一页",
    "next": "下一页",
    "page": "第 {page} 页",
    "groupCreated": "组 \"{name}\" 已创建！",
    "pleaseCorrectErrors": "请更正错误",
    "errorCreatingGroup": "创建组时出错",
    "emojiUpdated": "表情符号已更新！",
    "errorUpdatingEmoji": "更新表情符号时出错",
    "emojiDeleted": "表情符号已删除！",
    "errorDeletingEmoji": "删除表情符号时出错",
    "emojiCreated": "表情符号已创建！",
    "errorCreatingEmoji": "创建表情符号时出错",
    "emojiStatusUpdated": "表情符号状态已更新！",
    "errorUpdatingEmojiStatus": "更新表情符号状态时出错",
    "onlyOneFileAllowed": "单文件模式只允许一个文件",
    "maximum100Files": "最多允许100个文件",
    "fileTypeNotSupported": "不支持的文件类型",
    "fileTooLarge": "文件太大（最大2MB）",
    "pleaseCreateGroup": "请先创建一个组",
    "errorLoadingEmoji": "加载表情符号时出错",
    "errorLoadingGroups": "加载组时出错",
    "noEmojiSelected": "未选择表情符号",
    "fileNotSupported": "不支持的文件。请使用JPEG、PNG、GIF、WebP或SVG。",
    "fileTooLargeMessage": "文件太大。最大2MB。",
    "emojiCreatedSuccess": "{count} 个表情符号创建成功！",
    "activated": "已激活",
    "deactivated": "已停用",
    "noEmojiAvailable": "没有可用的表情符号",
    "noResultForFilter": "没有找到符合筛选条件的结果",
    "createGroupFirst": "请先创建一个组",
    "tryModifyFilter": "尝试修改筛选条件",
    "createAGroup": "创建一个组",
    "addEmoji": "添加表情符号",
    "resetFilters": "重置筛选条件",
    "edit": "编辑",
    "delete": "删除",
    "noGroup": "无组",
    "preview": "预览"
  },
  "banner": {
    "pageTitle": "横幅",
    "searchPlaceholder": "搜索横幅...",
    "addBanner": "添加横幅",
    "noImage": "无图片",
    "pageOf": "第 {page} 页，共 {totalPages} 页",
    "editBanner": "编辑横幅",
    "addNewBanner": "添加新横幅",
    "noBannersTitle": "暂无横幅",
    "noBannersDescription": "开始添加您的第一个横幅进行展示",
    "addFirstBanner": "添加第一个横幅",
    "nameLabel": "名称 *",
    "namePlaceholder": "输入横幅名称",
    "descriptionLabel": "描述",
    "descriptionPlaceholder": "输入横幅描述",
    "expirationDateLabel": "过期日期 *",
    "bannerImageLabel": "横幅图片",
    "chooseFile": "选择文件",
    "noFileSelected": "未选择文件",
    "cancel": "取消",
    "update": "更新",
    "create": "创建",
    "bannerDetails": "横幅详情",
    "name": "名称:",
    "description": "描述:",
    "expirationDate": "过期日期:",
    "close": "关闭",
    "id": "ID",
    "image": "图片",
    "nameHeader": "名称",
    "descriptionHeader": "描述",
    "expiresAt": "过期时间",
    "actions": "操作",
    "confirmDelete": "您确定要删除 \"{name}\" 吗？"
  },
  "users": {
    "title": "管理员",
    "active": "活跃",
    "filterByAgent": "按代理过滤",
    "inactive": "非活跃",
    "noData": "未找到项目。",
    "noFiltered": "没有项目符合过滤条件。",
    "createVip": "创建VIP",
    "selectVipPlan": "选择一个VIP计划",
    "vipCreated": "VIP已为{username}创建",
    "search": "搜索",
    "displayId": "展示 ID",
    "blockUser": "封禁用户",
    "confirmBlockUser": "您确定要封禁 {username} 吗？",
    "addAdmin": "添加管理员",
    "totalUsers": "用户总数",
    "activeUsers": "活跃用户数",
    "editUser": "编辑用户",
    "addUser": "添加用户",
    "save": "保存",
    "add": "添加",
    "passwordRetrait": "提现密码",
    "phone": "电话号码",
    "points": "点数",
    "page": "页面",
    "of": "共",
    "chooseAvatarFile": "选择一个头像文件",
    "country": "国家",
    "visitor": "访客",
    "verified": "已验证",
    "nickname": "昵称",
    "update": "更新",
    "days": "天",
    "createdAt": "创建时间",
    "userUpdated": "{username} 已更新",
    "userCreated": "{username} 已创建",
    "userDeleted": "{username} 已删除",
    "unsavedChanges": "表单有未保存的更改。您确定要关闭它吗？",
    "username": "用户名",
    "loginId": "登录 ID",
    "optionId": "游戏渠道",
    "optionIdPlaceholder": "游戏渠道",
    "password": "密码",
    "confirmPassword": "确认密码",
    "changePassword": "更改密码",
    "changePasswordFor": "为 {username} 更改密码",
    "role": "角色",
    "commissionRate": "佣金率",
    "revenue": "收入",
    "estimatedRevenue": "预估收入",
    "withdrawableAmount": "可提现金额",
    "withdrawingAmount": "提现中金额",
    "withdrawnAmount": "已提现金额",
    "status": "状态",
    "actions": "操作",
    "notAvailable": "N/A",
    "admin": "管理员",
    "agent": "代理",
    "avatar": "头像",
    "payment": "付款",
    "duration": "持续时间",
    "expires": "到期",
    "results": "结果",
    "resultsPerPage": "每页结果",
    "previousPage": "上一页",
    "nextPage": "下一页",
    "deleteUser": "删除用户",
    "deleteUserConfirm": "您确定要删除 {username} 吗？",
    "passwordRequired": "需要确认密码",
    "passwordMismatch": "密码不匹配",
    "errorMessage": "错误：{error}",
    "usernameExists": "用户名 '{username}' 已存在。请选择另一个。",
    "usernameRequired": "用户名是必需的",
    "common": {
      "search": "搜索",
      "all": "全部",
      "status": "状态",
      "active": "活跃",
      "inactive": "非活跃",
      "actions": "操作",
      "edit": "编辑",
      "delete": "删除",
      "save": "保存",
      "create": "创建",
      "cancel": "取消",
      "close": "关闭",
      "add": "添加",
      "update": "更新",
      "loading": "加载中",
      "retry": "重试",
      "error": "发生错误",
      "yes": "是",
      "no": "否",
      "confirmDelete": "您确定要删除吗？",
      "activate": "激活",
      "deactivate": "停用",
      "image": "图像"
    },
    "id": "ID",
    "yes": "是",
    "no": "否",
    "notVerified": "未验证",
    "updateVip": "更新VIP",
    "changeVipPlan": "更改VIP套餐",
    "keepCurrentVip": "保留当前VIP",
    "newPassword": "新密码",
    "confirmNewPassword": "确认新密码",
    "vipSettings": "VIP设置",
    "currentVipCard": "当前VIP卡",
    "noVip": "无VIP",
    "vip": "VIP",
    "vipRequired": "VIP*",
    "selectOption": "选择一个选项",
    "unlimitedVideos": "无限观看所有视频",
    "lifetimeVideos": "终身观看所有视频",
    "yearVideos": "观看所有视频1年",
    "monthVideos": "观看所有视频1个月",
    "dayVideos": "观看所有视频1天",
    "durationRequired": "持续时间*",
    "unit": "单位*",
    "minutes": "分钟",
    "hour": "小时",
    "day": "天",
    "vipNote": "注意：删除用户之前的VIP状态",
    "submit": "提交",
    "vipRenewed": "已为{username}续费VIP",
    "vipRenewalError": "VIP续费错误",
    "selectValidityType": "请选择有效期类型",
    "fillDurationUnit": "请填写持续时间和单位",
    "enterNewPassword": "输入新密码",
    "passwordsDoNotMatch": "密码不匹配",
    "passwordUpdated": "已为{username}更新密码",
    "passwordUpdateError": "密码更新失败：{error}",
    "createError": "创建用户{username}失败：{error}",
    "unknownError": "未知错误：{error}",
    "cancel": "取消操作",
    "tableHeaders": {
      "username": "用户名",
      "nickname": "昵称",
      "phone": "电话",
      "role": "角色",
      "id": "ID",
      "vip": "VIP",
      "points": "点数",
      "country": "国家",
      "agent": "代理",
      "visitor": "来源",
      "verified": "已验证",
      "createdAt": "创建时间",
      "status": "状态"
    }
  },
  "country": {
    "title": "国家语言管理器",
    "searchPlaceholder": "按国家或语言代码搜索...",
    "addLanguage": "添加语言",
    "id": "ID",
    "name": "名称",
    "country": "国家",
    "namePlaceholder": "例如：新闻、精选、紧急...",
    "languageCode": "语言代码",
    "langPlaceholder": "例如：fr-FR、en-US...",
    "flag": "旗帜",
    "version": "版本",
    "actions": "操作",
    "noFlag": "无旗帜",
    "lang": "语言",
    "addNewLanguage": "添加新语言",
    "countryName": "国家名称",
    "deleteLanguage": "删除语言",
    "languageCodePlaceholder": "fr-FR, en-US, 等",
    "flagImage": "旗帜图片",
    "chooseFile": "选择文件",
    "noFileSelected": "未选择文件",
    "versionDate": "版本日期",
    "updateLanguage": "更新语言",
    "chooseNewFlag": "选择新旗帜",
    "new": "新",
    "currentFlag": "当前旗帜",
    "viewCurrentFlag": "查看当前旗帜",
    "confirmDelete": "确认删除",
    "deleteConfirmMessage": "您确定要删除 {country} ({language}) 吗？此操作无法撤销。",
    "loadFailed": "加载语言失败",
    "requiredFields": "国家名称、语言代码和版本为必填项",
    "invalidCountryName": "国家名称只能包含字母、空格、连字符或撇号",
    "countryExists": "国家已存在",
    "countryNameExists": "另一个同名的国家已存在",
    "createSuccess": "语言创建成功",
    "createFailed": "创建语言失败",
    "updateSuccess": "语言更新成功",
    "updateFailed": "更新语言失败",
    "deleteSuccess": "语言删除成功",
    "deleteFailed": "删除语言失败",
    "loadingLanguages": "加载语言中...",
    "noLanguagesFound": "未找到语言",
    "createFirstLanguage": "创建您的第一个语言",
    "createFirstLanguageButton": "创建语言",
    "noLanguagesMatch": "没有语言匹配您的搜索",
    "tryAdjustingSearch": "尝试调整您的搜索条件",
    "clearSearchButton": "清除搜索",
    "stats": {
      "totalLanguages": "总语言数",
      "thisWeek": "本周新增",
      "lastUpdated": "最后更新"
    }
  },
  "systemSettings": {
    "pageTitle": "系统设置",
    "sectionApi": "接口设置",
    "sectionJdVideoConfig": "京东视频配置",
    "jdVideoConfigUrlLabel": "京东视频配置地址",
    "jsonLabelJdVideoConfig": "京东视频配置（JSON）",
    "agentRedirectHint": "代理重定向提示",
    "agentRedirectLabel": "代理重定向",
    "agentRedirectFallback": "代理重定向回退",
    "sectionAgentRedirect": "代理重定向",
    "sectionVersionUrls": "版本下载地址设置",
    "versionUrlsHint": "编辑最新版本的 Android 和 iOS 下载地址。",
    "latestVersionBadge": "最新版本：",
    "addVersionButton": "新增版本",
    "versionNumberLabel": "版本号",
    "versionDateLabel": "发布日期",
    "versionDescriptionLabel": "描述",
    "versionIsMultiLabel": "多开关",
    "versionForceInstallLabel": "强制安装",
    "versionCreateRequired": "版本号、发布日期、描述、Android 地址和 iOS 地址不能为空。",
    "versionCreateInvalid": "版本号格式必须为 X.Y.Z。",
    "versionCreateSuccess": "版本创建成功。",
    "versionCreateFailed": "版本创建失败。",
    "versionAndroidUrlLabel": "Android 地址",
    "versionIosUrlLabel": "iOS 地址",
    "versionUrlsRequired": "Android 地址和 iOS 地址不能为空。",
    "versionMissingId": "无法识别最新版本 ID。",
    "cancel": "取消",
    "create": "创建",
    "sectionLanding": "App 落地设置",
    "sectionArchive": "老片库域名设置",
    "sectionIos": "iOS 书签配置",
    "sectionCfDomain": "新片库播放域名设置",
    "hintApiDomains": "可编辑 domains 数组（至少保留 1 条）。下方 JSON 与列表双向同步。",
    "addDomain": "添加域名",
    "addDocs": "添加文档",
    "openDocs": "打开文档",
    "delete": "删除",
    "save": "保存",
    "jsonLabelApi": "JSON（接口设置）",
    "jsonLabelLanding": "JSON（app 落地设置）",
    "videoUrl": "视频链接",
    "coverUrl": "封面链接",
    "jsonLabelArchive": "JSON（老片库域名）",
    "iosHint": "逗号分隔的纯文本（非 JSON），至少保留一条非空书签。",
    "addBookmark": "添加书签",
    "iosTextareaLabel": "书签列表（逗号分隔）",
    "cfDomainLabel": "播放域名",
    "loading": "正在从服务器加载…",
    "loaded": "已从服务器加载。",
    "saving": "正在保存…",
    "saved": "已保存到服务器。",
    "lastUpdated": "最后更新",
    "loadFailed": "加载失败",
    "saveFailed": "保存失败",
    "validationFailed": "校验未通过，未提交。",
    "invalidJson": "JSON 无效，未提交。",
    "remoteInvalid": "远端数据无效",
    "remoteJsonParse": "远端 JSON 无法解析。",
    "domainUrlPlaceholder": "域名 URL",
    "errJsonObject": "JSON 必须是对象。",
    "errDomains": "缺少 domains 数组。",
    "errDomainsMin": "domains 至少需要一个元素。",
    "errDomainItem": "每条记录需要有效的 domain 字符串。",
    "errUrl": "视频链接（url）必须是字符串。",
    "errCover": "封面链接（cover）必须是字符串。",
    "errIosMin": "至少保留一条书签。",
    "errIosEmpty": "至少需要一个非空的书签地址。",
    "errCfDomainEmpty": "播放域名不能为空。",
    "jsonParseFailed": "JSON 解析失败。",
    "expandJson": "展开 JSON",
    "collapseJson": "收起 JSON",
    "exportApiJson": "导出 api.json",
    "exportApiJsonSuccess": "api.json 已下载到本地。",
    "exportApiJsonFailed": "导出失败",
    "docsModal": {
      "title": "为 {target} 添加文档",
      "description": "选择你希望为这个配置添加文档的方式。",
      "modeFile": "文件",
      "modeFileHint": "直接从你的设备上传文档。",
      "modeLink": "链接",
      "modeLinkHint": "使用外部文档链接。",
      "linkLabel": "文档链接",
      "linkPlaceholder": "https://example.com/docs",
      "fileLabel": "文档文件",
      "fileEmpty": "暂未选择文件。",
      "submit": "提交",
      "linkRequired": "文档链接不能为空。",
      "fileRequired": "请选择文档文件。",
      "success": "文档保存成功。",
      "error": "文档保存失败。"
    }
  },
  "config": {
    "title": "配置管理",
    "editConfig": "编辑配置",
    "addNewConfig": "添加新配置",
    "configKey": "配置键",
    "configKeyPlaceholder": "写任何内容",
    "type": "类型",
    "typePlaceholder": "选择一个类型",
    "value": "值",
    "valuePlaceholder": "输入文本值",
    "valueNumberPlaceholder": "0",
    "valueBool": "值 (1 = 真, 0 = 假)",
    "uploadFile": "上传文件",
    "imageFile": "图片文件",
    "cancel": "取消",
    "save": "保存配置",
    "saving": "保存中...",
    "update": "更新",
    "totalConfigs": "总配置数",
    "boolean": "布尔值",
    "string": "字符串",
    "number": "数字",
    "image": "图片",
    "files": "文件",
    "searchPlaceholder": "搜索配置...",
    "addConfig": "添加配置",
    "id": "ID",
    "key": "键",
    "created": "创建时间",
    "actions": "操作",
    "true": "真",
    "false": "假",
    "edit": "编辑",
    "delete": "删除",
    "page": "页",
    "of": "共",
    "show": "显示",
    "noConfigsFound": "未找到配置",
    "configCreated": "配置创建成功",
    "configUpdated": "配置更新成功",
    "configDeleted": "配置删除成功",
    "createFailed": "创建配置失败",
    "updateFailed": "更新配置失败",
    "deleteFailed": "删除配置失败",
    "confirmDelete": "确定要删除此配置吗？",
    "requiredFields": "键和类型为必填项",
    "invalidKey": "键只能包含字母、数字、下划线和连字符",
    "configExists": "此键的配置已存在",
    "notification": {
      "titleLabel": "通知标题",
      "bodyTitle": "内容（Body）",
      "addBodyLine": "添加一行",
      "linksTitle": "链接（LinkList）",
      "addLink": "添加链接",
      "linkTextLabel": "文本",
      "linkTextPlaceholder": "按钮文本",
      "linkUrlLabel": "URL"
    },
    "errors": {
      "unexpected": "发生未知错误",
      "fetchNotification": "获取通知配置失败",
      "updateNotification": "更新通知配置失败",
      "fetchAgentConfigs": "获取代理配置失败",
      "fetchKeys": "获取配置键失败",
      "updateAgentConfigs": "更新代理配置失败",
      "updateAgentConfig": "更新代理配置失败",
      "loadAgentConfigs": "加载代理配置失败",
      "addItem": "添加项目失败",
      "removeItem": "删除项目失败",
      "addField": "添加字段失败",
      "invalidJsonObject": "JSON 必须是对象",
      "addBodyItem": "添加内容行失败",
      "removeBodyItem": "删除内容行失败",
      "addLinkItem": "添加链接失败",
      "removeLinkItem": "删除链接失败",
      "copyJson": "复制 JSON 失败",
      "keyRequired": "配置键不能为空",
      "typeRequired": "请选择类型",
      "boolValueRequired": "请设置一个值（1 或 0）",
      "stringValueRequired": "请输入字符串值",
      "numberValueRequired": "请输入数字值",
      "fileRequired": "请上传图片文件"
    },
    "json": {
      "editTitle": "编辑JSON配置",
      "viewTitle": "查看JSON配置",
      "Add New Field": "添加新字段",
      "addLink": "添加链接",
      "remove": "删除",
      "addNewField": "添加新字段",
      "text": "文本",
      "url": "URL",
      "linkText": "链接文本",
      "linkUrl": "链接URL",
      "readOnly": "只读",
      "view": "查看",
      "jsonData": "JSON数据",
      "invalidJson": "JSON格式无效",
      "failedToSave": "保存JSON配置失败",
      "viewContent": "查看当前 JSON",
      "copyJson": "复制 JSON"
    }
  },
  "announceEditor": {
    "title": "公告编辑",
    "confirmDeleteBody": "确定要删除此正文行吗？",
    "emptyLine": "空行",
    "description": "修改通知 JSON，并将变更保存到数据库。",
    "notificationTitleLabel": "通知标题",
    "bodySectionTitle": "内容（Body）",
    "addBodyLine": "添加一行",
    "linksSectionTitle": "链接（LinkList）",
    "addLink": "添加链接",
    "linkTextLabel": "文本",
    "linkTextPlaceholder": "按钮文本",
    "linkUrlLabel": "URL",
    "invalidJson": "JSON 格式无效",
    "saveFailed": "更新通知配置失败",
    "copyFailed": "复制 JSON 失败",
    "loadFailed": "加载通知配置失败"
  },
  "announceEditorDark": {
    "title": "公告编辑（深色模式）",
    "confirmDeleteBody": "确定要删除此正文行吗？",
    "confirmDeleteLink": "确定要删除此链接吗？",
    "emptyLine": "空行",
    "description": "修改深色模式通知 JSON，并将变更保存到数据库。",
    "bodySectionTitle": "内容（Body）",
    "addBodyLine": "添加一行",
    "linksSectionTitle": "链接（LinkList）",
    "addLink": "添加链接",
    "linkTextLabel": "文本",
    "linkTextPlaceholder": "按钮文本",
    "linkUrlLabel": "URL",
    "footerTextLabel": "页脚文本",
    "footerTextPlaceholder": "显示在通知底部的文本",
    "invalidJson": "JSON 格式无效",
    "saveFailed": "更新深色模式通知配置失败",
    "copyFailed": "复制 JSON 失败",
    "loadFailed": "加载深色模式通知配置失败"
  },
  "agents": {
    "title": "代理",
    "tableView": "表格视图",
    "resetAll": "重置所有扣量",
    "usernameExists": "Username '{username}' already exists. Please choose another one.",
    "resetAllConfirm": "确认重置所有代理的扣量设置吗？",
    "noAgentsForStealReset": "未找到可重置的代理。",
    "resetAllSuccess": "已重置 {count} 个代理的扣量设置。",
    "resetAllPartial": "重置完成，但 {total} 个代理中有 {failed} 个失败。",
    "resetAllError": "重置扣量设置失败：{error}",
    "hierarchyView": "层级视图",
    "active": "活跃",
    "number": "编号",
    "stealSettingsSaved": "扣量设置已保存",
    "lock": "锁定",
    "id": "ID",
    "edit": "修改",
    "userId": "用户ID",
    "noStealHistory": "No Steal history",
    "roleAdmin": "管理员",
    "adminId": "管理员ID",
    "description": "描述",
    "type": "类型",
    "reason": "原因",
    "amount": "金额",
    "createdAt": "创建时间",
    "updatedAt": "更新时间",
    "stealStats24h": "24小时扣量统计",
    "stealStatistics": "扣量统计",
    "stealToday": "今日扣量",
    "enterPercentage": "输入扣量百分比 (0-100)",
    "stealOperations": "扣量操作",
    "stealAmount": "扣量金额",
    "stealYesterday": "昨日扣量",
    "stealHistory": "扣量历史",
    "allStealRecords": "所有扣量记录",
    "totalRecords": "总记录数",
    "activateAgent": "代理状态（非活跃为封禁)",
    "inactive": "非活跃",
    "advancedSettings": "暗扣设置(N扣1)",
    "activatehiddendeduction": "开启暗扣",
    "agentname": "代理名称:",
    "deactivate": "停用",
    "activate": "激活",
    "activateSuccess": "{username} 激活成功",
    "deactivateSuccess": "{username} 停用成功",
    "lockhiddendeduction": "锁定暗扣",
    "deductionStartTime": "扣量开始时间(小时数)*",
    "deductionEndTime": "扣量结束时间(小时数)*",
    "hidevipdeduction": "VIP暗扣开关*",
    "perunitdeduction": "单片暗扣开关*",
    "search": "搜索",
    "searchPlaceholder": "按登录ID、用户名或代码搜索...",
    "addAgent": "添加代理",
    "stealSettings": "暗扣设置",
    "stealSettingsDescription": "用于生成需要写入 agent_configs 的配置键值对（config_key/config_value）。 / Generates config key-value pairs for agent_configs.",
    "globalSteal": "全局扣量",
    "configKeyGlobalSteal": "config_key: global_steal，config_value: 0 或 1",
    "configKeyGlobalStealRobit": "config_key: global_steal_robit，config_value: integer (suggest ≥ 0",
    "globalStealRatio": "全局扣量比例",
    "stealStatus": "暗扣状态",
    "stealStatusSubLabel": "开启 / 关闭",
    "stealLock": "锁定扣量",
    "stealRatio": "扣量设置",
    "collapseHierarchy": "收起层级",
    "viewHierarchy": "查看层级",
    "editUser": "编辑用户",
    "addUser": "添加用户",
    "chooseAvatarFile": "选择头像文件",
    "save": "保存",
    "add": "添加",
    "userUpdated": "{username} 已更新",
    "userCreated": "{username} 已创建",
    "userDeleted": "{username} 已删除",
    "unsavedChanges": "表单有未保存的更改。您确定要关闭它吗？",
    "avatar": "头像",
    "username": "用户名",
    "code": "邀请码",
    "financialSettings": "财务设置",
    "loginId": "登录 ID",
    "password": "密码",
    "withdrawPassword": "提现密码",
    "optionId": "游戏渠道",
    "optionIdPlaceholder": "游戏渠道",
    "usernamePlaceholder": "输入用户名",
    "passwordPlaceholder": "输入强密码",
    "newPasswordPlaceholder": "留空保持当前密码",
    "confirmPasswordPlaceholder": "确认密码",
    "commissionRatePlaceholder": "佣金率",
    "StealRatioPlaceholder": "输入扣量数（0-100）",
    "parentCommissionInfo": "上级代理佣金: {commission}%",
    "commissionLimitError": "佣金不能超过 {commission}% (上级代理佣金)",
    "role": "角色",
    "revenue": "收入",
    "estimatedRevenue": "预估收入",
    "withdrawableAmount": "可提现金额",
    "selfRevenue": "自身收入",
    "totalAgentBalance": "代理账户金额总计 ",
    "totalWithdrawn": "代理已提金额总计",
    "filter": {
      "agentId": "代理",
      "agentCode": "代理",
      "loginAccount": "登录账号"
    },
    "withdrawingAmount": "提现中金额",
    "withdrawnAmount": "已提现金额",
    "status": "状态",
    "visitOverview": "访问概览",
    "agentInfo": "代理信息",
    "visits": "访问",
    "conversion": "转化",
    "created": "创建时间",
    "lastActive": "最后活动",
    "actions": "操作",
    "page": "页",
    "of": "共",
    "roleAdmin": "管理员",
    "roleAgent": "代理",
    "results": "结果",
    "resultsPerPage": "每页结果",
    "previousPage": "上一页",
    "nextPage": "下一页",
    "deleteUser": "删除用户",
    "deleteUserConfirm": "您确定要删除 {username} 吗？",
    "confirmDelete": "确认删除",
    "warning": "警告",
    "hasChildren": "代理 {username} 有 {count} 个下级代理。\n\n删除此代理不会删除其下级代理，但它们将不再有直接父级。\n\n您要继续吗？",
    "deleteSuccess": "{username} 已成功删除",
    "deleteError": "删除 {username} 时出错：{error}",
    "updateError": "更新 {username} 时出错：{error}",
    "createError": "创建 {username} 时出错：{error}",
    "usernameExists": "用户名 '{username}' 已存在。请选择另一个。",
    "saveError": "保存时出错：{error}",
    "unknownError": "未知错误",
    "newPassword": "新密码",
    "confirmPassword": "确认密码",
    "commissionRate": "佣金率",
    "cancel": "取消",
    "passwordRequired": "需要确认密码",
    "passwordMismatch": "密码不匹配",
    "notAvailable": "N/A",
    "noAgentsTitle": "暂无代理",
    "noAgentsDescription": "开始添加您的第一个代理来管理团队",
    "noHierarchyAvailable": "无可用层级",
    "noHierarchyDescription": "代理尚未按层级组织",
    "hierarchyTitle": "代理层级",
    "addFirstAgent": "添加第一个代理",
    "commission": {
      "title": "代理佣金",
      "agent": "代理",
      "subAgents": "下级代理",
      "rate": "费率 (%)",
      "total": "总计 (€)",
      "month": "本月 (€)",
      "agents": "代理数量"
    },
    "children": "下级代理",
    "parent": "上级代理",
    "vip": {
      "title": "代理及其VIP计划",
      "totalAgents": "总代理数",
      "totalVipPlans": "总VIP计划",
      "averagePerAgent": "平均/代理",
      "searchPlaceholder": "搜索代理...",
      "empty": "未找到代理",
      "memberSince": "成员自",
      "viewDetails": "查看VIP详情",
      "modalTitle": "{username}的VIP详情",
      "stats": {
        "totalPlans": "总计划",
        "activePlans": "活跃计划",
        "totalSales": "总销售",
        "totalRevenue": "实际收入"
      },
      "plans": "VIP计划",
      "noPlans": "无VIP计划",
      "sales": "销售",
      "errorLoading": "加载代理时出错"
    },
    "impersonate": "以代理身份查看",
    "impersonateSuccess": "新标签页以 {username} 身份打开",
    "impersonateError": "启动模拟失败",
    "usernameRequired": "用户名是必需的",
    "usernameMinLength": "用户名必须至少3个字符",
    "usernameMaxLength": "用户名不能超过64个字符",
    "passwordRequired": "密码是必需的",
    "passwordMinLength": "密码必须至少6个字符",
    "passwordRetraitMinLength": "提现密码必须至少6个字符",
    "commissionRateNumber": "佣金率必须是数字",
    "commissionRateNegative": "佣金率不能为负数",
    "active": "激活"
  },
  "gameManagement": {
    "title": "游戏管理",
    "titlePlaceholder": "输入减免标题",
    "dashboard": "仪表板",
    "adminUser": "管理员用户",
    "administrator": "管理员",
    "history": "游戏历史",
    "catalog": "目录",
    "platforms": "平台",
    "countryMapping": "国家映射",
    "internationalization": "国际化",
    "platformI18n": "平台I18n",
    "catalogTitle": "游戏目录",
    "catalogDescription": "管理和同步您的游戏",
    "searchGame": "搜索游戏...",
    "reducerTitle": "游戏减免",
    "images": "图片",
    "reducerDescription": "管理计划中的游戏减免",
    "addReducer": "添加减免",
    "editReducer": "编辑减免",
    "uploadImages": "上传图片",
    "reductionAmount": "减免金额",
    "time": "时间",
    "createReducer": "创建减免",
    "updateReducer": "更新减免",
    "deleteReducer": "删除减免",
    "deleteReducerConfirm": "确定删除从 {start} 到 {end} 的减免吗？",
    "reducerCreated": "减免创建成功",
    "reducerUpdated": "减免更新成功",
    "reducerDeleted": "减免删除成功",
    "noReducers": "未找到减免",
    "failedToLoadReducers": "加载减免失败",
    "failedToSubmitReducer": "提交减免失败",
    "failedToDeleteReducer": "删除减免失败",
    "fillRequiredFields": "请填写所有必填字段",
    "addGame": "添加游戏",
    "noGamesAvailable": "无可用游戏",
    "startFirstGame": "从创建您的第一个游戏开始",
    "online": "在线",
    "offline": "离线",
    "isRecommended": "推荐",
    "actions": "操作",
    "edit": "编辑",
    "pause": "暂停",
    "activate": "激活",
    "delete": "删除",
    "created": "创建时间",
    "displayName": "显示名称",
    "description": "描述",
    "editTranslation": "编辑翻译",
    "newTranslation": "新翻译",
    "gameCannotBeModified": "游戏创建后无法修改",
    "languageCannotBeModified": "语言创建后无法修改",
    "displayNamePlaceholder": "例: Dragon Fortune",
    "displayNameHint": "将在此语言中显示的名称",
    "descriptionPlaceholder": "例: 一款激动人心的老虎机游戏",
    "descriptionHint": "游戏在此语言中的描述",
    "iconUrl": "图标URL",
    "iconUrlPlaceholder": "https://example.com/icon.png",
    "iconUrlHint": "图标图片的完整URL",
    "translationCreated": "翻译创建成功",
    "translationUpdated": "翻译更新成功",
    "translationDeleted": "翻译删除成功",
    "errorLoadingTranslations": "加载翻译时出错",
    "errorCreatingTranslation": "创建翻译时出错",
    "errorUpdatingTranslation": "更新翻译时出错",
    "errorDeletingTranslation": "删除翻译时出错",
    "confirmDeleteTranslation": "您确定要删除翻译 \"{name}\" 吗？",
    "createGame": "创建新游戏",
    "editGame": "编辑游戏",
    "gameCode": "游戏代码",
    "gameName": "游戏名称",
    "gameType": "游戏类型",
    "provider": "提供商",
    "platform": "平台",
    "rtp": "RTP (%)",
    "minBet": "最小投注",
    "maxBet": "最大投注",
    "imageUrl": "图片URL",
    "gameUrl": "游戏URL",
    "cancel": "取消",
    "save": "保存",
    "update": "更新",
    "create": "创建",
    "saving": "保存中...",
    "confirmDelete": "确认删除",
    "deleteGameConfirm": "您确定要删除游戏 {name} 吗？",
    "irreversibleAction": "此操作不可逆转。",
    "deleting": "删除中...",
    "previous": "← 上一页",
    "next": "下一页 →",
    "page": "页面",
    "gameTypeExample": "SLOT, CASINO...",
    "providerExample": "PG Soft...",
    "minBetExample": "100",
    "codeRequired": "游戏代码是必需的",
    "codeMinLength": "代码必须包含至少3个字符",
    "codeMinLength2": "代码必须包含至少2个字符",
    "codeExists": "代码 \"{code}\" 已存在。请选择其他代码。",
    "codeExistsOther": "其他游戏已使用代码 \"{code}\"",
    "gameCreated": "游戏创建成功",
    "gameUpdated": "游戏更新成功",
    "gameDeleted": "游戏删除成功",
    "gameStatusToggled": "游戏{status}成功",
    "errorLoadingGames": "加载游戏时出错",
    "errorLoadingPlatforms": "加载平台时出错",
    "errorCreatingGame": "创建游戏时出错",
    "errorUpdatingGame": "更新游戏时出错",
    "errorDeletingGame": "删除游戏时出错",
    "errorTogglingStatus": "更改状态时出错",
    "platformCreated": "平台创建成功",
    "platformUpdated": "平台更新成功",
    "platformDeleted": "平台删除成功",
    "platformStatusToggled": "平台{status}成功",
    "platformCodeExists": "其他平台已使用代码 \"{code}\"",
    "confirmDeletePlatform": "您确定要删除 \"{name}\" 吗？",
    "errorCreatingPlatform": "创建平台时出错",
    "errorUpdatingPlatform": "更新平台时出错",
    "errorDeletingPlatform": "删除平台时出错",
    "errorTogglingPlatformStatus": "修改状态时出错",
    "filters": "搜索过滤器",
    "username": "用户名",
    "usernamePlaceholder": "名称或ID",
    "all": "全部",
    "ngPlatform": "NG平台",
    "meisheng": "Meisheng",
    "gameTypeFilter": "游戏类型",
    "slot": "老虎机",
    "casino": "赌场",
    "result": "结果",
    "win": "赢",
    "lose": "输",
    "startDate": "开始日期",
    "endDate": "结束日期",
    "search": "搜索",
    "reset": "重置",
    "exportExcel": "导出Excel",
    "gameHistoryTitle": "游戏历史",
    "total": "总计",
    "wins": "赢",
    "losses": "输",
    "showing": "显示",
    "of": "共",
    "records": "条记录",
    "platformStatus": "平台状态",
    "active": "活跃",
    "inactive": "非活跃",
    "toggleStatus": "切换状态",
    "countryMappingTitle": "国家映射",
    "countryMappingDescription": "管理国家限制和权限",
    "addCountryMapping": "添加国家映射",
    "country": "国家",
    "game": "游戏",
    "restrictionType": "限制类型",
    "allow": "允许",
    "deny": "拒绝",
    "internationalizationTitle": "游戏国际化",
    "internationalizationDescription": "管理游戏翻译和本地化",
    "addTranslation": "添加翻译",
    "language": "语言",
    "translationKey": "翻译键",
    "translationValue": "翻译值",
    "platformI18nTitle": "平台语言配置",
    "platformI18nDescription": "管理平台特定的语言设置",
    "addPlatformLanguage": "添加平台语言",
    "platformLanguage": "平台语言",
    "isDefault": "默认",
    "yes": "是",
    "no": "否",
    "mappingUpdatedSuccess": "映射更新成功",
    "mappingCreatedSuccess": "映射创建成功",
    "mappingDeletedSuccess": "映射删除成功",
    "mappingLoadError": "加载映射时出错",
    "mappingCreationError": "创建映射时出错",
    "mappingUpdateError": "更新映射时出错",
    "mappingDeletionError": "删除映射时出错",
    "mappingStatusError": "修改状态时出错",
    "mappingStatusChanged": "映射{status}",
    "setAsDefault": "设为默认",
    "removedFromDefault": "从默认中移除",
    "noDefaultConfigFound": "未找到默认配置",
    "confirmDeleteMapping": "您确定要删除\"{country}\"的映射吗？",
    "updated": "已更新",
    "platformName": "平台名称",
    "platformCode": "平台代码",
    "configureLanguage": "配置语言",
    "platformLanguageConfig": "平台语言配置",
    "manageLanguageSettings": "管理不同平台的语言设置",
    "platformI18nConfig": "平台I18n配置将在此处实现。",
    "gameInternationalization": "游戏国际化",
    "gameInternationalizationDesc": "管理游戏翻译和按国家/语言的显示。",
    "gameTranslations": "游戏翻译",
    "totalTranslations": "总翻译数",
    "searchTranslation": "搜索...",
    "addNewTranslation": "添加翻译",
    "loadingTranslations": "加载翻译中...",
    "noTranslations": "无翻译",
    "noResults": "无结果",
    "tryAnotherSearch": "尝试其他搜索",
    "addFirstTranslation": "从添加您的第一个游戏翻译开始",
    "addTranslationButton": "添加翻译",
    "misAJour": "已更新",
    "searchPlaceholder": "搜索...",
    "apiBaseUrl": "API基础URL",
    "callbackUrl": "回调URL",
    "apiKey": "API密钥",
    "apiSecret": "API密钥",
    "signKey": "签名密钥",
    "noConfigsFound": "未找到配置"
  },
  "landingPage": {
    "pageTitle": "着陆页请求",
    "user": "用户",
    "createNewRequest": "创建新请求",
    "editRequest": "编辑请求",
    "createDescription": "选择模型并描述您的需求",
    "editDescription": "编辑您的请求详情",
    "editingRequest": "编辑请求 #",
    "cancelEdit": "取消编辑",
    "currentStatus": "当前状态：",
    "createdOn": "创建于：",
    "step1Title": "1. 选择模型",
    "landingPageType": "着陆页类型 *",
    "selectTemplate": "选择模型",
    "step2Title": "2. 项目详情",
    "requestTitle": "标题 *",
    "titlePlaceholder": "例如：我的第一个页面",
    "requestDescription": "描述 *",
    "descriptionPlaceholder": "一个描述",
    "promotionLink": "推广链接（可选）",
    "noPromotionSelected": "未选择推广",
    "url": "URL: ",
    "reset": "重置",
    "cancel": "取消",
    "update": "更新",
    "sendRequest": "发送请求",
    "sending": "发送中...",
    "updating": "更新中...",
    "yourRecentRequests": "您最近的请求",
    "refresh": "刷新",
    "loadingRequests": "加载请求中...",
    "noRequestsYet": "您还没有创建任何请求",
    "id": "ID",
    "title": "标题",
    "template": "模型",
    "promotionUrl": "推广链接",
    "platform": "平台",
    "status": "状态",
    "date": "日期",
    "actions": "操作",
    "locked": "已锁定",
    "page": "第",
    "of": "页，共",
    "confirmDelete": "确认删除",
    "deleteRequest": "确定要删除请求",
    "deleteWarning": "此操作不可撤销。",
    "requestId": "请求ID:",
    "requestTemplate": "模型:",
    "requestStatus": "状态:",
    "delete": "永久删除",
    "deleting": "删除中...",
    "requestCreated": "您的请求已成功记录。管理员验证后您将收到通知。",
    "requestUpdated": "请求更新成功",
    "requestDeleted": "请求删除成功",
    "errorCreating": "创建请求失败",
    "errorUpdating": "更新请求失败",
    "errorDeleting": "删除请求失败",
    "requestExists": "创建失败或您的请求已存在",
    "listRefreshed": "列表已刷新",
    "congratulations": "恭喜！您的请求",
    "requestCompleted": "已验证并现已完成。",
    "multipleCompleted": "个您的请求已验证并现已完成！",
    "requestsUpdated": "个请求已更新",
    "inProduction": "生产中",
    "inReview": "审核中",
    "rejected": "被拒绝",
    "statusChanged": "您的请求",
    "hasBeen": "已",
    "completed": "完成",
    "pending": "等待",
    "collectingRequirements": "需求收集中",
    "modified": "修改",
    "simple": "简单",
    "videoPreview": "视频预览",
    "multiImages": "多图片",
    "pendingStatus": "等待中",
    "inReviewStatus": "审核中",
    "collectingRequirementsStatus": "收集中需求",
    "inProductionStatus": "生产中",
    "completedStatus": "已完成",
    "rejectedStatus": "已拒绝",
    "cancelledStatus": "已取消",
    "validatedStatus": "已验证",
    "notApplicable": "不适用"
  },
  "common": {
    "search": "搜索",
    "clear": "清除",
    "all": "全部",
    "status": "状态",
    "active": "活跃",
    "inactive": "非活跃",
    "actions": "操作",
    "edit": "编辑",
    "delete": "删除",
    "save": "保存",
    "create": "创建",
    "cancel": "取消",
    "close": "关闭",
    "apply": "应用",
    "add": "添加",
    "update": "更新",
    "loading": "加载中",
    "retry": "重试",
    "error": "发生错误",
    "success": "成功",
    "info": "信息",
    "warning": "警告",
    "deleted": "已删除！",
    "confirmDelete": "您确定要删除吗？",
    "yes_delete": "是的，删除！",
    "delete_warning": "此操作无法撤销。",
    "yes": "是",
    "no": "否",
    "activate": "激活",
    "deactivate": "停用",
    "page": "页",
    "of": "共",
    "show": "显示",
    "showing": "显示",
    "select": "选择",
    "platform": "平台",
    "language": "语言",
    "default": "默认",
    "image": "图像",
    "noData": "无可用数据",
    "details": "详情",
    "dates": "日期",
    "createdAt": "创建时间",
    "updatedAt": "更新时间",
    "username": "用户名",
    "role": "角色",
    "code": "代码",
    "refresh": "刷新",
    "copied": "已复制"
  },
  "announcements": {
    "systemTitle": "系统公告",
    "systemSubtitle": "管理和传播您的通信",
    "newAnnouncement": "新公告",
    "editAnnouncement": "编辑公告",
    "totalAnnouncements": "总公告数",
    "active": "活跃",
    "scheduled": "已计划",
    "archived": "已归档",
    "all": "全部",
    "toutes": "全部",
    "searchPlaceholder": "搜索公告...",
    "show": "显示",
    "of": "共",
    "announcements": "个公告",
    "noAnnouncementsFound": "未找到公告",
    "noResultsForSearch": "您的搜索无结果",
    "createFirstAnnouncement": "创建您的第一个公告开始",
    "status": "状态",
    "title": "标题",
    "content": "预览",
    "publishDate": "发布日期",
    "recipients": "收件人",
    "progress": "进度",
    "actions": "操作",
    "scheduledBadge": "已计划",
    "confirmationBadge": "确认",
    "allAgents": "全部",
    "readsCount": "{read}/{total}",
    "activate": "激活",
    "deactivate": "停用",
    "modify": "修改",
    "delete": "删除",
    "confirmAction": "确认操作",
    "confirmActivate": "您确定要激活此公告吗？",
    "confirmDeactivate": "您确定要停用此公告吗？",
    "activated": "已激活",
    "deactivated": "已停用",
    "confirmDelete": "确认删除",
    "irreversibleAction": "此操作不可逆转",
    "deleted": "已删除",
    "form": {
      "titleLabel": "公告标题 *",
      "titlePlaceholder": "例如：重要系统更新",
      "contentLabel": "内容 *",
      "contentPlaceholder": "撰写您的公告...",
      "recipientsLabel": "收件人 *",
      "allAgents": "所有代理",
      "specificAgents": "特定代理",
      "selectAgents": "选择代理",
      "agentsSelected": "已选择 {count} 个代理",
      "forceConfirmation": "强制确认",
      "forceConfirmationDesc": "代理必须点击\"我理解\"才能关闭",
      "publishTimeLabel": "发布时间 *",
      "immediatePublish": "立即发布",
      "scheduledPublish": "计划发布",
      "publishDateLabel": "发布日期 *",
      "dateTimeLabel": "日期和时间",
      "publishNow": "立即发布",
      "schedule": "计划"
    },
    "agentSelector": {
      "title": "选择代理",
      "searchPlaceholder": "按姓名、代码搜索代理...",
      "selectAll": "全选",
      "deselectAll": "取消全选",
      "selectedCount": "已选择 {selected} / {total} 个",
      "noAgentsFound": "未找到代理",
      "confirm": "确认 ({count})"
    },
    "pagination": {
      "showing": "显示",
      "of": "至",
      "announcements": "个公告",
      "page": "页",
      "goToPage": "跳转到页面",
      "go": "前往"
    },
    "messages": {
      "confirmAction": "确认操作",
      "confirmActivate": "您确定要激活此公告吗？",
      "confirmDeactivate": "您确定要停用此公告吗？",
      "confirmDelete": "您确定要删除此公告吗？",
      "published": "已发布！",
      "publishedSuccess": "公告创建成功",
      "activated": "已激活",
      "deactivated": "已停用",
      "deleted": "已删除",
      "success": "成功！",
      "error": "错误",
      "titleRequired": "标题是必需的",
      "contentRequired": "内容是必需的",
      "publishDateRequired": "发布日期是必需的",
      "selectAtLeastOneAgent": "请至少选择一个代理",
      "cannotSave": "无法保存公告",
      "cannotToggleStatus": "无法修改状态",
      "cannotDelete": "无法删除公告",
      "cannotLoadAgents": "无法加载代理列表",
      "cannotLoadAnnouncements": "无法加载公告",
      "announcementActivated": "公告已激活",
      "announcementDeactivated": "公告已停用",
      "announcementDeleted": "公告已删除"
    }
  },
  "vip": {
    "setting": {
      "title": "VIP设置",
      "subtitle": "基于现有VIP计划创建新的VIP计划",
      "createNew": "创建新VIP",
      "editVip": "编辑VIP",
      "editing": "正在编辑",
      "updateButton": "更新",
      "yesdelete": "确认删除",
      "yescancel": "取消",
      "createSuccess": "VIP创建成功",
      "updateSuccess": "VIP更新成功",
      "selectVip": "选择VIP计划 (显示的价格为参考价格，可自行修改）",
      "selectPlaceholder": "选择VIP计划 ",
      "selectedVipDetails": "选中的VIP详情",
      "newPrice": "价格",
      "price": "价格",
      "pricePlaceholder": "例如：价格在最低价和最高价之间",
      "priceHint": "输入此VIP的价格",
      "createButton": "创建VIP",
      "image": "图片",
      "noData": "无可用数据",
      "myCreatedPrices": "我的配置",
      "vipName": "VIP",
      "vipFallback": "VIP #{id}",
      "vipLogoAlt": "VIP 标志",
      "confirmDelete": "您确定吗？",
      "confirmDeleteText": "您真的要删除这个VIP \"{name}\" 吗？",
      "deleteSuccess": "已删除！",
      "deleteSuccessText": "VIP已成功删除。",
      "confirmToggle": "您确定要{action}这个VIP吗？",
      "confirmToggleText": "您即将{action}VIP \"{name}\"",
      "toggleSuccess": "成功！",
      "toggleSuccessText": "VIP已成功{action}。",
      "confirmToggleButton": "是的，{action}！",
      "activateAction": "激活",
      "deactivateAction": "停用",
      "minimumLabel": "最低",
      "maximumLabel": "最高",
      "deleteError": "删除VIP时出错",
      "toggleError": "更改VIP状态时出错",
      "minPriceError": "价格必须至少为 {minPrice}",
      "maxPriceError": "价格必须最多为 {maxPrice}",
      "priceRangeHint": "官方定价",
      "editPriceTitle": "编辑价格",
      "editPriceText": "价格",
      "priceValidation": "请输入大于0的有效价格",
      "updateError": "更新VIP时出错"
    },
    "title": "VIP管理",
    "subtitle": "管理您的用户VIP订阅",
    "add_vip": "购买VIP",
    "search_user_id": "按用户ID搜索...",
    "search_phone": "按手机号搜索...",
    "search_button": "搜索",
    "stats": {
      "active": "活跃VIP",
      "expired": "非活跃VIP",
      "revenue": "总收入"
    },
    "search": "搜索...",
    "filters": {
      "all": "全部",
      "active": "活跃",
      "expired": "已过期"
    },
    "filter": {
      "title": "筛选条件",
      "reset": "重置",
      "seller": "销售员",
      "seller_placeholder": "销售员",
      "agent": "代理",
      "select_option": "请选择",
      "user_id": "用户ID",
      "user_id_placeholder": "",
      "order_type": "订单类型",
      "all": "全部",
      "new": "新购",
      "renewal": "续费",
      "upgrade": "升级",
      "order_number": "订单号",
      "order_number_placeholder": "",
      "payment_status": "支付状态",
      "all_m": "全部",
      "payment_channel": "支付配置",
      "order_period": "下单日期",
      "order_period_placeholder": "",
      "phone": "手机号",
      "phone_placeholder": "",
      "submit": "应用",
      "quick_search": "搜索"
    },
    "table": {
      "user": "用户",
      "phone": "手机号",
      "agent_id": "代理ID",
      "registration_date": "注册日期",
      "product": "产品",
      "price": "价格",
      "payment_status": "支付状态",
      "payment_channel": "支付配置",
      "payment_number": "支付号码",
      "user_id": "用户ID",
      "duration": "时长",
      "purchase_date": "购买日期",
      "expiration": "到期",
      "status": "状态",
      "actions": "操作"
    },
    "status": {
      "active": "活跃",
      "expired": "已过期",
      "inactive": "未激活"
    },
    "common": {
      "days": "天"
    },
    "actions": {
      "edit": "编辑",
      "activate": "激活",
      "deactivate": "停用"
    },
    "modal": {
      "add_title": "购买VIP",
      "edit_title": "编辑VIP",
      "user_label": "用户 *",
      "user_placeholder": "搜索用户...",
      "plan_label": "VIP套餐 *",
      "plan_placeholder": "-- 选择 --",
      "no_users_found": "未找到用户",
      "vip_logo_alt": "VIP 标志",
      "cancel": "取消",
      "save": "购买",
      "update": "更新",
      "confirm_purchase_title": "购买确认",
      "confirm_update_title": "修改确认",
      "confirm_purchase_subtitle": "确认VIP购买",
      "confirm_update_subtitle": "编辑VIP",
      "confirm_purchase_warning": "此操作将从用户钱包中扣除费用。",
      "confirm_update_warning": "此操作将修改此用户的VIP套餐。",
      "confirm_purchase_button": "确认购买",
      "confirm_update_button": "修改"
    },
    "toggle_modal": {
      "title": "修改确认",
      "activate_subtitle": "激活VIP",
      "deactivate_subtitle": "停用VIP",
      "activate_warning": "此操作将为用户激活VIP访问权限。",
      "deactivate_warning": "此操作将为用户停用VIP访问权限。",
      "activate_button": "激活",
      "deactivate_button": "停用"
    },
    "pagination": {
      "showing": "显示第 {start} 到 {end} 条，共 {total} 条VIP",
      "items_per_page": "每页条目:",
      "go_to_page": "跳转到页:",
      "go_button": "跳转",
      "first_page": "首页",
      "prev_page": "上一页",
      "next_page": "下一页",
      "last_page": "末页"
    },
    "empty": "未找到结果",
    "toasts": {
      "success": "成功",
      "error": "错误",
      "purchase_success": "VIP购买成功！",
      "update_success": "VIP修改成功！",
      "activate_success": "VIP激活成功！",
      "deactivate_success": "VIP停用成功！",
      "purchase_error": "购买时出错",
      "update_error": "修改时出错",
      "toggle_error": "修改VIP状态时发生错误。",
      "insufficient_balance": "用户钱包余额不足以购买此VIP。",
      "select_user_plan": "请选择用户和VIP套餐。",
      "select_plan": "请选择VIP套餐。"
    },
    "payment_status": {
      "completed": "已完成",
      "pending": "待处理",
      "failed": "失败",
      "cancelled": "已取消",
      "unknown": "未知"
    },
    "payment_channel": {
      "wallet": "钱包",
      "credit_card": "信用卡",
      "paypal": "PayPal",
      "bank_transfer": "银行转账"
    },
    "plans": {
      "title": "VIP计划管理",
      "subtitle": "管理可用的VIP计划",
      "add": "添加VIP计划",
      "edit": "编辑VIP计划",
      "name": "名称",
      "image": "图片",
      "status": "状态",
      "save": "保存",
      "loading": "加载中...",
      "validDays": "有效天数",
      "price": "价格",
      "basePrice": "基础价格",
      "minPrice": "最低价格",
      "maxPrice": "最高价格",
      "order": "显示顺序",
      "total": "总计",
      "active": "活跃计划",
      "inactive": "非活跃计划",
      "recommended": "推荐",
      "logoUrl": "Logo URL",
      "days": "天",
      "empty": "未找到VIP计划",
      "searchPlaceholder": "按名称搜索...",
      "namePlaceholder": "输入计划名称",
      "validDaysPlaceholder": "输入天数",
      "pricePlaceholder": "输入价格",
      "orderPlaceholder": "输入显示顺序",
      "markRecommended": "标记为推荐",
      "createSuccess": "VIP计划创建成功",
      "updateSuccess": "VIP计划更新成功",
      "deleteSuccess": "VIP计划删除成功",
      "deleteConfirm": "这将删除VIP计划。您确定吗？",
      "statusUpdated": "VIP计划状态已更新",
      "manageTranslations": "管理翻译",
      "translations": "vip计划",
      "description": "描述",
      "descriptionPlaceholder": "输入描述",
      "translationAdded": "翻译添加成功",
      "translationUpdated": "翻译更新成功",
      "translationDeleted": "翻译删除成功",
      "translationRequired": "请至少添加一个翻译",
      "basicInfo": "基本信息",
      "pricing": "定价",
      "originalPrice": "原价",
      "vipItems": "VIP权益",
      "agentSettings": "代理设置",
      "openToAgents": "开放给代理",
      "minAgentPrice": "最低代理价格",
      "maxAgentPrice": "最高代理价格",
      "display": "显示",
      "logo": "标志",
      "logoRequired": "标志图片是必需的",
      "selectExistingLogo": "请选择一个已存在的标志。",
      "invalidFileType": "请选择有效的图像文件",
      "fileTooLarge": "图片不能超过5MB",
      "language": "语言",
      "languagePlaceholder": "fr_FR",
      "shortIntro": "简短介绍",
      "shortIntroPlaceholder": "简短描述",
      "addTranslation": "添加翻译",
      "details": "VIP计划详情",
      "open": "开放",
      "openAgent": "开放代理",
      "agent": "代理",
      "actions": {
        "details": "详情",
        "edit": "编辑",
        "activate": "激活",
        "deactivate": "停用",
        "delete": "删除"
      },
      "notify": {
        "agentPlanReadonly": "管理员不能修改代理所属的VIP计划。",
        "agentPlanReadonlyTooltip": "无权限：代理所属计划"
      },
      "validation": {
        "basePriceGreaterThanMax": "基础价格不能高于最高价格",
        "minPriceGreaterThanBase": "最低价格不能高于基础价格",
        "originalPriceBetweenMinAndMax": "原价必须介于最低价格和最高价格之间"
      },
      "filters": {
        "all": "全部",
        "active": "活跃",
        "inactive": "非活跃"
      }
    },
    "rights": {
      "title": "VIP权限管理",
      "titleField": "标题",
      "chooseFile": "选取文件",
      "noFileSelected": "尚未选择文件",
      "translations": "权限翻译",
      "subtitle": "管理可用的VIP计划",
      "manageTranslations": "管理翻译",
      "logo": "标志",
      "add": "添加VIP权限",
      "orderPlaceholder": "输入显示顺序",
      "codePlaceholder": "例如：笑脸",
      "titlePlaceholder": "输入标题",
      "descriptionPlaceholder": "输入描述",
      "codes": {
        "can_download_resources": "下载资源",
        "can_access_long_free": "长视频免费观看",
        "can_access_short_free": "短视频无限观看",
        "can_access_posts_free": "帖子免费查看",
        "can_access_im_free": "即时通讯免费",
        "can_access_audio_free": "音频免费访问",
        "can_access_manga_free": "漫画免费访问",
        "can_access_novel_free": "小说免费访问",
        "can_watch_long_videos_free": "免费观看长视频",
        "can_watch_short_videos_unlimited": "无限观看短视频",
        "can_view_posts_free": "免费查看帖子",
        "can_use_instant_messaging_free": "免费使用即时通讯",
        "can_access_premium_content_free": "免费访问高级内容"
      },
      "codeDescriptions": {
        "can_download_resources": "允许下载资源（视频、图片等）",
        "can_access_long_free": "授予或拒绝免费观看长视频的权限",
        "can_access_short_free": "授予或拒绝无限观看短视频的权限",
        "can_access_posts_free": "授予或拒绝免费查看帖子内容的权限",
        "can_access_im_free": "授予或拒绝免费使用即时通讯（IM）的权限",
        "can_access_audio_free": "授予或拒绝免费收听音频内容的权限",
        "can_access_manga_free": "授予或拒绝免费阅读漫画的权限",
        "can_access_novel_free": "授予或拒绝免费阅读小说的权限",
        "can_watch_long_videos_free": "授予免费观看长视频的权限",
        "can_watch_short_videos_unlimited": "授予无限时长观看短视频的权限",
        "can_view_posts_free": "授予免费查看帖子内容的权限",
        "can_use_instant_messaging_free": "授予免费使用即时通讯（IM）的权限",
        "can_access_premium_content_free": "授予免费收听音频、阅读漫画及访问其他高级内容的权限"
      },
      "edit": "编辑VIP权限",
      "code": "代码",
      "description": "描述",
      "order": "显示顺序",
      "logoUrl": "Logo URL",
      "total": "总权限",
      "dropzoneText": "拖拽图片或点击上传",
      "configured": "已配置",
      "empty": "未找到VIP权限",
      "searchPlaceholder": "按代码或标题搜索...",
      "deleteConfirm": "这将删除VIP权限。您确定吗？",
      "codeRequired": "代码为必填项",
      "createSuccess": "VIP权限创建成功",
      "updateSuccess": "VIP权限更新成功",
      "deleteSuccess": "VIP权限删除成功",
      "translationAdded": "翻译添加成功",
      "translationUpdated": "翻译更新成功",
      "translationDeleted": "翻译删除成功",
      "updateError": "VIP权限更新失败"
    }
  },
  "domain": {
    "title": "域名管理",
    "stats": {
      "total": "总计",
      "active": "活跃",
      "inactive": "非活跃"
    },
    "search": {
      "label": "搜索",
      "placeholder": "按名称搜索..."
    },
    "filter": {
      "status": "状态",
      "all": "全部"
    },
    "addButton": "添加域名",
    "loading": "加载域名中...",
    "retry": "重试",
    "noDomains": "未找到域名",
    "table": {
      "headers": {
        "id": "ID",
        "domainName": "域名",
        "tag": "标签",
        "platform": "平台",
        "account": "账户",
        "type": "类型",
        "group": "组",
        "state": "状态",
        "province": "省份",
        "status": "状态",
        "expiration": "到期",
        "actions": "操作"
      },
      "actions": {
        "edit": "修改",
        "activate": "激活",
        "deactivate": "停用",
        "delete": "删除"
      },
      "status": {
        "enabled": "已启用",
        "disabled": "已停用"
      }
    },
    "modal": {
      "addTitle": "添加域名",
      "editTitle": "修改域名",
      "fields": {
        "domain": "域名",
        "domainPlaceholder": "例如：https://example.com",
        "tag": "标签",
        "tagPlaceholder": "例如：web, api, video, image",
        "platform": "平台",
        "platformPlaceholder": "例如：AWS, Cloudflare",
        "platformAccount": "平台账户",
        "platformAccountPlaceholder": "例如：aws-prod-001",
        "domainType": "域名类型",
        "domainTypePlaceholder": "选择类型",
        "domainGroup": "域名组",
        "domainGroupPlaceholder": "选择组",
        "province": "省份",
        "provincePlaceholder": "选择省份",
        "expiration": "到期日期",
        "expirationPlaceholder": "例如：2026-12-31T23:59:59Z",
        "status": "状态"
      },
      "buttons": {
        "cancel": "取消",
        "save": "保存",
        "add": "添加"
      }
    },
    "options": {
      "status": {
        "active": "活跃",
        "inactive": "非活跃"
      },
      "domainType": {
        "long": "长",
        "short": "短"
      },
      "domainGroup": {
        "production": "生产",
        "dedicated": "专用",
        "test": "测试"
      }
    },
    "messages": {
      "success": "成功！",
      "error": "错误！",
      "confirmDelete": "您确定吗？",
      "irreversibleAction": "此操作不可逆转！",
      "confirmDeleteButton": "是的，删除",
      "deleted": "已删除！",
      "domainRequired": "域名是必需的",
      "tagRequired": "标签是必需的",
      "tagExists": "此标签已存在。请选择另一个标签。",
      "tagDuplicateNotification": "重复标签",
      "platformRequired": "平台是必需的",
      "domainUpdated": "域名已成功修改",
      "domainCreated": "域名已成功创建",
      "domainDeleted": "域名已成功删除",
      "updateError": "修改时出错",
      "createError": "创建时出错",
      "deleteError": "删除时出错",
      "loadError": "无法加载域名"
    }
  },
  "domainSurveillance": {
    "title": "域名监控",
    "stats": {
      "totalDomains": "总域名",
      "activeDomains": "活跃域名",
      "inactiveDomains": "非活跃域名",
      "checksLast24h": "检查次数（24小时）"
    },
    "filters": {
      "domain": "域名",
      "allDomains": "所有域名",
      "checkType": "检查类型",
      "all": "全部",
      "status": "状态"
    },
    "actions": {
      "refresh": "刷新",
      "triggerCheck": "触发检查"
    },
    "loading": "加载监控日志中...",
    "retry": "重试",
    "noLogs": "未找到监控日志",
    "table": {
      "headers": {
        "id": "ID",
        "domain": "域名",
        "province": "省份",
        "type": "类型",
        "time": "时间",
        "status": "状态",
        "summary": "摘要",
        "duration": "持续时间（毫秒）",
        "actions": "操作"
      },
      "actions": {
        "viewDetails": "查看详情"
      },
      "status": {
        "success": "成功",
        "failed": "失败"
      }
    },
    "checkTypes": {
      "browser": "浏览器",
      "regional_7c": "区域 7c.cc",
      "regional_itdog": "区域 ITDog"
    },
    "modals": {
      "trigger": {
        "title": "触发检查",
        "fields": {
          "domain": "域名",
          "selectDomain": "选择域名",
          "checkType": "检查类型",
          "checkTypePlaceholder": "完整检查"
        },
        "buttons": {
          "cancel": "取消",
          "trigger": "触发"
        },
        "errors": {
          "selectDomainRequired": "请选择域名"
        }
      },
      "details": {
        "title": "监控日志详情",
        "fields": {
          "domain": "域名",
          "checkType": "检查类型",
          "time": "时间",
          "status": "状态",
          "summary": "摘要",
          "duration": "持续时间"
        },
        "jsonDetails": "JSON 详情",
        "close": "关闭"
      }
    },
    "messages": {
      "success": "成功！",
      "error": "错误！",
      "checkTriggered": "检查已成功触发。结果将在几秒钟内显示。",
      "triggerError": "触发时出错",
      "loadError": "无法加载日志",
      "apiCredentialsNote": "注意：后端可能未配置 API 凭据"
    }
  },
  "domainMapping": {
    "title": "短域名映射",
    "search": {
      "label": "搜索",
      "placeholder": "搜索..."
    },
    "addButton": "添加映射",
    "loading": "加载映射中...",
    "retry": "重试",
    "noMappings": "未找到映射",
    "table": {
      "headers": {
        "id": "ID",
        "shortDomain": "短域名",
        "shortStatus": "短域名状态",
        "longDomain": "长域名",
        "longStatus": "长域名状态",
        "creationDate": "创建日期",
        "actions": "操作"
      },
      "actions": {
        "delete": "删除"
      }
    },
    "modal": {
      "addTitle": "添加域名映射",
      "fields": {
        "shortDomain": "短域名",
        "selectShortDomain": "选择短域名",
        "shortDomainNote": "仅显示\"短\"类型的域名",
        "longDomain": "长域名",
        "selectLongDomain": "选择长域名",
        "longDomainNote": "仅显示\"长\"类型的域名"
      },
      "buttons": {
        "cancel": "取消",
        "add": "添加"
      }
    },
    "messages": {
      "success": "成功！",
      "error": "错误！",
      "confirmDelete": "您确定吗？",
      "irreversibleAction": "此操作不可逆转！",
      "confirmDeleteButton": "是的，删除",
      "deleted": "已删除！",
      "mappingCreated": "映射创建成功",
      "mappingDeleted": "映射删除成功",
      "shortDomainRequired": "短域名是必需的",
      "longDomainRequired": "长域名是必需的",
      "createError": "创建时出错",
      "deleteError": "删除时出错",
      "loadError": "无法加载映射",
      "mappingAlreadyExists": "映射已存在"
    }
  },
  "resourceDomainChangeLogs": {
    "title": "资源域名变更日志",
    "subtitle": "资源域名（短）顺序修改历史记录",
    "filters": {
      "startDate": "开始日期",
      "endDate": "结束日期",
      "startDatePlaceholder": "开始日期",
      "endDatePlaceholder": "结束日期"
    },
    "actions": {
      "refresh": "刷新",
      "generateJson": "生成资源JSON",
      "viewCurrentJson": "查看当前JSON",
      "details": "详情"
    },
    "loading": "加载日志中...",
    "noLogs": "未找到变更日志",
    "table": {
      "headers": {
        "id": "ID",
        "date": "日期",
        "operator": "操作员",
        "changes": "变更",
        "mainDomain": "主域名",
        "statistics": "统计",
        "actions": "操作"
      },
      "changes": {
        "topDomainChanged": "🔄 主域名变更",
        "statusChanges": "个状态变更",
        "orderChanges": "个顺序变更"
      },
      "statistics": {
        "total": "总计",
        "normal": "正常",
        "partial": "部分",
        "regionBlock": "区域阻止"
      }
    },
    "modals": {
      "details": {
        "title": "日志详情",
        "generalInfo": "一般信息",
        "fields": {
          "id": "ID",
          "date": "日期",
          "operator": "操作员",
          "reason": "原因"
        },
        "topDomainChange": {
          "title": "🔄 主域名变更",
          "previous": "上一个",
          "current": "当前"
        },
        "statusChanges": {
          "title": "状态变更",
          "headers": {
            "domain": "域名",
            "oldStatus": "旧状态",
            "newStatus": "新状态"
          }
        },
        "orderChanges": {
          "title": "顺序变更",
          "headers": {
            "domain": "域名",
            "oldPosition": "旧位置",
            "newPosition": "新位置"
          }
        },
        "currentJson": {
          "title": "当前JSON",
          "copyJson": "复制JSON"
        }
      },
      "currentJson": {
        "title": "当前资源JSON",
        "publicLink": "公开链接",
        "copyLink": "复制链接",
        "content": "内容",
        "copyJson": "复制JSON"
      }
    },
    "messages": {
      "generateJson": {
        "title": "生成资源JSON？",
        "text": "这将为资源域名生成一个新的JSON文件。",
        "confirmButton": "是的，生成",
        "cancelButton": "取消",
        "success": "成功",
        "successText": "资源JSON生成成功",
        "error": "错误"
      },
      "viewCurrentJson": {
        "noJson": "没有JSON",
        "noJsonText": "未找到资源JSON。请先生成。",
        "error": "错误"
      },
      "copy": {
        "jsonCopied": "JSON已复制到剪贴板",
        "linkCopied": "链接已复制到剪贴板",
        "copyError": "无法复制内容",
        "copyLinkError": "无法复制链接",
        "error": "错误"
      }
    },
    "operator": {
      "system": "系统"
    }
  },
  "apiDomainChangeLogs": {
    "title": "API域名变更日志",
    "subtitle": "API域名（长）顺序修改历史记录",
    "filters": {
      "startDate": "开始日期",
      "endDate": "结束日期",
      "startDatePlaceholder": "开始日期",
      "endDatePlaceholder": "结束日期"
    },
    "actions": {
      "refresh": "刷新",
      "generateJson": "生成API JSON",
      "viewCurrentJson": "查看当前JSON",
      "details": "详情"
    },
    "loading": "加载日志中...",
    "noLogs": "未找到变更日志",
    "table": {
      "headers": {
        "id": "ID",
        "date": "日期",
        "operator": "操作员",
        "changes": "变更",
        "mainDomain": "主域名",
        "statistics": "统计",
        "actions": "操作"
      },
      "changes": {
        "topDomainChanged": "🔄 主域名变更",
        "statusChanges": "个状态变更",
        "orderChanges": "个顺序变更"
      },
      "statistics": {
        "total": "总计",
        "normal": "正常",
        "partial": "部分",
        "regionBlock": "区域阻止"
      }
    },
    "modals": {
      "details": {
        "title": "日志详情",
        "generalInfo": "一般信息",
        "fields": {
          "id": "ID",
          "date": "日期",
          "operator": "操作员",
          "reason": "原因"
        },
        "topDomainChange": {
          "title": "🔄 主域名变更",
          "previous": "上一个",
          "current": "当前"
        },
        "statusChanges": {
          "title": "状态变更",
          "headers": {
            "domain": "域名",
            "oldStatus": "旧状态",
            "newStatus": "新状态"
          }
        },
        "orderChanges": {
          "title": "顺序变更",
          "headers": {
            "domain": "域名",
            "oldPosition": "旧位置",
            "newPosition": "新位置"
          }
        },
        "currentJson": {
          "title": "当前JSON",
          "copyJson": "复制JSON"
        }
      },
      "currentJson": {
        "title": "当前API JSON",
        "publicLink": "公开链接",
        "copyLink": "复制链接",
        "content": "内容",
        "copyJson": "复制JSON"
      }
    },
    "messages": {
      "generateJson": {
        "title": "生成API JSON？",
        "text": "这将为API域名生成一个新的JSON文件。",
        "confirmButton": "是的，生成",
        "cancelButton": "取消",
        "success": "成功",
        "successText": "API JSON生成成功",
        "error": "错误"
      },
      "viewCurrentJson": {
        "noJson": "没有JSON",
        "noJsonText": "未找到API JSON。请先生成。",
        "error": "错误"
      },
      "copy": {
        "jsonCopied": "JSON已复制到剪贴板",
        "linkCopied": "链接已复制到剪贴板",
        "copyError": "无法复制内容",
        "copyLinkError": "无法复制链接",
        "error": "错误"
      }
    },
    "operator": {
      "system": "系统"
    }
  },
  "failoverLogs": {
    "title": "自动切换日志",
    "filters": {
      "failedDomain": "故障域名",
      "startDate": "开始日期",
      "endDate": "结束日期",
      "allDomains": "所有域名",
      "startDatePlaceholder": "开始日期",
      "endDatePlaceholder": "结束日期"
    },
    "actions": {
      "refresh": "刷新",
      "updateUrlsJson": "更新URLs JSON",
      "viewUrlsJson": "查看URLs JSON",
      "testFailover": "测试切换",
      "retry": "重试",
      "previous": "上一页",
      "next": "下一页",
      "viewDetails": "查看详情",
      "close": "关闭",
      "cancel": "取消",
      "test": "测试"
    },
    "loading": "加载切换日志中...",
    "noLogs": "未找到切换日志。",
    "table": {
      "headers": {
        "id": "ID",
        "failedDomain": "故障域名",
        "replacementDomain": "替换域名",
        "province": "省份",
        "operator": "操作员",
        "date": "日期",
        "actions": "操作"
      },
      "tag": "标签"
    },
    "pagination": {
      "pageOf": "第 {current} 页，共 {total} 页 ({results} 个结果)"
    },
    "modals": {
      "testFailover": {
        "title": "测试自动切换",
        "failedDomain": "故障域名",
        "selectDomain": "选择域名",
        "operator": "操作员（可选）",
        "operatorPlaceholder": "例如: admin、系统等",
        "autoFindReplacement": "系统将自动找到活跃的替换域名",
        "selectFailedDomain": "请选择故障域名",
        "success": {
          "title": "成功！",
          "replacementFound": "找到的替换域名："
        },
        "error": "切换测试错误"
      },
      "details": {
        "title": "切换详情",
        "failedDomain": "故障域名",
        "replacementDomain": "替换域名",
        "failoverReason": "切换原因",
        "operator": "操作员",
        "date": "日期",
        "metadata": "元数据"
      }
    },
    "messages": {
      "updateUrlsJson": {
        "title": "更新URLs JSON ?",
        "text": "这将生成并上传一个新的urls.json文件到R2, 包含所有活跃的API域名。",
        "confirmButton": "是的，更新",
        "success": {
          "title": "成功！",
          "updated": "URLs JSON更新成功! ",
          "domainsCount": "域名数量：",
          "url": "URL: "
        },
        "error": "更新错误"
      },
      "viewUrlsJson": {
        "noFile": "没有文件",
        "noFileText": "在R2中未找到urls.json文件。请先更新。",
        "current": "当前URLs JSON",
        "version": "版本：",
        "updated": "更新：",
        "domains": "域名：",
        "error": "检索错误"
      },
      "loadError": "无法加载切换日志",
      "domainsLoadError": "加载域名时出错：",
      "logsLoadError": "加载日志时出错："
    },
    "operator": {
      "system": "系统"
    },
    "no": "否",
    "notConfigured": "未配置",
    "lastModification": "最后修改",
    "by": "由",
    "page": "第",
    "of": "页，共",
    "show": "显示"
  },
  "gestionLandingPage": {
    "pageTitle": "着陆页请求",
    "status": "状态",
    "agent": "代理",
    "all": "全部",
    "searchPlaceholder": "按标题搜索...",
    "details": "详情",
    "edit": "编辑",
    "delete": "删除",
    "template": "模板",
    "createdOn": "创建于:",
    "modifiedOn": "修改于:",
    "description": "描述",
    "noDescription": "无描述",
    "validate": "验证",
    "reject": "拒绝",
    "close": "关闭",
    "editRequest": "编辑请求 #",
    "title": "标题",
    "titleRequired": "标题是必需的",
    "descriptionRequired": "描述是必需的",
    "titlePlaceholder": "请求标题",
    "descriptionPlaceholder": "详细描述",
    "templateRequired": "模板是必需的",
    "simple": "简单",
    "videoPreview": "视频预览",
    "multiImages": "多图",
    "save": "保存",
    "cancel": "取消",
    "saving": "保存中...",
    "page": "第",
    "of": "页，共",
    "total": "总计",
    "pending": "待处理",
    "validated": "已验证",
    "rejected": "已拒绝",
    "noRequestsFound": "未找到请求",
    "requestDeleted": "请求删除成功",
    "requestUpdated": "请求更新成功",
    "requestValidated": "请求验证成功",
    "requestRejected": "请求拒绝成功",
    "inReview": "审核中",
    "collectingRequirements": "收集需求",
    "inProduction": "生产中",
    "completed": "已完成",
    "deleted": "已删除",
    "cancelled": "已取消",
    "unknownUser": "未知用户",
    "confirmDelete": "您确定要删除此请求吗？",
    "deleteConfirm": "删除此请求？",
    "setToPending": "设置为待处理",
    "setToReview": "设置为审核中",
    "setToProduction": "设置为生产中",
    "setToCompleted": "设置为已完成",
    "stats": {
      "total": "总计",
      "pending": "待处理",
      "validated": "已验证",
      "rejected": "已拒绝"
    },
    "notifications": {
      "requestStatusUpdated": "请求{status}成功",
      "fillRequiredFields": "请填写所有必填字段",
      "requestUpdated": "请求更新成功",
      "rejectConfirm": "拒绝请求\"{title}\"? ",
      "updateRequestError": "无法更新请求",
      "requestSubmitted": "您的请求已成功提交。管理员验证后您将收到通知。",
      "requestCompleted": "恭喜！您的请求\"{title}\"已验证并完成。",
      "multipleRequestsCompleted": "{count}个请求已验证并完成！",
      "requestCreationError": "创建时出错或请求已存在",
      "requestUpdateSuccess": "请求更新成功",
      "requestDeleteSuccess": "请求删除成功",
      "requestDeleteError": "删除时出错",
      "listRefreshed": "列表已刷新",
      "createRequestError": "无法创建请求",
      "deleteRequestError": "无法删除请求"
    },
    "templates": {
      "simple": "简单",
      "videoPreview": "视频预览",
      "multiImages": "多图片"
    },
    "statusLabels": {
      "pending": "待处理",
      "in_review": "审核中",
      "collecting_requirements": "收集需求",
      "in_production": "生产中",
      "completed": "已完成",
      "rejected": "已拒绝",
      "cancelled": "已取消",
      "validated": "已验证"
    }
  },
  "mangas": {
    "mangas": "漫画",
    "titles": "标题",
    "chapters": "章节",
    "episodes": "剧集",
    "categories": "分类",
    "subcategories": "子分类",
    "tags": "标签",
    "tagCategories": "标签分类",
    "images": "图片"
  },
  "mangasList": {
    "management": "漫画管理",
    "editManga": "编辑漫画",
    "addNewManga": "添加新漫画",
    "reference": "引用",
    "referencePlaceholder": "输入唯一引用 (例如: one-piece)",
    "referenceRequired": "引用是必需的",
    "referenceExists": "具有此引用的漫画已存在",
    "confirmDelete": "确认删除",
    "userId": "用户ID",
    "userIdPlaceholder": "输入用户ID",
    "userIdRequired": "用户ID是必需的",
    "userNotFound": "未找到用户",
    "mangaId": "漫画ID",
    "title": "标题",
    "titlePlaceholder": "输入漫画标题",
    "titleRequired": "标题是必需的",
    "description": "描述",
    "deleteConfirmMessage": "确定要删除吗？此操作无法撤销。",
    "descriptionPlaceholder": "输入漫画描述",
    "descriptionRequired": "描述是必需的",
    "totalChapters": "总章节数",
    "totalChaptersPlaceholder": "1200",
    "totalChaptersRequired": "总章节数是必需的",
    "totalChaptersNegative": "总章节数不能为负数",
    "checkingStatus": "检查状态",
    "checkingStatusRequired": "检查状态是必需的",
    "processingStatus": "处理状态",
    "coverUrl": "封面URL",
    "coverUrlPlaceholder": "https://example.com/cover.jpg",
    "coverUploadStatus": "封面上传状态",
    "coverUploadStatusPlaceholder": "0或1",
    "coverUploadStatusRequired": "封面上传状态是必需的",
    "uploadNegative": "上传不能为负数",
    "localCoverPath": "本地封面路径",
    "localCoverPathPlaceholder": "/tmp/one-piece.jpg",
    "hash": "哈希",
    "hashPlaceholder": "a94a8fe5ccb19ba61c4c0873d391e987",
    "searchPlaceholder": "搜索漫画...",
    "addManga": "添加漫画",
    "noMangasFound": "未找到漫画",
    "createFirstManga": "创建第一个漫画",
    "ref": "引用",
    "chapters": "章节",
    "checking": "检查",
    "processing": "处理",
    "createdAt": "创建时间",
    "waitingForChecking": "等待检查",
    "checked": "已检查",
    "refused": "已拒绝",
    "null": "空",
    "working": "工作中",
    "done": "完成",
    "loadError": "加载漫画失败",
    "fillRequiredFields": "请填写所有必填字段",
    "saveError": "保存漫画失败",
    "deleteConfirm": "确定吗？",
    "deleteError": "删除漫画失败"
  },
  "mangaTitles": {
    "management": "漫画标题管理",
    "editTitle": "编辑标题",
    "addNewTitle": "添加新标题",
    "title": "标题",
    "titlePlaceholder": "输入标题",
    "titleRequired": "标题是必需的",
    "description": "描述",
    "descriptionPlaceholder": "输入描述",
    "descriptionRequired": "描述是必需的",
    "mangaId": "漫画ID",
    "mangaIdRequired": "漫画ID是必需的",
    "mangaIdMin": "漫画ID必须 >= 1",
    "language": "语言",
    "languageRequired": "语言是必需的",
    "searchPlaceholder": "搜索标题...",
    "addTitle": "添加标题",
    "noTitlesFound": "未找到标题",
    "createFirstTitle": "创建第一个标题",
    "createdAt": "创建时间",
    "confirmDelete": "确认删除",
    "deleteConfirmMessage": "您确定要删除此标题吗？",
    "french": "法语",
    "english": "英语",
    "spanish": "西班牙语",
    "german": "德语",
    "italian": "意大利语",
    "portuguese": "葡萄牙语",
    "japanese": "日语",
    "chinese": "中文",
    "loadError": "加载标题失败",
    "fillRequiredFields": "请填写所有必填字段",
    "saveError": "保存标题失败",
    "deleteError": "删除标题失败",
    "deleteConfirm": "确定吗？"
  },
  "deleteModal": {
    "confirmDelete": "确认删除",
    "deleteConfirmMessage": "您确定要删除此项目吗？"
  },
  "mangaChapters": {
    "management": "漫画章节管理",
    "editChapter": "编辑章节",
    "addNewChapter": "添加新章节",
    "chapterTitle": "章节标题",
    "titleRequired": "标题是必需的",
    "chapterNumber": "章节号",
    "chapterNumberRequired": "章节号是必需的",
    "chapterNumberNegative": "章节号不能为负数",
    "mangaIdRequired": "漫画ID是必需的",
    "mangaIdNegative": "漫画ID不能为负数",
    "pagesRequired": "页数是必需的",
    "pagesNegative": "页数不能为负数",
    "searchPlaceholder": "搜索章节...",
    "addChapter": "添加章节",
    "noChaptersFound": "未找到章节",
    "title": "标题",
    "description": "描述",
    "number": "号",
    "mangaId": "漫画ID",
    "pages": "页数",
    "confirmDelete": "确认删除",
    "deleteConfirmMessage": "您确定要删除此章节吗？",
    "validationRequired": "标题、章节号和漫画ID是必需的",
    "duplicateNumberError": "相同章节号的章节已存在于此漫画",
    "duplicateTitleError": "相同标题的章节已存在于此漫画",
    "loadError": "加载章节失败",
    "saveError": "保存章节失败",
    "deleteError": "删除章节失败"
  },
  "mangaEpisodes": {
    "management": "漫画剧集管理",
    "editEpisode": "编辑剧集",
    "addNewEpisode": "添加新剧集",
    "episodeName": "剧集名称",
    "episodeNamePlaceholder": "例如: 第1集 - 开始",
    "nameRequired": "名称是必需的",
    "episodeNumber": "剧集编号",
    "episodeNumberPlaceholder": "1",
    "episodeNumberRequired": "剧集编号是必需的",
    "episodeNumberNegative": "剧集编号不能为负数",
    "chapterId": "章节ID",
    "chapterIdRequired": "章节ID是必需的",
    "chapterIdNegative": "章节ID不能为负数",
    "description": "描述",
    "descriptionPlaceholder": "输入描述",
    "descriptionRequired": "描述是必需的",
    "duration": "时长",
    "durationPlaceholder": "例如: 10分钟或600",
    "durationRequired": "时长是必需的",
    "durationNegative": "时长不能为负数",
    "quality": "质量",
    "qualityPlaceholder": "例如：高清",
    "qualityRequired": "质量是必需的",
    "searchPlaceholder": "搜索剧集...",
    "addEpisode": "添加剧集",
    "noEpisodesFound": "未找到剧集",
    "createFirstEpisode": "创建第一个剧集",
    "number": "编号",
    "images": "图片",
    "createdAt": "创建时间",
    "confirmDelete": "确认删除",
    "deleteConfirmMessage": "您确定要删除此剧集吗？",
    "fillRequiredFields": "请正确填写所有必填字段",
    "loadError": "加载剧集失败",
    "saveError": "保存剧集失败",
    "deleteError": "删除剧集失败"
  },
  "mangaCategories": {
    "management": "漫画分类管理",
    "editCategory": "编辑分类",
    "addNewCategory": "添加新分类",
    "name": "名称",
    "namePlaceholder": "输入分类名称",
    "nameRequired": "名称是必需的",
    "description": "描述",
    "descriptionPlaceholder": "输入描述",
    "descriptionRequired": "描述是必需的",
    "searchPlaceholder": "搜索分类...",
    "addCategory": "添加分类",
    "noCategoriesFound": "未找到分类",
    "createFirstCategory": "创建第一个分类",
    "createdAt": "创建时间",
    "confirmDelete": "确认删除",
    "deleteConfirmMessage": "您确定要删除此分类吗？",
    "fillRequiredFields": "请填写所有必填字段",
    "loadError": "加载分类失败",
    "saveError": "保存分类失败",
    "deleteError": "删除分类失败"
  },
  "mangaSubCategories": {
    "management": "漫画子分类管理",
    "editSubCategory": "编辑子分类",
    "addNewSubCategory": "添加新子分类",
    "name": "名称",
    "namePlaceholder": "输入子分类名称",
    "nameRequired": "名称是必需的",
    "categoryId": "分类ID",
    "categoryIdRequired": "分类ID是必需的",
    "categoryIdNegative": "分类ID不能为负数",
    "categoryIdValidation": "分类ID必须提供且不能为负数",
    "description": "描述",
    "descriptionPlaceholder": "输入描述",
    "descriptionRequired": "描述是必需的",
    "searchPlaceholder": "搜索子分类...",
    "addSubCategory": "添加子分类",
    "noSubCategoriesFound": "未找到子分类",
    "createFirstSubCategory": "创建第一个子分类",
    "category": "分类",
    "createdAt": "创建时间",
    "confirmDelete": "确认删除",
    "deleteConfirmMessage": "您确定要删除此子分类吗？",
    "deleteConfirm": "您确定吗？",
    "fillRequiredFields": "请填写所有必填字段",
    "loadError": "加载子分类失败",
    "saveError": "保存子分类失败",
    "deleteError": "删除子分类失败"
  },
  "mangaTags": {
    "management": "漫画标签管理",
    "editTag": "编辑标签",
    "addNewTag": "添加新标签",
    "userId": "用户ID",
    "userIdPlaceholder": "输入用户ID",
    "userIdRequired": "用户ID是必需的",
    "userNotFound": "未找到用户",
    "mangaId": "漫画ID",
    "mangaIdPlaceholder": "输入漫画ID",
    "mangaIdRequired": "漫画ID是必需的",
    "tagCategoryId": "标签分类ID",
    "tagCategoryIdPlaceholder": "输入标签分类ID",
    "tagCategoryIdRequired": "标签分类ID是必需的",
    "searchPlaceholder": "搜索标签...",
    "addTag": "添加标签",
    "noTagsFound": "未找到标签",
    "createFirstTag": "创建第一个标签",
    "confirmDelete": "确认删除",
    "deleteConfirmMessage": "您确定要删除此标签吗？",
    "fillRequiredFields": "请填写所有必填字段",
    "loadError": "加载标签失败",
    "saveError": "保存标签失败",
    "deleteError": "删除标签失败"
  },
  "mangaTagCategories": {
    "management": "漫画标签分类管理",
    "editTagCategory": "编辑标签分类",
    "addNewTagCategory": "添加新标签分类",
    "name": "名称",
    "namePlaceholder": "输入分类名称",
    "nameRequired": "名称是必需的",
    "color": "颜色",
    "colorPlaceholder": "选择颜色",
    "colorRequired": "颜色是必需的",
    "searchPlaceholder": "搜索标签分类...",
    "addTagCategory": "添加标签分类",
    "noTagCategoriesFound": "未找到标签分类",
    "createFirstTagCategory": "创建第一个标签分类",
    "createdAt": "创建时间",
    "confirmDelete": "确认删除",
    "deleteConfirmMessage": "您确定要删除此标签分类吗？",
    "deleteConfirm": "您确定吗？",
    "fillRequiredFields": "请填写所有必填字段",
    "loadError": "加载标签分类失败",
    "saveError": "保存标签分类失败",
    "deleteError": "删除标签分类失败"
  },
  "mangaImages": {
    "management": "漫画图片管理",
    "editImage": "编辑图片",
    "addNewImage": "添加新图片",
    "episodeId": "章节ID",
    "episodeIdRequired": "章节ID是必需的",
    "episodeIdMinValidation": "章节ID必须 >= 1",
    "image": "图片",
    "acceptedFormats": "接受的格式: JPG, PNG, GIF, WebP (最大5MB)",
    "imageUrlAlternative": "图片URL (替代)",
    "imageUrlPlaceholder": "https://example.com/image.jpg",
    "searchPlaceholder": "按章节ID搜索...",
    "addImage": "添加图片",
    "noImagesFound": "未找到图片",
    "addFirstImage": "添加第一张图片",
    "imagePreview": "图片预览",
    "status": "状态",
    "createdAt": "创建时间",
    "actions": "操作",
    "uploaded": "已上传",
    "pending": "待处理",
    "confirmDelete": "确认删除",
    "deleteConfirmMessage": "您确定要删除此图片吗？",
    "fileOrUrlRequired": "请选择文件或提供图片URL",
    "loadError": "加载图片失败",
    "saveError": "保存图片失败",
    "deleteError": "删除图片失败"
  },
  "promotionPage": {
    "summaryAll": "\u6240\u6709",
    "summaryActive": "\u542f\u7528",
    "summaryInactive": "\u7981\u7528",
    "entrance": "入口",
    "description": "描述",
    "selectDomainType": "选择域名类型",
    "copied": "已复制",
    "filterConditions": "\u7b5b\u9009\u6761\u4ef6",
    "resetFilters": "\u91cd\u7f6e",
    "statusAll": "\u5168\u90e8",
    "confirmFilters": "\u786e\u5b9a",
    "activeFilters": "\u6fc0\u6d3b\u7b5b\u9009\u6761\u4ef6",
    "statusTag": "\u72b6\u6001",
    "platformTag": "\u5e73\u53f0",
    "domainTypeTag": "\u7c7b\u578b",
    "domainType": "\u57df\u540d\u7c7b\u578b",
    "isUsed": "\u5df2\u4f7f\u7528",
    "domainTypeAll": "\u5168\u90e8\u7c7b\u578b",
    "short": "\u77ed\u57df\u540d",
    "long": "\u843d\u5730\u57df\u540d",
    "searchPlaceholder": "\u641c\u7d22...",
    "domainColumn": "\u57df\u540d",
    "onlineColumn": "\u4e0a\u7ebf",
    "generalColumn": "\u901a\u7528",
    "domainTypeColumn": "\u57df\u540d\u7c7b\u578b",
    "platformColumn": "\u5e73\u53f0",
    "createdAtColumn": "\u521b\u5efa\u65f6\u95f4",
    "visitsColumn": "\u8bbf\u95ee\u91cf",
    "noDataFound": "\u6682\u65e0\u6570\u636e",
    "title": "多语言推广",
    "delete": "删除",
    "deleteSuccess": "删除成功",
    "allPlatform": "所有平台",
    "promotionLink": "推广链接",
    "noLinkAvailable": "无可用链接",
    "promotionPlatform": "推广平台添加",
    "createDomainPromotion": "创建域名推广",
    "copyLink": "复制链接",
    "copiedSuccessfully": "✓ 复制成功！",
    "createPromotion": "创建推广",
    "codeQR": "二维码",
    "selectPlatform": "选择平台",
    "promotionList": "推广列表",
    "id": "ID",
    "platform": "平台",
    "link": "链接",
    "status": "状态",
    "actions": "操作",
    "enable": "启用",
    "disable": "禁用",
    "toggleError": "无法更改推广状态",
    "markUsed": "标记为已使用",
    "unmarkUsed": "取消已使用标记",
    "toggleUsedError": "无法更改已使用状态",
    "copyUrl": "复制链接",
    "confirmDelete": "您确定要删除此推广吗？",
    "deleteError": "删除时出错"
  },
  "domainPromotion": {
    "title": "创建域名推广",
    "domainSection": "域名信息",
    "domain": "域名",
    "descriptionPlaceholder": "请输入描述",
    "domainPlaceholder": "例如：api5.example.com",
    "tag": "标签",
    "tagPlaceholder": "例如：web",
    "platform": "平台",
    "platformPlaceholder": "例如：AWS",
    "platformAccount": "平台账户",
    "platformAccountPlaceholder": "例如：aws-prod-001",
    "domainType": "域名类型",
    "selectDomainType": "选择域名类型",
    "short": "短域名",
    "long": "落地域名",
    "domainGroup": "域名分组",
    "selectDomainGroup": "选择域名分组",
    "production": "生产",
    "dedicated": "专属",
    "test": "测试",
    "province": "省份",
    "provincePlaceholder": "例如：北京",
    "expireAt": "过期时间",
    "active": "活跃",
    "inactive": "非活跃",
    "promotionLinkSection": "推广链接",
    "promotionPlatform": "平台",
    "selectPlatform": "选择平台",
    "enable": "启用",
    "disable": "禁用",
    "domainRequired": "域名是必填项",
    "platformRequired": "平台是必填项",
    "createSuccess": "域名推广创建成功",
    "createError": "创建推广失败",
    "save": "\u4fdd\u5b58",
    "saveAndCreate": "\u4fdd\u5b58\u5e76\u521b\u5efa"
  },
  "createPromotion": {
    "title": "创建推广",
    "backToPromotions": "返回推广",
    "promotionDetails": "推广详情",
    "loadingData": "加载数据中...",
    "domain": "域名",
    "platform": "平台",
    "required": "必填",
    "selectDomain": "选择域名",
    "selectPlatform": "选择平台",
    "noDomainsAvailable": "无可用域名。请先创建域名。",
    "noPlatformsAvailable": "无可用平台。请先创建平台。",
    "publishingOptions": "发布选项",
    "create": "创建推广",
    "creating": "创建中...",
    "cancel": "取消",
    "fillRequiredFields": "请填写所有必填字段",
    "loginAgain": "请重新登录",
    "failedToLoadData": "加载数据失败",
    "noPermission": "您没有权限创建推广",
    "contactAdmin": "联系管理员以获取访问权限。",
    "creationFailed": "创建失败"
  },
  "promotionLink": {
    "title": "推广链接",
    "description": "所有推广链接",
    "totalLinks": "总链接数",
    "activeLinks": "活跃链接",
    "users": "用户",
    "platforms": "平台",
    "loading": "加载推广链接中...",
    "retry": "重试",
    "noLinksFound": "未找到推广链接",
    "noLinksDescription": "尚未创建推广链接",
    "createFirstLink": "创建第一个链接",
    "id": "ID",
    "promotionUrl": "推广链接",
    "user": "用户",
    "platform": "平台",
    "domain": "域名",
    "created": "创建时间",
    "actions": "操作",
    "copyUrl": "复制链接",
    "qrCode": "二维码",
    "active": "活跃",
    "inactive": "非活跃",
    "enable": "启用",
    "disable": "禁用",
    "delete": "删除",
    "showing": "显示",
    "of": "共",
    "links": "链接",
    "editLink": "编辑推广链接",
    "createNewLink": "创建新推广链接",
    "platformRequired": "平台",
    "domainRequired": "域名",
    "status": "状态",
    "selectPlatform": "选择平台",
    "selectDomain": "选择域名",
    "selected": "已选择",
    "preview": "预览",
    "promotionUrlLabel": "推广链接:",
    "cancel": "取消",
    "saving": "保存中...",
    "update": "更新",
    "create": "创建",
    "qrCodeTitle": "二维码",
    "noPromotionUrl": "此链接没有可用的推广URL",
    "copyUrlSuccess": "推广URL已复制到剪贴板 !",
    "noUrlToCopy": "没有推广URL可复制",
    "confirmEnable": "您确定要启用此链接吗？",
    "confirmDisable": "您确定要禁用此链接吗？",
    "confirmDelete": "您确定要删除此推广链接吗？此操作无法撤销。",
    "linkEnabled": "链接已成功启用！",
    "linkDisabled": "链接已成功禁用！",
    "linkCreated": "推广链接创建成功！",
    "linkUpdated": "推广链接更新成功！",
    "linkDeleted": "推广链接删除成功！",
    "failedToCreate": "创建推广链接失败",
    "failedToUpdate": "更新推广链接失败",
    "failedToDelete": "删除推广链接失败",
    "failedToUpdateStatus": "更新状态失败",
    "linkAlreadyExists": "具有这些参数的推广链接已存在",
    "fillRequiredFields": "请填写以下必填字段",
    "failedToLoadData": "加载数据失败"
  },
  "promotionPlatform": {
    "title": "推广平台",
    "subtitle": "管理您的推广平台及其详细信息",
    "addPlatform": "添加平台",
    "totalPlatforms": "总平台数",
    "active": "活跃",
    "platformsList": "平台列表",
    "platform": "平台",
    "description": "描述",
    "actions": "操作",
    "edit": "编辑",
    "delete": "删除",
    "noPlatformsFound": "未找到平台",
    "addFirstPlatform": "添加您的第一个平台以开始",
    "addNewPlatform": "添加新平台",
    "editPlatform": "编辑平台",
    "platformName": "平台名称",
    "platformNamePlaceholder": "输入平台名称",
    "nameRequired": "名称是必填项",
    "descriptionOptional": "描述（可选）",
    "descriptionPlaceholder": "输入平台描述",
    "cancel": "取消",
    "createPlatform": "创建平台",
    "saveChanges": "保存更改",
    "noDescriptionProvided": "未提供描述",
    "confirmDelete": "您确定要删除此平台吗？",
    "confirmDeleteWithName": "您确定要删除 \"{name}\" 吗？",
    "nameIsRequired": "名称是必填项",
    "saveFailed": "保存失败",
    "loadingError": "加载错误"
  },
  "promotionTracking": {
    "title": "广告参数对接 ",
    "subtitle": "为当前账号配置 Binom、MaxConv 等转化回调，不影响旧推广链接配置。",
    "addBinding": "新增绑定",
    "platforms": "系统平台映射",
    "platformsHint": "这里只展示平台说明和官方文档；如果你的入口参数名与默认值不同，可在绑定里通过入口参数覆盖 JSON 调整。",
    "noPlatforms": "暂无平台数据",
    "bindings": "我的对接绑定",
    "bindingsHint": "每个账号只能绑定一个推广平台，如需切换平台或回调地址，请编辑现有绑定。",
    "noBindings": "暂未创建绑定",
    "logs": "最近回调日志",
    "logsHint": "这里只显示当前账号的最近回调结果。",
    "noLogs": "暂无回调日志",
    "platform": "平台",
    "owner": "归属账号",
    "callbackUrl": "回调 URL",
    "displayName": "显示名称",
    "overrideJson": "入口参数覆盖 JSON",
    "status": "状态",
    "actions": "操作",
    "edit": "编辑",
    "delete": "删除",
    "enable": "启用",
    "disable": "停用",
    "enabled": "已启用",
    "disabled": "已停用",
    "createdAt": "创建时间",
    "orderNo": "订单号",
    "userId": "用户 ID",
    "detail": "详情",
    "docs": "查看文档",
    "readonlyMapping": "平台说明",
    "captureRule": "默认采集",
    "callbackRule": "默认回调",
    "note": "说明",
    "noOverride": "未覆盖",
    "enableLabel": "启用该绑定",
    "createTitle": "新增推广平台对接",
    "editTitle": "编辑推广平台对接",
    "save": "保存",
    "cancel": "取消",
    "saveSuccess": "保存成功",
    "deleteSuccess": "删除成功",
    "toggleSuccess": "状态已更新",
    "saveFailed": "保存失败",
    "loadFailed": "加载失败",
    "refresh": "刷新",
    "filterAccount": "筛选账号",
    "allAccounts": "全部账号",
    "invalidJson": "入口参数覆盖 JSON 格式不正确",
    "formInvalid": "请先补全平台、显示名称和回调 URL",
    "ownerRequired": "请选择归属账号",
    "platformRequired": "请选择平台",
    "displayNameRequired": "请输入显示名称",
    "callbackUrlRequired": "请输入回调 URL",
    "overridePlaceholder": "示例：\nclick_id: sub1, clickid\ngclid: gclid",
    "deleteConfirm": "确定删除绑定 {name} 吗？",
    "platformDetails": {
      "binom": {
        "capture": "默认从用户首次进入时保存的 query 参数里读取 clickid 作为 click_id。",
        "callback": "支付成功后回调 cnv_id、payout、cnv_currency，并固定发送 cnv_status=sale。",
        "note": "如果你的 Binom 落地参数名不是 clickid，可以在绑定里用入口参数覆盖 JSON 改成 sub1 等自定义字段。"
      },
      "maxconv": {
        "capture": "默认优先读取 mclid，同时兼容 gclid。",
        "callback": "支付成功后回调 clid 或 gclid、payout、currency、txid、timestamp，以及可用的用户标识信息。",
        "note": "如果你的落地参数名不是 mclid 或 gclid，可以在绑定里用入口参数覆盖 JSON 指定候选字段。"
      },
      "default": {
        "capture": "按系统内置规则读取用户首次访问时保存的参数。",
        "callback": "按系统内置规则拼装转化回调参数。",
        "note": "如需兼容自定义入口参数名，可在绑定里配置入口参数覆盖 JSON。"
      }
    },
    "logStatus": {
      "success": "成功",
      "skipped": "已跳过",
      "failed": "失败",
      "pending": "等待中",
      "error": "错误"
    }
  },
  "videos": {
    "editAllPricesHomeLabel": "首页(短视频)",
    "editPricesVideoLabel": "视频(长视频)",
    "editPricesPostLabel": "帖子",
    "typeLabel": "类型",
    "typePlaceholder": "选择类型...",
    "confirmDelete": "您确定要删除视频 \"{title}\" 吗？",
    "pageTitle": "视频管理",
    "addVideoBtn": "添加视频",
    "addNewVideo": "添加新视频",
    "editVideo": "编辑视频",
    "updateVideo": "更新视频",
    "deleteVideo": "删除视频",
    "videoDetails": "视频详情",
    "searchLabel": "搜索",
    "searchPlaceholder": "按标题或描述搜索...",
    "loadingText": "加载视频中...",
    "noVideosFound": "未找到视频",
    "getStartedText": "开始添加新视频",
    "addFirstVideoBtn": "添加您的第一个视频",
    "price": "价格",
    "noVideosMatchFilters": "没有视频符合您的筛选条件",
    "tryAdjustingSearch": "尝试调整您的搜索条件",
    "clearFiltersBtn": "清除筛选",
    "showingText": "显示",
    "ofText": "共",
    "videosText": "个视频",
    "pageText": "第",
    "ofPagesText": "页，共",
    "previousBtn": "上一页",
    "nextBtn": "下一页",
    "cancelBtn": "取消",
    "submitBtn": "提交",
    "updateBtn": "更新",
    "applyBtn": "应用",
    "resetBtn": "重置",
    "filterByCategoryBtn": "按分类筛选",
    "applyFilter": "应用筛选",
    "editAllPricesBtn": "编辑所有价格",
    "editAllPricesTitle": "编辑所有视频的价格",
    "editAllPricesDesc": "自定义价格范围（最小和最大），没有填写将默认为总台价格",
    "filterByCategory": "按分类筛选视频",
    "selectCategory": "选择分类",
    "chooseCategoryPlaceholder": "选择一个分类",
    "userNameLabel": "创作者名称",
    "userNamePlaceholder": "输入用户名...",
    "likeSortLabel": "点赞排序",
    "likeSortPlaceholder": "选择排序...",
    "noCategoryVideos": "未找到此分类的视频",
    "closeBtn": "关闭",
    "untitledText": "无标题",
    "featuredBadge": "精选",
    "freeBadge": "免费",
    "pinBtn": "置顶",
    "manageBtn": "管理",
    "topPopularTitle": "今日十大热门",
    "communityTitle": "社区",
    "tableRank": "排名",
    "tableTitle": "标题",
    "viewTodayCol": "今日观看",
    "loadingSuccessRateCol": "加载成功率",
    "tableStatusCol": "状态",
    "creatorCol": "创作者",
    "categoryCol": "分类(级别 1)",
    "rankingLevelCol": "排名级别(级别 2)",
    "actionsCol": "操作",
    "basicInfo": "基本信息",
    "media": "媒体",
    "classification": "分类",
    "features": "功能",
    "featuredVideo": "精选视频",
    "featuredVideoDesc": "突出显示此视频",
    "vipAccess": "VIP访问",
    "vipAccessDesc": "专为VIP会员保留",
    "location": "位置",
    "totalVideos": "总视频数",
    "activeVideos": "活跃",
    "pendingVideos": "待处理",
    "vipVideos": "VIP视频",
    "vipBadge": "VIP",
    "quickSearch": "快速搜索",
    "searchPressEnter": "按回车键搜索 \"{query}\"",
    "quickFilters": "快速筛选",
    "active": "活跃",
    "pending": "待处理",
    "featured": "精选",
    "resetFilters": "重置筛选",
    "view": "查看",
    "showingResults": "显示",
    "totalText": "总计",
    "form": {
      "titleLabel": "标题",
      "titlePlaceholder": "输入视频标题",
      "titleRequired": "标题为必填项",
      "descriptionLabel": "描述",
      "descriptionPlaceholder": "输入视频描述",
      "typeLabel": "类型",
      "typePlaceholder": "选择类型",
      "typeRequired": "类型为必填项",
      "priceLabel": "价格 (Ar)",
      "priceMinLabel": "最低价格 （最低 3)",
      "priceMinLabelAdmin": "最低价格",
      "priceMinPlaceholder": "例如: 8",
      "priceMaxLabel": "最高价格 （最高 20)",
      "priceMaxLabelAdmin": "最高价格",
      "priceMaxPlaceholder": "例如: 15",
      "priceValidation": "价格必须为零或正数",
      "priceRangeValidation": "价格必须在 3 到 20 之间",
      "videoUrlLabel": "视频 URL",
      "videoUrlPlaceholder": "https://example.com/video.mp4",
      "videoUrlRequired": "视频 URL 为必填项",
      "durationLabel": "时长 (秒)",
      "durationValidation": "时长必须 > 0",
      "statusLabel": "状态",
      "featuredLabel": "精选",
      "vipLabel": "VIP",
      "coverImageUrlLabel": "封面图片 URL",
      "coverImageUrlPlaceholder": "https://example.com/cover.jpg",
      "provinceLabel": "省份",
      "provincePlaceholder": "输入省份",
      "cityLabel": "城市",
      "cityPlaceholder": "输入城市"
    },
    "types": {
      "long": "长",
      "short": "短",
      "unknown": "未知"
    },
    "statusLabels": {
      "pending": "待审核",
      "validated": "已验证",
      "rejected": "已拒绝",
      "unknown": "未知"
    },
    "messages": {
      "deleteConfirm": "您确定要删除视频 \"{title}\" 吗？",
      "loadFailed": "加载视频失败。请稍后重试。",
      "deleteFailed": "删除视频失败。请稍后重试。",
      "toggleStatusFailed": "切换状态失败。",
      "validationError": "请在提交前修复验证错误。",
      "updateFailed": "更新视频失败。请稍后重试。",
      "addFailed": "添加视频失败。请稍后重试。",
      "enterAtLeastOnePrice": "请至少输入一个价格(最小或最大)。",
      "updatePricesFailed": "更新价格失败。请稍后重试。",
      "pricesUpdatedSuccessfully": "价格更新成功！",
      "unexpectedDataFormat": "从服务器接收到意外的数据格式"
    },
    "detailsModal": {
      "title": "视频详情",
      "videoPlay": "视频播放",
      "coverImage": "封面图片",
      "duration": "时长",
      "creator": "创作者",
      "price": "价格",
      "status": "状态",
      "description": "描述",
      "videoDetails": "视频详情",
      "location": "位置",
      "type": "类型",
      "vipAccess": "VIP访问",
      "required": "必需",
      "public": "公开",
      "featured": "精选",
      "yes": "是",
      "no": "否",
      "createdOn": "创建时间",
      "lastUpdated": "最后更新",
      "videoId": "视频ID",
      "close": "关闭",
      "browserNotSupported": "您的浏览器不支持视频标签。"
    },
    "category": {
      "title": "分类",
      "name": "名称",
      "type": "类型",
      "sort": "排序",
      "createdAt": "创建时间",
      "actions": "操作"
    },
    "actions": {
      "edit": "编辑",
      "delete": "删除"
    }
  },
  "category": {
    "title": "分类管理",
    "addNewCategory": "添加新分类",
    "editCategory": "编辑分类",
    "stats": {
      "totalCategories": "总分类数",
      "thisWeek": "本周新增",
      "lastUpdated": "最后更新"
    },
    "form": {
      "name": "分类名称",
      "namePlaceholder": "输入分类名称",
      "type": "类型",
      "typePlaceholder": "选择类型",
      "sortOrder": "排序",
      "sortPlaceholder": "输入排序序号",
      "showOnHome": "在首页显示"
    },
    "buttons": {
      "cancel": "取消",
      "save": "保存",
      "addNewCategory": "添加分类",
      "updateCategory": "更新分类",
      "createCategory": "创建分类",
      "createFirstCategory": "创建第一个分类",
      "clearSearch": "清除搜索"
    },
    "search": {
      "placeholder": "搜索分类..."
    },
    "messages": {
      "loading": "加载中...",
      "createFirstCategory": "创建第一个分类",
      "noCategoriesFound": "未找到分类",
      "noCategoriesMatch": "没有匹配的分类",
      "loadError": "加载分类时出错",
      "saveError": "保存分类时出错",
      "deleteError": "删除分类时出错",
      "deleteConfirm": "确定要删除这个分类吗？",
      "nameAndTypeRequired": "分类名称和类型为必填项"
    },
    "table": {
      "headers": {
        "id": "ID",
        "name": "名称",
        "type": "类型",
        "sort": "排序",
        "createdAt": "创建日期",
        "actions": "操作"
      },
      "actions": {
        "edit": "编辑",
        "delete": "删除"
      }
    },
    "badges": {
      "home": "首页"
    },
    "types": {
      "Long": "长型",
      "Short": "短型",
      "unknown": "未知类型 {type}"
    }
  },
  "tag": {
    "title": "标签管理",
    "description": "标签管理页面",
    "search": {
      "placeholder": "按名称搜索标签..."
    },
    "form": {
      "name": "标签名称",
      "namePlaceholder": "例如：新闻、精选、紧急..."
    },
    "buttons": {
      "cancel": "取消",
      "save": "保存",
      "addTag": "添加标签",
      "createFirstTag": "创建第一个标签",
      "clearSearch": "清除搜索",
      "updateTag": "更新标签",
      "createTag": "创建标签"
    },
    "messages": {
      "loading": "加载标签中...",
      "noTags": "未找到标签",
      "noTagsFound": "没有找到匹配的标签",
      "nameRequired": "标签名称为必填项",
      "loadError": "加载标签时出错",
      "saveError": "保存标签时出错",
      "deleteError": "删除标签时出错",
      "deleteConfirm": "确定要删除标签 \"{name}\" 吗？",
      "tryAdjustingSearch": "请尝试调整搜索条件"
    },
    "stats": {
      "totalTags": "总标签数",
      "thisWeek": "本周新增",
      "lastUpdated": "最后更新"
    },
    "table": {
      "headers": {
        "id": "ID",
        "name": "标签名称",
        "createdAt": "创建日期",
        "actions": "操作"
      },
      "actions": {
        "edit": "编辑",
        "delete": "删除"
      }
    },
    "modal": {
      "addTitle": "添加新标签",
      "editTitle": "编辑标签"
    }
  },
  "preferences": {
    "title": "个人资料",
    "withdrawPassword": "提现密码",
    "resetWithdrawPassword": "重置提现密码",
    "createWithdrawPassword": "创建提现密码",
    "createWithdrawPasswordModal": {
      "title": "创建提现密码",
      "createWithdrawPassword": "创建密码",
      "successMessage": "提现密码创建成功"
    },
    "resetWithdrawPasswordModal": {
      "title": "修改提现密码",
      "oldWithdrawPasswordLabel": "旧提现密码",
      "oldWithdrawPasswordPlaceholder": "请输入旧提现密码",
      "newWithdrawPasswordLabel": "新提现密码",
      "newWithdrawPasswordPlaceholder": "请输入新提现密码",
      "repeatNewWithdrawPasswordLabel": "确认新提现密码",
      "repeatNewWithdrawPasswordPlaceholder": "请再次输入新提现密码",
      "cancel": "取消",
      "updateWithdrawPassword": "更新",
      "successMessage": "提现密码修改成功",
      "errorMessage": "修改提现密码时出错",
      "validation": {
        "min4Chars": "至少4个字符",
        "min3UniqueChars": "至少包含3个不同字符",
        "min3UniqueDigits": "至少包含3个不同数字",
        "oldWithdrawPasswordRequired": "请输入旧提现密码",
        "newWithdrawPasswordRequired": "请输入新提现密码",
        "repeatWithdrawPasswordRequired": "请确认新提现密码",
        "newWithdrawPasswordMinLength": "密码至少需要4位数字",
        "newWithdrawPasswordUniqueChars": "至少包含3个不同字符",
        "newWithdrawPasswordUniqueDigits": "密码至少需要包含3个不同数字",
        "newWithdrawPasswordDifferent": "新密码不能与旧密码相同",
        "repeatWithdrawPasswordMatch": "两次输入的密码不一致"
      }
    },
    "memberSince": "会员自：",
    "name": "姓名",
    "password": "密码",
    "edit": "编辑",
    "resetPassword": "重置密码",
    "editNameModal": {
      "title": "修改用户名",
      "nameLabel": "姓名",
      "namePlaceholder": "姓名",
      "cancel": "取消",
      "save": "保存",
      "successMessage": "用户名修改成功"
    },
    "avatar": {
      "modal": {
        "title": "更换头像",
        "currentAvatar": "当前头像",
        "uploadImage": "上传新头像",
        "supportedFormats": "支持格式：JPG、PNG、GIF、WebP（最大5MB）",
        "uploadSuccess": "头像上传成功"
      }
    },
    "resetPasswordModal": {
      "title": "重置密码",
      "oldPasswordLabel": "旧密码",
      "redirectMessage": "您将在 {seconds} 秒后重定向到登录页面...",
      "oldPasswordPlaceholder": "旧密码",
      "newPasswordLabel": "新密码",
      "newPasswordPlaceholder": "新密码",
      "repeatNewPasswordLabel": "确认新密码",
      "repeatNewPasswordPlaceholder": "再次输入新密码",
      "cancel": "取消",
      "updatePassword": "更新密码",
      "successMessage": "密码修改成功",
      "validation": {
        "min8Chars": "至少8个字符",
        "min6UniqueChars": "至少包含6个不同字符",
        "oldPasswordRequired": "请输入旧密码",
        "newPasswordRequired": "请输入新密码",
        "newPasswordMinLength": "密码至少需要8个字符",
        "newPasswordUniqueChars": "密码至少需要包含6个不同字符",
        "newPasswordDifferent": "新密码不能与旧密码相同",
        "repeatPasswordRequired": "请确认新密码",
        "repeatPasswordMatch": "两次输入的密码不一致"
      }
    }
  },
  "settings": {
    "title": "设置",
    "theme": "主题",
    "generalPreferences": "常规偏好设置"
  },
  "exchangePage": {
    "title": "汇率管理",
    "subtitle": "管理您的转换汇率",
    "statistics": {
      "totalRates": "汇率数量",
      "withSource": "有来源"
    },
    "modal": {
      "editTitle": "修改汇率",
      "addTitle": "添加汇率",
      "sourceCurrency": "源货币",
      "targetCurrency": "目标货币",
      "rate": "汇率",
      "ratePlaceholder": "0.0000",
      "source": "来源",
      "sourceOptional": "来源（可选）",
      "sourcePlaceholder": "例如: API、手动...",
      "cancel": "取消",
      "edit": "修改",
      "add": "添加"
    },
    "deleteModal": {
      "title": "确认删除",
      "message": "您确定要删除这个汇率吗？",
      "cancel": "取消",
      "delete": "删除"
    },
    "updateModal": {
      "title": "汇率已存在",
      "message": "此汇率已存在。您要更新它吗？",
      "no": "否",
      "yes": "是的，更新"
    },
    "search": {
      "placeholder": "搜索货币...",
      "addButton": "添加汇率"
    },
    "loading": "加载汇率中...",
    "noRates": "未找到汇率。",
    "noResults": "未找到结果。",
    "table": {
      "headers": {
        "sourceCurrency": "源货币",
        "targetCurrency": "目标货币",
        "rate": "汇率",
        "source": "来源",
        "actions": "操作"
      }
    },
    "messages": {
      "loadError": "无法加载汇率",
      "submitError": "保存时出错",
      "deleteError": "无法删除汇率",
      "updateError": "更新时出错",
      "requiredFields": "请填写所有必填字段：源货币、目标货币和汇率",
      "positiveRate": "汇率必须是正数",
      "success": {
        "created": "汇率创建成功",
        "updated": "汇率更新成功",
        "deleted": "汇率删除成功",
        "modified": "汇率修改成功"
      }
    }
  },
  "paymentPlatformsPage": {
    "title": "支付平台配置",
    "subtitle": "支付平台配置",
    "addPlatform": "添加平台",
    "loading": "加载平台中...",
    "loadingChannels": "加载渠道中...",
    "noPlatforms": "未找到支付平台。",
    "noChannels": "此平台未找到渠道。",
    "actions": {
      "view": "查看",
      "edit": "编辑",
      "delete": "删除"
    },
    "search": {
      "placeholder": "搜索支付平台..."
    },
    "table": {
      "headers": {
        "name": "名称",
        "code": "代码",
        "status": "状态",
        "actions": "操作"
      },
      "channels": {
        "headers": {
          "name": "名称",
          "code": "代码",
          "currency": "货币",
          "amountRange": "金额范围",
          "status": "状态",
          "actions": "操作"
        },
        "title": "渠道 ({count})"
      }
    },
    "status": {
      "active": "活跃",
      "inactive": "非活跃",
      "maintenance": "维护中"
    },
    "modals": {
      "platformDetails": {
        "title": "平台详情",
        "basicInfo": "基本信息",
        "apiConfig": "API配置",
        "securityKeys": "安全密钥",
        "urls": "URLs",
        "additionalInfo": "附加信息",
        "timestamps": "时间戳",
        "fields": {
          "id": "ID",
          "name": "名称",
          "code": "代码",
          "description": "描述",
          "status": "状态",
          "apiBaseUrl": "API 基础 URL",
          "merchantId": "商户ID",
          "sort": "排序",
          "privateKey": "私钥",
          "publicKey": "公钥",
          "secretKey": "密钥",
          "callbackUrl": "回调URL",
          "returnUrl": "返回URL",
          "i18nKey": "国际化密钥",
          "sandboxMode": "沙盒模式",
          "createdAt": "创建时间",
          "updatedAt": "更新时间"
        },
        "sandbox": {
          "enabled": "启用",
          "disabled": "禁用"
        },
        "close": "关闭",
        "edit": "编辑"
      },
      "channelDetails": {
        "title": "渠道详情",
        "basicInfo": "基本信息",
        "transactionConfig": "交易配置",
        "additionalInfo": "附加信息",
        "timestamps": "时间戳",
        "fields": {
          "id": "ID",
          "name": "名称",
          "channelCode": "渠道代码",
          "platformId": "平台ID",
          "status": "状态",
          "sort": "排序",
          "currency": "货币",
          "countries": "国家",
          "minAmount": "最小金额",
          "maxAmount": "最大金额",
          "i18nKey": "国际化密钥",
          "icon": "图标",
          "sandboxMode": "沙盒模式",
          "createdAt": "创建时间",
          "updatedAt": "更新时间"
        },
        "sandbox": {
          "enabled": "启用",
          "disabled": "禁用"
        },
        "close": "关闭"
      },
      "deletePlatform": {
        "title": "删除平台",
        "message": "您确定要删除此支付平台吗？此操作无法撤销。"
      },
      "platform": {
        "title": "支付平台",
        "platformName": "平台名称",
        "fields": {
          "name": "名称",
          "code": "代码",
          "description": "描述",
          "status": "状态"
        },
        "description": "描述",
        "status": "状态",
        "statusPlaceholder": "选择状态",
        "cancel": "取消",
        "save": "保存"
      }
    },
    "messages": {
      "fillRequiredFields": "请填写所有必填字段",
      "platformUpdated": "平台更新成功",
      "platformCreated": "平台创建成功",
      "platformDeleted": "平台删除成功",
      "errorSavingPlatform": "保存平台时出错",
      "errorDeletingPlatform": "删除平台时出错"
    },
    "channelTypes": {
      "bankCard": "银行卡",
      "alipayH5": "支付宝H5",
      "wechatH5": "微信H5",
      "alipayQr": "支付宝二维码",
      "wechatQr": "微信二维码",
      "usdt": "USDT",
      "crypto": "加密货币",
      "beifang_online": "北方在线",
      "0000倒贴": "倒贴支付",
      "微信H5 003": "微信H5 003",
      "huitong": "汇通",
      "g63 online": "G63在线"
    }
  },
  "paymentChannelsPage": {
    "title": "支付配置",
    "addChannel": "添加渠道",
    "subtitle": "支付配置",
    "loading": "加载渠道中...",
    "loadingStats": "加载统计中...",
    "noChannels": "未找到支付配置。",
    "noChannelsHint": "添加新的支付配置开始使用。",
    "stats": {
      "totalChannels": "总渠道",
      "activeChannels": "活跃",
      "inactiveChannels": "非活跃",
      "maintenanceChannels": "维护中"
    },
    "search": {
      "placeholder": "搜索渠道...",
      "filterByStatus": "按状态筛选"
    },
    "actions": {
      "view": "查看",
      "edit": "编辑",
      "delete": "删除"
    },
    "table": {
      "headers": {
        "name": "名称",
        "code": "代码",
        "currency": "货币",
        "amount": "金额",
        "status": "状态",
        "actions": "操作",
        "businessType": "业务类型",
        "enabled": "启用",
        "dataStats": "数据统计",
        "dataStatsPercent": "统计(%)",
        "merchantId": "商户ID",
        "paymentGateway": "支付网关",
        "sortWeight": "排序权重",
        "minAmount": "最小金额",
        "maxAmount": "最大金额",
        "extendedParams": "扩展参数",
        "amountRange": "金额范围",
        "description": "描述",
        "bizType": "业务类型",
        "status": "状态",
        "currency": "货币"
      }
    },
    "status": {
      "active": "活跃",
      "inactive": "非活跃",
      "maintenance": "维护中"
    },
    "statistics": {
      "title": "支付统计",
      "totalRevenue": "总收入",
      "totalOrders": "总订单",
      "successRate": "成功率",
      "todayLabel": "今日",
      "yesterdayLabel": "昨日",
      "totalLabel": "总计",
      "amount": "金额",
      "orders": "订单",
      "todayAmount": "今日金额",
      "todaySuccessRate": "今日成功率",
      "yesterdayAmount": "昨日金额",
      "yesterdaySuccessRate": "昨日成功率",
      "totalAmount": "总金额",
      "totalSuccessRate": "总成功率"
    },
    "modals": {
      "channelDetails": {
        "title": "渠道详情",
        "basicInfo": "基本信息",
        "transactionConfig": "交易配置",
        "additionalInfo": "附加信息",
        "timestamps": "时间戳",
        "fields": {
          "id": "ID",
          "name": "名称",
          "channelCode": "渠道代码",
          "platformId": "平台ID",
          "status": "状态",
          "sort": "排序",
          "currency": "货币",
          "countries": "国家",
          "minAmount": "最小金额",
          "maxAmount": "最大金额",
          "i18nKey": "国际化密钥",
          "icon": "图标",
          "sandboxMode": "沙盒模式",
          "createdAt": "创建时间",
          "updatedAt": "更新时间"
        },
        "sandbox": {
          "enabled": "启用",
          "disabled": "禁用"
        },
        "close": "关闭",
        "edit": "编辑"
      },
      "deleteChannel": {
        "title": "删除渠道",
        "message": "您确定要删除此支付配置吗？此操作无法撤销。"
      },
      "channel": {
        "title": "支付配置",
        "channelName": "渠道名称",
        "titleEdit": "编辑支付配置",
        "channelCode": "渠道代码",
        "platform": "平台",
        "channelType": "渠道类型",
        "status": "状态",
        "statusPlaceholder": "选择状态",
        "typePlaceholder": "选择渠道类型",
        "minAmount": "最小金额",
        "maxAmount": "最大金额",
        "currency": "货币",
        "sort": "排序",
        "icon": "图标",
        "i18nKey": "国际化密钥",
        "activityType": "业务类型",
        "activityTypePlaceholder": "选择业务类型",
        "sandboxMode": "沙盒模式",
        "description": "描述",
        "bizType": "业务类型",
        "bizTypePlaceholder": "选择业务类型",
        "sortOrder": "排序权重",
        "numericFields": "数字字段",
        "statusHint": "控制此支付配置是否处于活跃或非活跃状态",
        "iconUpload": "图标上传",
        "selectIcon": "选择图标",
        "suggestedIcons": "推荐图标",
        "chooseFile": "选择文件",
        "iconFileHint": "为此支付配置上传图标图片。支持格式：JPG、PNG、GIF。最大大小：5MB。",
        "cancel": "取消",
        "save": "保存"
      }
    },
    "channelTypes": {
      "bankCard": "银行卡",
      "alipayH5": "支付宝H5",
      "wechatH5": "微信H5",
      "alipayQr": "支付宝二维码",
      "wechatQr": "微信二维码",
      "usdt": "USDT",
      "crypto": "加密货币",
      "beifang_online": "北方在线",
      "0000倒贴": "倒贴支付",
      "微信H5 003": "微信H5 003",
      "huitong": "汇通",
      "Alipay - Beifang": "支付宝-北方",
      "QQ双端": "QQ双端",
      "guanzi online": "冠子在线",
      "支付宝原生009": "支付宝原生009",
      "银联扫码": "银联扫码",
      "支付宝BC大额": "支付宝BC大额",
      "纯视频微信扫码": "纯视频微信扫码",
      "支付宝纯视频原生H5": "支付宝纯视频原生H5",
      "g63 online": "G63在线",
      "微信H5内付原生": "微信H5内付原生",
      "支付宝H5抗投黄油": "支付宝H5抗投黄油",
      "微信扫码黄油专用": "微信扫码黄油专用",
      "微信话费H5": "微信话费H5",
      "数字人民币": "数字人民币",
      "微信IOS原生": "微信IOS原生",
      "视频专用原生": "视频专用原生",
      "微信扫码BC专用": "微信扫码BC专用",
      "支付宝金条原生": "支付宝金条原生",
      "BC微信原生": "BC微信原生",
      "支付宝 VPN": "支付宝 VPN",
      "BC支付宝原生": "BC支付宝原生",
      "微信视频打赏原生": "微信视频打赏原生",
      "微信打赏原生": "微信打赏原生",
      "微信 VPN": "微信 VPN",
      "微信小额IOS": "微信小额IOS",
      "霸王专用": "霸王专用",
      "支付宝打赏专用": "支付宝打赏专用",
      "支付宝凤楼原生": "支付宝凤楼原生",
      "支付宝原生（白天开）": "支付宝原生（白天开）",
      "wxpay微信": "wxpay微信",
      "momo单片视频": "momo单片视频",
      "0077纯视频zz": "0077纯视频zz",
      "ABCD单片视频打赏": "ABCD单片视频打赏",
      "6600支付宝企业V": "6600支付宝企业V",
      "7700支付宝视频抗投": "7700支付宝视频抗投",
      "9898抗投黄游": "9898抗投黄游",
      "4433微信h5": "4433微信h5",
      "3333黄游王炸": "3333黄游王炸",
      "3344微信纯打赏": "3344微信纯打赏",
      "9123微信纯视频": "9123微信纯视频",
      "1010微信vpn": "1010微信vpn",
      "5566微信扫码": "5566微信扫码",
      "9900支付宝vpn": "9900支付宝vpn",
      "0506微信黄游h5": "0506微信黄游h5",
      "0102支付宝": "0102支付宝",
      "0304微信短剧": "0304微信短剧",
      "8800支付宝原生": "8800支付宝原生",
      "打赏专属通道": "打赏专属通道",
      "支付宝10-500": "支付宝10-500",
      "支付宝VPN": "支付宝VPN",
      "支付宝视频量": "支付宝视频量",
      "VPN，视频，游戏": "VPN，视频，游戏",
      "支付宝内高层": "支付宝内高层",
      "支付宝小额50起": "支付宝小额50起",
      "支付宝资金原生": "支付宝资金原生",
      "支付宝纯原生": "支付宝纯原生",
      "支付宝固额100": "支付宝固额100",
      "云闪付100-200": "云闪付100-200",
      "微信扫码前期": "微信扫码前期",
      "全层H5转账红包100-5000": "全层H5转账红包100-5000",
      "支付宝小钱袋前期": "支付宝小钱袋前期",
      "支付宝前期": "支付宝前期",
      "小钱袋": "小钱袋",
      "支付宝话费": "支付宝话费",
      "技术测试": "技术测试",
      "1188话费商城": "1188话费商城",
      "8000支付宝燃气": "8000支付宝燃气",
      "8123": "8123",
      "A1127楼凤炮台": "A1127楼凤炮台",
      "2244微信qq": "2244微信qq",
      "V2480资金原生": "V2480资金原生",
      "2480资金原生": "2480资金原生",
      "8321微信原生": "8321微信原生",
      "6606数字": "6606数字",
      "4443微信快手": "4443微信快手",
      "2225微信扫码": "2225微信扫码",
      "7766大额原生": "7766大额原生",
      "2221内层5000 100-500": "2221内层5000 100-500",
      "5555腾讯点卷": "5555腾讯点卷",
      "4444微信": "4444微信",
      "1112内层": "1112内层",
      "0990wx视频pc端": "0990wx视频pc端",
      "8989微信h5黄游": "8989微信h5黄游",
      "0708微信语聊": "0708微信语聊",
      "8585微信红包": "8585微信红包",
      "8889小额金条": "8889小额金条",
      "8009支付宝原生": "8009支付宝原生",
      "9955微信游戏私服": "9955微信游戏私服",
      "2222微信双端原生": "2222微信双端原生",
      "9998支付宝Ai": "9998支付宝Ai",
      "7733支付宝抗投游戏私服": "7733支付宝抗投游戏私服",
      "6667宝转卡": "6667宝转卡",
      "7777小额UID": "7777小额UID",
      "8888金条原生": "8888金条原生",
      "8811支付宝纯原生": "8811支付宝纯原生",
      "9999纯黄播": "9999纯黄播",
      "微信支付": "微信支付",
      "支付宝": "支付宝",
      "微信扫码畅游": "微信扫码畅游",
      "名片小额100": "名片小额100",
      "微信完美6-200": "微信完美6-200",
      "转账红包大额": "转账红包大额",
      "微信内高层": "微信内高层",
      "代付原生": "代付原生",
      "固定金额": "固定金额",
      "小额100-200H5复制转账": "小额100-200H5复制转账",
      "支付宝原生100-500": "支付宝原生100-500",
      "纯原生小额8021": "纯原生小额8021",
      "8020内高层3万加": "8020内高层3万加",
      "8019支付宝综合": "8019支付宝综合",
      "微信YY": "微信YY",
      "微信内付": "微信内付"
    },
    "messages": {
      "channelUpdated": "渠道更新成功",
      "channelCreated": "渠道创建成功",
      "channelDeleted": "渠道删除成功",
      "statusUpdated": "渠道状态更新成功",
      "errorLoadingChannels": "加载渠道时出错",
      "errorLoadingPlatforms": "加载平台时出错",
      "errorSavingChannel": "保存渠道时出错",
      "errorUpdatingStatus": "更新渠道状态时出错",
      "errorDeletingChannel": "删除渠道时出错",
      "channelAlreadyExists": "具有此名称或代码的渠道已存在"
    },
    "bizTypes": {
      "recharge": "充值",
      "resource": "单片",
      "vip": "VIP",
      "timePackage": "时间套餐"
    }
  },
  "pay": {
    "channel": {
      "huitong_online": "汇通在线"
    }
  },
  "paymentStatistics": {
    "title": "支付统计",
    "subtitle": "实时支付性能指标",
    "totalTransactions": "总交易量",
    "totalRevenue": "总收入",
    "successRate": "成功率",
    "activeChannels": "活跃渠道",
    "revenueChart": "收入趋势",
    "transactionStatus": "交易状态",
    "completed": "已完成",
    "pending": "待处理",
    "failed": "失败",
    "chartPlaceholder": "图表可视化将显示在此处",
    "errorLoading": "加载支付统计信息时出错"
  },
  "user": {
    "account": "账户",
    "profile": "个人资料",
    "settings": "设置",
    "logout": "退出登录"
  },
  "ads": {
    "title": "广告管理",
    "tabs": {
      "ads": "广告",
      "video_ads": "视频广告",
      "video_durations": "视频时长",
      "video_logs": "视频日志",
      "activities": "活动",
      "collections": "收藏",
      "placements": "位置",
      "switches": "开关",
      "triggers": "触发器",
      "trigger_history": "触发历史",
      "settings": "设置",
      "tracking": "跟踪",
      "statistics": "统计",
      "targeting": "定向",
      "agents": "代理"
    },
    "activities": {
      "title": "活动管理",
      "subtitle": "创建并管理包含关联广告的活动",
      "showOnAppLaunch": "在活动期间应用启动时显示",
      "showAsPopup": "在活动期间以弹窗形式显示",
      "list": {
        "search_placeholder": "搜索活动...",
        "filter_status": "所有状态",
        "add_button": "新建活动",
        "no_data": "未找到活动",
        "columns": {
          "code": "代码",
          "name": "名称",
          "status": "状态",
          "start": "开始",
          "end": "结束",
          "linked_ads": "关联广告",
          "actions": "操作"
        }
      },
      "form": {
        "create_title": "创建新活动",
        "edit_title": "编辑活动",
        "view_title": "活动详情",
        "basic_info": "基本信息",
        "period_status": "周期和状态",
        "fields": {
          "activity_code": "活动代码",
          "activity_code_placeholder": "例如: SUMMER_PROMO_2024",
          "activity_code_required": "代码必填",
          "activity_name": "活动名称",
          "activity_name_placeholder": "例如: 2024夏季促销",
          "activity_name_required": "名称必填",
          "description": "描述",
          "description_placeholder": "描述该活动...",
          "start_time": "开始日期",
          "end_time": "结束日期",
          "status": "状态",
          "status_placeholder": "选择状态",
          "open_screen_ad": "开屏广告",
          "open_screen_ad_short": "开屏",
          "popup_ad": "弹窗广告",
          "popup_ad_short": "弹窗"
        },
        "display_on_launch": "在活动期间应用启动时显示",
        "display_on_popup": "在活动期间以弹窗形式显示",
        "actions": {
          "cancel": "取消",
          "create": "创建",
          "update": "更新",
          "save": "保存"
        }
      },
      "display_order": {
        "title": "预定显示顺序",
        "step_launch": "1. 应用启动",
        "step_normal_open": "2. → 普通开屏广告（如果已启用）",
        "step_activity_open": "{step}. → 活动开屏广告",
        "step_enter": "{step}. 进入应用",
        "step_normal_popup": "{step}. → 普通弹窗（如果已启用）",
        "step_activity_popup": "{step}. → 活动弹窗"
      },
      "preview_info": {
        "open_screen_title": "开屏广告",
        "open_screen_desc": "在活动期间应用启动时显示",
        "popup_title": "弹窗广告",
        "popup_desc": "在活动期间以弹窗形式显示"
      },
      "status": {
        "draft": "草稿",
        "active": "激活",
        "paused": "暂停",
        "expired": "已过期"
      },
      "messages": {
        "load_error": "加载活动失败",
        "create_success": "活动创建成功",
        "update_success": "活动更新成功",
        "delete_success": "活动删除成功",
        "delete_confirm": "您确定要删除此活动吗？",
        "validation": {
          "code_required": "代码必填",
          "code_invalid": "活动代码只能包含大写字母、数字、下划线和连字符",
          "name_required": "名称必填",
          "name_invalid": "活动名称包含无效字符",
          "date_invalid": "结束日期必须在开始日期之后"
        }
      }
    },
    "video_ads": {
      "modal": {
        "createVideoAd": "创建视频广告",
        "editVideoAd": "编辑视频广告"
      },
      "button": {
        "addVideoAd": "添加视频广告",
        "createAd": "创建广告",
        "saveChanges": "保存修改",
        "cancel": "取消",
        "openVideo": "打开视频",
        "close": "关闭",
        "apply": "应用",
        "create": "创建"
      },
      "form": {
        "triggerMoment": "触发时间 *",
        "internalTitle": "内部标题",
        "internalTitlePlaceholder": "用于识别广告的名称",
        "videoFile": "视频文件",
        "dragVideo": "将视频拖到这里",
        "currentUrl": "当前URL",
        "coverImage": "封面图片",
        "dragImage": "将图片拖到这里",
        "rewardApiUrl": "奖励 API 地址",
        "rewardApiUrlPlaceholder": "例如：/api/game/reward",
        "rewardApiHint": "观看后自动调用",
        "redirectUrl": "跳转 URL",
        "redirectUrlPlaceholder": "例如： https://...",
        "redirectHint": "点击广告时打开",
        "displayOrder": "显示顺序",
        "activeAd": "广告启用",
        "forcePlay": "强制播放（不可跳过）",
        "orientation": "方向",
        "portrait": "竖屏",
        "landscape": "横屏",
        "all": "全部",
        "skipConfig": "跳过设置",
        "skipAfter": "多少秒后可跳过",
        "skipTextFr": "文本 (FR)",
        "skipTextEn": "文本 (EN)",
        "start": "开始时间",
        "end": "结束时间"
      },
      "messages": {
        "uploadVideo": "上传视频文件",
        "uploadImage": "上传封面图片"
      },
      "details": {
        "title": "视频广告详情",
        "titleLabel": "标题",
        "videoDuration": "视频时长",
        "configuration": "配置",
        "trigger": "触发时间",
        "status": "状态",
        "playMode": "播放方式",
        "rewardUrl": "奖励地址",
        "targetUrl": "目标地址",
        "videoPlay": "视频播放",
        "coverImage": "封面图片",
        "adDetails": "广告详情",
        "urls": "链接地址",
        "duration": "时长",
        "type": "类型",
        "sortOrder": "排序",
        "orientation": "方向"
      },
      "orientation": {
        "portrait": "竖屏",
        "landscape": "横屏",
        "all": "全部"
      },
      "batch": {
        "orientation": {
          "title": "更新方向",
          "setForVideos": "为 {count} 个视频设置方向：",
          "newOrientation": "新的方向"
        },
        "skipConfig": {
          "title": "跳过按钮配置",
          "applyForVideos": "将配置应用到 {count} 个视频：",
          "enableSkip": "启用跳过",
          "skipAfterSeconds": "多少秒后可跳过",
          "textFr": "文本 (FR)",
          "textEn": "文本 (EN)"
        }
      },
      "status": {
        "active": "启用",
        "inactive": "未启用"
      },
      "play": {
        "force": "强制播放",
        "skippable": "可跳过"
      },
      "common": {
        "required": "必填"
      }
    },
    "durationConfig": {
      "modal": {
        "create": "创建配置",
        "edit": "修改配置"
      },
      "form": {
        "durationSeconds": "停留时间（秒）*",
        "description": "描述",
        "descriptionPlaceholder": "例如：3分钟后显示",
        "sortOrder": "排序",
        "active": "启用"
      },
      "validation": {
        "durationPositive": "持续时间必须大于 0"
      },
      "common": {
        "cancel": "取消",
        "create": "创建",
        "update": "更新"
      }
    },
    "collections": {
      "title": "广告合集管理",
      "subtitle": "管理网格或序列模式下的合集显示配置",
      "noData": "未找到项目。",
      "noFiltered": "没有项目符合过滤条件。",
      "list": {
        "search_placeholder": "搜索合集...",
        "filter_mode": "所有模式",
        "add_button": "新建合集",
        "columns": {
          "code": "代码",
          "name": "名称",
          "mode": "模式",
          "config": "配置",
          "ads": "广告",
          "status": "状态",
          "actions": "操作"
        },
        "config_grid": "{count} 列",
        "config_sequence": "{delay}秒 延迟",
        "ads_count": "{count} 个广告"
      },
      "status": {
        "draft": "草稿",
        "active": "激活",
        "paused": "暂停",
        "expired": "已过期"
      },
      "form": {
        "create_title": "创建新合集",
        "edit_title": "编辑合集",
        "view_title": "合集详情",
        "basic_info": "基本信息",
        "display_mode": "显示模式",
        "member_ads": "关联广告",
        "status": "状态",
        "fields": {
          "code": "合集代码",
          "code_placeholder": "例如: SUMMER_GRID_1",
          "name": "合集名称",
          "name_placeholder": "例如: 2024夏季合集",
          "description": "描述",
          "description_placeholder": "描述该合集...",
          "mode": "显示模式",
          "grid_columns": "列数",
          "grid_column": "{count} 列",
          "grid_columns_many": "{count} 列",
          "sequence_delay": "广告切换延迟 (秒)",
          "sequence_delay_placeholder": "例如: 3",
          "seconds": "秒"
        },
        "modes": {
          "grid": "网格",
          "grid_desc": "广告以网格布局同时显示",
          "sequence": "序列",
          "sequence_desc": "广告以可配置的延迟逐个显示",
          "grid_full": "网格 - 同时以网格显示",
          "sequence_full": "序列 - 按延迟逐个显示"
        },
        "selection": {
          "title": "选择广告",
          "search_placeholder": "搜索广告...",
          "no_data": "未找到广告",
          "add_button": "添加广告",
          "instruction": "选择要包含在此合集中的广告。它们将按网格布局/列表顺序显示。",
          "none_selected": "未选择广告。请为此合集添加广告。",
          "format": "格式: {format}",
          "cancel": "取消",
          "close": "关闭"
        },
        "actions": {
          "cancel": "取消",
          "create": "创建",
          "update": "更新"
        }
      },
      "messages": {
        "load_error": "加载合集失败",
        "save_success": "合集保存成功",
        "create_success": "合集创建成功",
        "update_success": "合集更新成功",
        "save_error": "保存合集失败",
        "delete_confirm": "您确定要删除合集 \"{name}\" 吗？",
        "delete_success": "合集已删除。",
        "delete_error": "删除合集失败",
        "validation": {
          "code_required": "代码必填",
          "code_invalid": "合集代码只能包含大写字母、数字、下划线和连字符",
          "name_required": "名称必填",
          "name_min_length": "名称长度必须至少为 2 个字符",
          "name_invalid": "合集名称包含无效字符",
          "mode_required": "请选择显示模式",
          "columns_required": "请选择列数",
          "delay_required": "请填写延迟时间",
          "ads_required": "请至少选择一个广告"
        }
      }
    },
    "placements_management": {
      "title": "版位管理",
      "subtitle": "管理广告版位及其显示配置",
      "noData": "未找到项目。",
      "noFiltered": "没有项目符合过滤条件。",
      "list": {
        "search_placeholder": "搜索版位...",
        "category_filter": "所有类别",
        "add_button": "添加版位",
        "insertion_frequency_text": "每 {count} 个项目 1 条广告",
        "columns": {
          "name": "版位",
          "category": "类别",
          "type": "类型",
          "enabled": "已启用",
          "platforms": "平台",
          "status": "状态",
          "actions": "操作"
        }
      },
      "batch": {
        "selected_count": "已选择 {count} 个版位",
        "activate": "激活",
        "deactivate": "停用",
        "orientation": "屏幕方向",
        "close_button": "关闭按钮",
        "delete": "删除",
        "cancel": "取消"
      },
      "form": {
        "create_title": "创建新版位",
        "edit_title": "编辑版位",
        "view_title": "版位详情",
        "basic_info": "基本信息",
        "scene_classification": "场景分类",
        "display_config": "显示配置",
        "platform_control": "平台控制与屏幕方向",
        "close_button_section": "关闭按钮",
        "allowed_formats": "允许的广告格式",
        "fields": {
          "code": "版位代码",
          "name": "版位名称",
          "description": "描述",
          "description_placeholder": "描述该版位...",
          "scene_type": "场景类型 / 类别",
          "video_type": "视频版位类型",
          "community_type": "社区版位类型",
          "chat_type": "聊天版位类型",
          "system_type": "系统版位类型",
          "open_screen_type": "开屏类型",
          "activity_type": "活动类型",
          "search_type": "搜索类型",
          "trigger_time": "触发时间 (秒)",
          "trigger_percent": "触发百分比 (%)",
          "insertion_frequency": "插入频率",
          "insertion_placeholder": "每 N 个项目 1 条广告",
          "frequency_cap": "频次上限",
          "frequency_placeholder": "最大显示次数",
          "frequency_unit": "频次单位",
          "display_interval": "最小显示间隔 (秒)",
          "interval_placeholder": "广告间的最小间隔",
          "devices": "允许的终端",
          "devices_placeholder": "选择终端",
          "orientation": "允许的屏幕方向",
          "show_close_button": "显示按钮",
          "close_button_after": "显示延迟 (秒)",
          "close_button_position": "按钮位置",
          "status": "状态",
          "is_enabled": "启用状态 (开关)",
          "activation_hint": "如需启用，状态必须为“激活”"
        }
      },
      "categories": {
        "video": "视频",
        "feed": "信息流 (Feed)",
        "chat": "聊天",
        "status": "状态 (系统)",
        "open_screen": "开屏",
        "activity": "活动",
        "search": "搜索",
        "popup_daily": "每日弹窗",
        "popup_after_views": "观看后弹窗",
        "popup_marketing": "营销弹窗",
        "popup_exit": "退出弹窗",
        "popup_redirect": "重定向弹窗",
        "loading": "加载中",
        "network_error": "网络错误",
        "offline": "离线",
        "app_promotion": "应用推广",
        "rewarded_redirect": "激励重定向",
        "offerwall": "积分墙",
        "video_pause": "视频暂停",
        "video_preroll": "视频前贴片",
        "video_midroll": "视频中贴片",
        "video_postroll": "视频后贴片",
        "fixed_placement": "固定版位",
        "popup": "弹窗",
        "trigger_based": "行为触发",
        "redirect": "重定向"
      },
      "detailed_types": {
        "video_feed_banner": "视频流横幅",
        "video_pause_fullscreen": "视频暂停广告 (全屏)",
        "video_bottom_banner": "视频底部横幅",
        "community_feed_inline": "社区流嵌入",
        "community_top_banner": "顶部横幅",
        "community_native_small": "原生嵌入 (小)",
        "community_large_newsfeed": "大图广告 (新闻流)",
        "chat_top_banner": "聊天顶部横幅",
        "chat_bubble_system": "聊天气泡 (系统/AI)",
        "chat_bottom_cta": "底部 CTA 按钮",
        "chat_list_inline": "聊天列表嵌入",
        "chat_input_recommendation": "输入区推荐",
        "system_loading": "加载中",
        "system_network_error": "网络错误",
        "system_offline": "离线",
        "open_screen_fullscreen": "全屏开屏",
        "open_screen_secondary": "第二屏 (轻便型)",
        "activity_banner": "活动横幅",
        "activity_popup": "活动弹窗",
        "activity_inline": "嵌入式活动",
        "search_top_banner": "搜索顶部横幅",
        "search_bottom_banner": "搜索底部横幅",
        "search_inline": "搜索结果内",
        "search_sidebar": "搜索侧边栏",
        "popup_daily_first": "每日初始弹窗",
        "popup_after_n_videos": "观看 N 次后",
        "popup_redirect_app": "应用重定向",
        "redirect_app_download": "应用下载",
        "redirect_rewarded": "激励重定向",
        "redirect_offerwall": "任务墙 (Offerwall)",
        "video_preroll": "前贴片广告",
        "video_midroll": "中贴片广告"
      },
      "orientation": {
        "all": "全部",
        "portrait": "竖屏",
        "landscape": "横屏"
      },
      "close_button": {
        "top_right": "右上角",
        "top_left": "左上角",
        "bottom_right": "右下角",
        "bottom_left": "左下角"
      },
      "formats": {
        "fullscreen_image": "全屏图片",
        "fullscreen_video": "全屏视频",
        "halfscreen": "半屏",
        "collection": "合集"
      },
      "units": {
        "per_day": "每天",
        "per_hour": "每小时",
        "per_session": "每会话",
        "per_user_lifetime": "用户终生"
      },
      "messages": {
        "load_error": "加载版位失败",
        "save_success": "版位保存成功",
        "update_success": "版位更新成功",
        "create_success": "版位创建成功",
        "save_error": "保存失败",
        "delete_confirm": "确定删除版位 \"{name}\" 吗？",
        "delete_success": "版位已删除",
        "delete_error": "删除失败",
        "deleteVersion": "版本删除成功",
        "deleteLink": "删除链接",
        "deleteLinkConfirm": "您确定要删除版本 \"{version}\" 的版本链接 \"{name}\" 吗？",
        "deleteLinkWarning": "此操作无法撤销。",
        "dragAndDropFile": "将文件拖放到此处",
        "linkCopied": "链接已复制到剪贴板",
        "failedToCopyLink": "复制链接失败",
        "batch_activate_confirm": "确定激活选中的 {count} 个版位吗？",
        "batch_activate_success": "{count} 个版位激活成功",
        "batch_deactivate_confirm": "确定停用选中的 {count} 个版位吗？",
        "batch_deactivate_success": "{count} 个版位停用成功",
        "batch_delete_confirm": "警告：确定永久删除选中的 {count} 个版位吗？\n\n此操作不可撤销！",
        "batch_delete_success": "{count} 个版位删除成功",
        "batch_update_success": "{count} 个版位更新成功",
        "validation": {
          "code_required": "代码必填",
          "code_invalid": "版位代码只能包含大写字母、数字、下划线和连字符",
          "name_required": "名称必填",
          "name_min_length": "名称至少包含 2 个字符",
          "name_invalid": "版位名称包含无效字符",
          "scene_type_required": "场景类型必填"
        }
      }
    },
    "button": {
      "addVideoAd": "添加视频广告",
      "addDurationSetting": "添加时长设置"
    },
    "commun": {
      "status": {
        "active": "激活",
        "inactive": "未激活",
        "scheduled": "定时发布",
        "expired": "已过期"
      }
    },
    "list": {
      "search_placeholder": "搜索广告...",
      "searchConfiguration": "搜索配置...",
      "searchVideoAds": "搜索视频广告...",
      "filter_duration": "按时长筛选",
      "filter_status": "按状态筛选",
      "add_button": "添加广告",
      "no_image": "无图片",
      "undefined": "未定义",
      "noData": "未找到项目。",
      "noFiltered": "没有项目符合过滤条件。",
      "columns": {
        "image": "图片",
        "code": "代码",
        "name": "名称",
        "status": "状态",
        "placements": "位置",
        "triggers": "触发器",
        "priority": "优先级",
        "start_time": "开始时间",
        "end_time": "结束时间",
        "actions": "操作",
        "video": "视频",
        "duree": "时长",
        "type": "类型",
        "order": "顺序",
        "second": "秒",
        "description": "描述",
        "action": "操作"
      },
      "actions": {
        "view": "查看详情",
        "manage_placements": "管理位置",
        "manage_triggers": "管理触发器",
        "edit": "编辑",
        "delete": "删除"
      },
      "pagination": {
        "page_info": "第 {current} 页，共 {total} 页"
      }
    },
    "form": {
      "create_title": "创建新广告",
      "edit_title": "编辑广告",
      "fields": {
        "ad_code": "广告代码",
        "ad_code_placeholder": "例如：SUMMER_PROMO_2024",
        "ad_code_required": "代码必填",
        "ad_code_invalid": "代码无效（仅限大写字母、数字、下划线、连字符）",
        "ad_name": "广告名称",
        "ad_name_placeholder": "例如：2024年夏季促销",
        "ad_name_required": "名称必填",
        "ad_name_invalid": "字符无效",
        "multilingual_content": "多语言内容",
        "title": "标题",
        "title_placeholder": "输入标题...",
        "description": "描述",
        "description_placeholder": "输入描述...",
        "target_type": "目标类型",
        "target_type_placeholder": "选择类型",
        "target_url": "目标URL",
        "target_url_placeholder": "输入URL",
        "display_format": "显示格式",
        "display_format_placeholder": "选择格式",
        "ad_position": "视频位置",
        "ad_position_placeholder": "选择位置",
        "cta_text": "CTA文本",
        "cta_text_placeholder": "输入行动号召文本",
        "priority": "优先级",
        "priority_placeholder": "0",
        "weight": "权重",
        "weight_placeholder": "1",
        "status": "状态",
        "status_placeholder": "选择状态",
        "start_time": "开始时间",
        "start_time_required": "开始时间必填",
        "start_time_validation": "必须早于或等于结束时间",
        "end_time": "结束时间",
        "end_time_required": "结束时间必填",
        "end_time_validation": "必须晚于或等于开始时间",
        "image": "广告图片",
        "image_info": "系统会自动从此图片生成3个优化尺寸（小、中、大）",
        "crop_image": "裁剪和调整图片",
        "video": "视频文件",
        "video_cover": "视频封面",
        "video_duration": "视频时长（秒）",
        "display_config": "显示配置",
        "is_skippable": "可跳过",
        "skip_countdown": "跳过倒计时（秒）",
        "min_watch": "最小观看时间（秒）",
        "close_button_delay": "关闭按钮延迟（秒）",
        "time_slots": "允许时间段",
        "time_slots_optional": "（可选）",
        "time_slots_info": "定义此广告可以显示的时间段。如果未定义时间段，广告将随时显示。",
        "start_hour": "开始小时",
        "end_hour": "结束小时",
        "time_slot_to": "至",
        "days": "天数",
        "all_days": "所有天数",
        "add_time_slot": "添加时间段"
      },
      "target_types": {
        "url": "URL",
        "deeplink": "深度链接",
        "page": "页面",
        "app": "应用",
        "none": "无"
      },
      "display_formats": {
        "fullscreen_image": "全屏图片",
        "fullscreen_video": "全屏视频",
        "halfscreen": "半屏",
        "collection": "合集",
        "banner": "横幅广告",
        "native": "原生广告",
        "interstitial": "插屏广告",
        "rewarded": "激励广告"
      },
      "ad_positions": {
        "not_applicable": "不适用",
        "preroll": "前贴片（视频前）",
        "midroll": "中贴片（视频中）",
        "postroll": "后贴片（视频后）",
        "pause": "暂停（视频暂停时）"
      },
      "days_of_week": {
        "1": "周一",
        "2": "周二",
        "3": "周三",
        "4": "周四",
        "5": "周五",
        "6": "周六",
        "0": "周日"
      },
      "actions": {
        "cancel": "取消",
        "create": "创建",
        "update": "更新",
        "save": "保存"
      }
    },
    "crop_modal": {
      "title": "高级图片编辑器",
      "zoom_in": "放大 +",
      "zoom_out": "缩小 -",
      "rotate_left": "向左旋转 ←",
      "rotate_right": "向右旋转 →",
      "aspect_ratio": "16:9",
      "aspect_ratio_square": "1:1",
      "aspect_ratio_free": "自由",
      "flip_horizontal": "水平翻转 H",
      "flip_vertical": "垂直翻转 V",
      "crop_info": "交互式裁剪已启用 - 移动和调整选择区域",
      "cancel": "取消",
      "apply": "应用裁剪"
    },
    "details": {
      "title": "广告详情",
      "ad_code": "广告代码",
      "ad_name": "广告名称",
      "status": "状态",
      "priority": "优先级",
      "description": "描述",
      "start_time": "开始时间",
      "end_time": "结束时间",
      "placements": "关联位置 ({count})",
      "triggers": "关联触发器 ({count})",
      "no_placements": "无关联位置",
      "no_triggers": "无关联触发器",
      "close": "关闭"
    },
    "placements": {
      "title": "管理位置",
      "info": "选择此广告应该出现的位置。",
      "search_placeholder": "搜索位置...",
      "selected": "已选择位置: {count}",
      "no_selected": "未选择位置",
      "priority": "优先级",
      "weight": "权重",
      "code_label": "代码",
      "category_label": "类别",
      "actions": {
        "cancel": "取消",
        "save": "保存"
      }
    },
    "triggers": {
      "title": "触发规则",
      "subtitle": "创建简单或组合规则以自动触发广告展示",
      "info": "触发器管理",
      "search_placeholder": "搜索触发器...",
      "selected": "已选择的触发器",
      "no_selected": "未选择任何触发器",
      "filters": {
        "search": "搜索规则...",
        "all_types": "所有类型"
      },
      "buttons": {
        "new_rule": "新建规则",
        "cancel": "取消",
        "save": "保存",
        "create": "创建",
        "update": "更新",
        "close": "关闭",
        "test": "运行测试",
        "add_condition": "添加条件",
        "delete": "删除",
        "yes_delete": "是的，删除！"
      },
      "table": {
        "code": "代码",
        "name": "名称",
        "type": "类型",
        "accumulation": "累积",
        "active": "激活",
        "status": "状态",
        "actions": "操作",
        "global": "全局",
        "session": "会话"
      },
      "code_label": "代码",
      "type_label": "类型",
      "threshold_label": "阈值",
      "modal": {
        "create_title": "创建新规则",
        "edit_title": "编辑规则",
        "view_title": "规则详情",
        "test_title": "测试触发规则",
        "basic_info": "基本信息",
        "simple_config": "简单配置",
        "combined_config": "组合规则配置",
        "advanced_params": "高级设置",
        "test_description": "模拟用户行为以测试规则是否正确触发。",
        "logic_preview": "逻辑预览"
      },
      "form": {
        "rule_code": "规则代码 *",
        "rule_name": "规则名称 *",
        "trigger_type": "触发类型 *",
        "threshold": "触发阈值 *",
        "time_window": "时间窗口（可选）",
        "resource_type": "适用资源类型（可选）",
        "accumulation_mode": "累积模式",
        "reset_after": "触发后重置",
        "status": "状态",
        "enabled": "规则启用",
        "logical_operator": "逻辑运算符 *",
        "condition_type": "条件类型",
        "wait_time": "等待时间（可选）",
        "simulation_value": "模拟值"
      },
      "placeholders": {
        "rule_code": "例如：TRIGGER_SCROLL_3",
        "rule_name": "例如：滚动3次后触发",
        "all_resources": "所有资源",
        "seconds": "秒",
        "wait_seconds": "秒",
        "choose": "选择...",
        "operator_and": "AND - 需要满足所有条件",
        "operator_or": "OR - 满足任一条件即可",
        "hours": "小时",
        "time_window": "例如：3600 表示 1 小时",
        "threshold_example": "例如：3",
        "browse_example": "例如：3 次滚动",
        "watch_example": "例如：5 个视频",
        "stay_example": "例如：60 秒",
        "like_example": "例如：10 个赞",
        "comment_example": "例如：5 条评论",
        "share_example": "例如：3 次分享",
        "visit_example": "例如：2 次访问",
        "chat_example": "例如：3 次互动"
      },
      "trigger_types": {
        "browse_count": "滚动",
        "watch_count": "观看",
        "stay_duration": "停留时长",
        "like_count": "点赞",
        "comment_count": "评论",
        "share_count": "分享",
        "page_visit_count": "访问",
        "ai_chat_count": "AI聊天",
        "custom_combination": "组合",
        "exit_intent": "退出",
        "app_background": "后台",
        "network_error": "网络错误",
        "loading_complete": "加载",
        "scroll_depth": "深度",
        "browse_count_desc": "滚动 - N 次滚动后",
        "watch_count_desc": "观看 - M 个视频后",
        "stay_duration_desc": "停留时长 - 页面停留 T 秒后",
        "like_count_desc": "点赞 - X 个赞后",
        "comment_count_desc": "评论 - Y 条评论后",
        "share_count_desc": "分享 - Z 次分享后",
        "page_visit_count_desc": "访问 - N 次页面访问后",
        "ai_chat_count_desc": "AI聊天 - N 次互动后",
        "custom_combination_desc": "自定义组合（AND/OR）",
        "exit_intent_desc": "退出意图 - 用户想要离开时",
        "app_background_desc": "后台 - 应用进入后台时",
        "network_error_desc": "网络错误 - 连接错误时",
        "loading_complete_desc": "加载完成 - 初始加载后",
        "scroll_depth_desc": "滚动深度 - 滚动 N% 后"
      },
      "accumulation_modes": {
        "global": "全局 - 持续累积",
        "session": "会话 - 每次会话重置",
        "daily": "每日 - 每日重置"
      },
      "statuses": {
        "draft": "草稿",
        "active": "激活",
        "paused": "暂停",
        "expired": "已过期",
        "inactive": "未激活"
      },
      "units": {
        "times": "次",
        "videos": "个视频",
        "likes": "个赞",
        "comments": "条评论",
        "shares": "次分享",
        "visits": "次访问",
        "interactions": "次互动",
        "seconds_short": "秒",
        "seconds": "秒"
      },
      "messages": {
        "load_error": "加载规则失败",
        "save_success": "规则保存成功",
        "update_success": "规则更新成功",
        "save_error": "保存规则失败",
        "delete_confirm_title": "您确定吗？",
        "delete_confirm_text": "您要删除规则 \"{name}\" 吗？",
        "delete_success": "规则已删除。",
        "delete_error": "删除规则失败",
        "toggle_success": "规则 {status}",
        "toggle_error": "更改状态失败",
        "test_triggered": "✓ 规则已触发！",
        "test_not_triggered": "✗ 规则未触发",
        "no_condition": "无条件",
        "threshold_reached": "阈值 {threshold} 已达到，当前值 {value}",
        "threshold_not_reached": "阈值 {threshold} 未达到（当前：{value}）",
        "combined_test_sim": "对包含 {count} 个条件的组合规则进行模拟测试",
        "activated": "已激活",
        "deactivated": "已停用",
        "required": "必填",
        "yes": "是",
        "no": "否",
        "example": "示例",
        "success_title": "成功",
        "error_title": "错误",
        "delete_success_title": "已删除！"
      },
      "resource_types": {
        "video": "视频",
        "image": "图片",
        "audio": "音频",
        "article": "文章"
      },
      "combined": {
        "description": "通过 AND/OR 逻辑组合多个条件来创建复杂规则。",
        "and_description": "必须满足所有条件",
        "or_description": "至少满足一个条件",
        "and_operator": "且",
        "or_operator": "或"
      },
      "examples": {
        "browse_count": "用户在列表中滚动 3 次 → 触发广告",
        "watch_count": "用户观看 5 个视频 → 触发广告",
        "stay_duration": "用户在页面停留 60 秒 → 触发广告",
        "like_count": "用户点赞 10 个内容 → 触发广告",
        "comment_count": "用户评论 5 次 → 触发广告",
        "share_count": "用户分享 3 次 → 触发广告",
        "page_visit_count": "用户访问页面 2 次 → 触发广告",
        "ai_chat_count": "用户与 AI 聊天互动 3 次 → 触发广告"
      },
      "test": {
        "rule": "规则",
        "simulation_placeholder": "输入测试值"
      },
      "view": {
        "general_info": "基本信息",
        "conditions": "条件",
        "wait": "等待",
        "description": "描述",
        "rule": "规则",
        "enter_test_value": "输入测试值"
      },
      "operators": {
        "and": "和",
        "or": "或"
      },
      "threshold": "阈值",
      "seconds": "秒",
      "actions": {
        "cancel": "取消",
        "save": "保存"
      }
    },
    "settings": {
      "title": "全局设置",
      "subtitle": "配置广告系统的全局参数。要启用/禁用系统，请使用 \"Switch Controls\" 选项卡。",
      "sections": {
        "frequency": "全局频率限制",
        "priority": "显示优先级",
        "advanced": "高级参数",
        "analytics": "分析设置",
        "skip": "\"跳过\" 配置",
        "close_button": "全局关闭按钮",
        "breakpoints": "响应式断点"
      },
      "frequency": {
        "description": "控制所有用户的广告最大显示频率",
        "global_cap": "全局频率限制",
        "time_unit": "时间单位",
        "max_per_session": "每次会话最大广告数",
        "min_interval": "广告之间的最小间隔",
        "ads_unit": "广告",
        "seconds_unit": "秒"
      },
      "frequency_units": {
        "per_hour": "每小时",
        "per_day": "每天",
        "per_week": "每周",
        "per_session": "每次会话"
      },
      "priority": {
        "description": "定义每种广告类型的显示优先级（1 = 最高优先级）",
        "open_screen": "打开屏幕",
        "popup": "弹窗",
        "activity": "活动",
        "video": "视频",
        "trigger_based": "触发式",
        "redirect": "重定向"
      },
      "advanced": {
        "counter_accumulation": "启用累积计数器",
        "counter_accumulation_desc": "允许在多个时段累积展示次数",
        "accumulation_mode": "累积模式",
        "auto_refresh": "允许自动刷新",
        "auto_refresh_desc": "自动更新广告集合",
        "refresh_interval": "刷新间隔（秒）",
        "debug_mode": "调试模式",
        "debug_mode_desc": "启用详细日志进行调试",
        "test_banners": "显示测试横幅",
        "test_banners_desc": "以测试模式显示广告并带有可视指示器"
      },
      "accumulation_modes": {
        "rolling": "滚动窗口",
        "reset": "定期重置",
        "lifetime": "总生命周期"
      },
      "analytics": {
        "impression_tracking": "启用展示跟踪",
        "impression_tracking_desc": "记录所有广告展示",
        "click_tracking": "启用点击跟踪",
        "click_tracking_desc": "记录所有广告点击",
        "conversion_tracking": "启用转化跟踪",
        "conversion_tracking_desc": "跟踪广告互动后的转化",
        "retention_days": "分析数据保留天数（天）"
      },
      "skip": {
        "enable_skip": "启用跳过选项",
        "enable_skip_desc": "允许用户在延迟后跳过广告",
        "skip_after": "延迟后跳过（秒）",
        "show_button": "显示按钮：",
        "button_text_fr": "按钮文本（法语）",
        "button_text_en": "按钮文本（英语）",
        "button_text_es": "按钮文本（西班牙语）"
      },
      "close_button": {
        "show_button": "显示关闭按钮",
        "show_button_desc": "在广告上显示关闭叉号",
        "show_after": "延迟后显示（秒）",
        "show_after_placeholder": "0 表示立即显示",
        "position": "按钮位置"
      },
      "positions": {
        "top_right": "右上",
        "top_left": "左上",
        "bottom_right": "右下",
        "bottom_left": "左下"
      },
      "breakpoints": {
        "description": "定义设备目标的屏幕宽度（像素）",
        "mobile": "移动设备（最大宽度）",
        "tablet": "平板电脑（最大宽度）",
        "desktop": "桌面（最小宽度）"
      },
      "buttons": {
        "reset": "重置",
        "save": "保存设置"
      },
      "messages": {
        "load_error": "加载设置失败",
        "save_success": "设置保存成功",
        "save_error": "保存设置失败",
        "reset_success": "设置已重置"
      }
    },
    "tracking": {
      "description": "查看广告跟踪数据：展示、点击、转化",
      "filters": {
        "title": "筛选器",
        "ad": "广告",
        "all_ads": "所有广告",
        "date_range": "日期范围"
      },
      "buttons": {
        "search": "搜索",
        "reset": "重置"
      },
      "stats": {
        "impressions": "展示",
        "clicks": "点击",
        "conversions": "转化",
        "video_plays": "视频播放"
      },
      "metrics": {
        "ctr": "点击率 (CTR)",
        "ctr_desc": "点击 / 展示",
        "conversion_rate": "转化率",
        "conversion_rate_desc": "转化 / 点击"
      },
      "tabs": {
        "impressions": "展示",
        "clicks": "点击",
        "conversions": "转化",
        "video_plays": "视频播放"
      },
      "columns": {
        "ad": "广告",
        "placement": "位置",
        "user_id": "用户ID",
        "device": "设备",
        "datetime": "日期/时间",
        "type": "类型",
        "value": "值",
        "duration": "时长",
        "completion_rate": "完成率"
      }
    },
    "statistics": {
      "description": "广告统计仪表板，包含性能指标、对比分析和详细数据。",
      "noData": "未找到项目。",
      "noFiltered": "没有项目符合过滤条件。",
      "overview": {
        "total_ads": "总广告数",
        "active": "活跃",
        "total_impressions": "总展示量",
        "total_clicks": "总点击量",
        "total_conversions": "总转化量",
        "vs_last": "对比上期"
      },
      "metrics": {
        "avg_ctr": "平均点击率 (CTR)",
        "clicks_impressions": "点击 / 展示",
        "avg_conversion_rate": "平均转化率",
        "conversions_clicks": "转化 / 点击",
        "performance_score": "整体性能评分",
        "performance_desc": "基于点击率、转化率和参与度"
      },
      "sections": {
        "top_ads": "表现最佳的广告",
        "by_placement": "按位置统计",
        "trends": "时间趋势"
      },
      "limits": {
        "top_5": "前5名",
        "top_10": "前10名",
        "top_20": "前20名"
      },
      "placeholders": {
        "all_ads": "所有广告",
        "all_placements": "所有位置"
      },
      "columns": {
        "ad": "广告",
        "impressions": "展示量",
        "clicks": "点击量",
        "conversions": "转化量",
        "ctr": "点击率",
        "conv_rate": "转化率",
        "placement": "位置"
      },
      "trends": {
        "description": "所选时间段内的性能可视化。数据显示展示量、点击量和转化量随时间的变化。",
        "impressions_growth": "展示量增长",
        "clicks_growth": "点击量增长",
        "conversions_growth": "转化量增长"
      }
    },
    "status": {
      "draft": "草稿",
      "active": "活跃",
      "paused": "暂停",
      "expired": "过期"
    },
    "scene_categories": {
      "video": "视频",
      "community": "社区",
      "chat": "聊天",
      "system": "系统",
      "open_screen": "打开屏幕",
      "popup": "弹窗",
      "activity": "活动",
      "status": "状态",
      "search": "搜索",
      "feed": "动态"
    },
    "trigger_types": {
      "browse_count": "浏览",
      "watch_count": "观看",
      "stay_duration": "停留时长",
      "like_count": "点赞",
      "comment_count": "评论",
      "share_count": "分享",
      "page_visit_count": "页面访问",
      "ai_chat_count": "AI聊天",
      "custom_combination": "组合"
    },
    "messages": {
      "load_error": "加载广告失败",
      "create_success": "广告创建成功",
      "update_success": "广告更新成功",
      "delete_confirm": "您要删除广告 \"{name}\" 吗？",
      "delete_success": "广告已删除",
      "placements_updated": "位置更新成功",
      "triggers_updated": "触发器更新成功",
      "error_title": "错误",
      "warning_title": "注意",
      "placements_update_failed": "更新位置失败",
      "triggers_update_failed": "更新触发器失败",
      "delete_failed": "删除失败",
      "save_failed": "保存失败",
      "validation": {
        "code_invalid": "广告代码只能包含大写字母、数字、下划线和连字符",
        "name_min_length": "广告名称至少需要2个字符",
        "name_invalid_chars": "名称不能包含字符：&lt; &gt; &quot; &#39; &amp;",
        "date_range": "结束时间必须大于或等于开始时间"
      },
      "video": {
        "transcoded": "视频已转码",
        "transcoded_success": "视频已成功转码",
        "transcode_error": "转码错误"
      },
      "crop": {
        "success": "图片裁剪成功",
        "error": "裁剪失败: {message}",
        "crop_error": "无法裁剪图片"
      },
      "actions": {
        "save": "保存",
        "cancel": "取消"
      }
    },
    "switches": {
      "title": "开关控制",
      "subtitle": "管理层级开关以控制广告显示（全局 → 类别 → 位置 → 平台）",
      "global_switch": {
        "title": "全局开关",
        "description": "完整广告系统",
        "help_text": "一键启用或禁用整个广告系统（紧急情况）",
        "enabled": "已启用",
        "disabled": "已禁用"
      },
      "category_switches": {
        "title": "类别开关",
        "subtitle": "按场景类别控制广告激活",
        "status_format": "{active}/{total} 已激活"
      },
      "placement_switches": {
        "title": "按位置和平台分类的开关",
        "subtitle": "按平台（H5, iOS, Android, Web）单独控制每个广告位置",
        "search_placeholder": "搜索位置...",
        "all_categories": "所有类别",
        "columns": {
          "placement": "展示位置",
          "category": "类别",
          "enabled": "已启用",
          "platforms": "平台"
        }
      },
      "categories": {
        "video": "视频广告",
        "video_desc": "整个应用的视频广告",
        "feed": "信息流",
        "feed_desc": "信息流中的广告",
        "chat": "聊天",
        "chat_desc": "会话中的广告",
        "status": "状态",
        "status_desc": "状态/故事中的广告",
        "open_screen": "开屏广告",
        "open_screen_desc": "启动应用时的广告",
        "activity": "活动",
        "activity_desc": "与营销活动相关的广告"
      },
      "messages": {
        "global_success": "广告系统已成功{status}",
        "global_error": "切换全局开关时出错",
        "category_success": "类别 \"{label}\" {status}",
        "category_error": "切换类别时出错",
        "placement_success": "位置 {status} 成功",
        "placement_error": "切换位置时出错",
        "platform_success": "平台 {platform} 已更新",
        "platform_error": "切换平台时出错",
        "activated": "已启用",
        "deactivated": "已禁用",
        "activated_m": "已启用",
        "deactivated_m": "已禁用"
      }
    },
    "targeting": {
      "info_alert": "配置广告的地理位置、设备和平台定向。请选择一个广告来管理其定向。",
      "select_ad_card": "选择广告",
      "ad_label": "广告",
      "ad_placeholder": "选择一个广告",
      "countries": {
        "title": "国家",
        "search_placeholder": "搜索...",
        "loading": "加载中...",
        "no_results": "无结果",
        "clear": "清空",
        "selected_count": "已选择 {count} 个"
      },
      "devices": {
        "title": "设备",
        "empty_selection_hint": "未选择 = 允许所有设备",
        "types": {
          "android": "Android",
          "android_desc": "Android 设备",
          "ios": "iOS",
          "ios_desc": "iPhone 和 iPad",
          "h5": "移动网页 (H5)",
          "h5_desc": "移动浏览器",
          "all": "所有设备",
          "all_desc": "通用投放"
        }
      },
      "platforms": {
        "title": "平台",
        "empty_selection_hint": "未选择 = 允许所有平台",
        "types": {
          "ios": "iOS",
          "ios_desc": "iPhone 和 iPad",
          "android": "Android",
          "android_desc": "Android 设备",
          "web": "网络 (Web)",
          "web_desc": "网络浏览器",
          "windows": "Windows",
          "windows_desc": "Windows 电脑",
          "macos": "macOS",
          "macos_desc": "Mac 电脑"
        }
      },
      "actions": {
        "reset": "重置",
        "save": "保存定向"
      },
      "empty_state": {
        "title": "请选择一个广告",
        "description": "在上方选择一个广告以配置其地理位置、设备和平台定向。"
      },
      "messages": {
        "save_success": "定向保存成功",
        "save_error": "定时设置失败",
        "fetch_countries_error": "加载国家列表失败",
        "success_title": "成功",
        "error_title": "错误"
      }
    },
    "videoAds": {
      "title": "视频广告",
      "new": "新视频广告",
      "edit": "编辑视频广告",
      "noVideo": "未选择视频",
      "noTitle": "无标题",
      "create": "创建",
      "update": "更新",
      "saveChanges": "保存更改",
      "createAd": "创建广告",
      "openVideo": "打开视频",
      "selectedVideos": "个视频已选中",
      "confirmDelete": "确定要删除此视频广告\"{title}\"吗？",
      "status": {
        "active": "已启用",
        "inactive": "已禁用"
      },
      "type": {
        "forced": "强制",
        "skippable": "可跳过"
      },
      "noData": "未找到项目。",
      "noFiltered": "没有项目符合过滤条件。",
      "videoAdsTable": {
        "columns": {
          "id": "ID",
          "video": "视频",
          "duration": "时长",
          "trigger": "触发条件",
          "status": "状态",
          "type": "类型",
          "order": "排序",
          "actions": "操作"
        }
      },
      "detailsModal": {
        "title": "视频广告详情",
        "id": "ID：",
        "title": "标题：",
        "duration": "视频时长：",
        "configuration": "配置",
        "trigger": "触发条件：",
        "status": "状态：",
        "playback": "播放：",
        "rewardUrl": "奖励URL：",
        "targetUrl": "目标URL："
      },
      "batch": {
        "orientation": "屏幕方向",
        "skipConfig": "跳过配置",
        "orientationModalTitle": "更新屏幕方向",
        "orientationPrompt": "为{count}个视频设置屏幕方向：",
        "newOrientation": "新屏幕方向",
        "portrait": "竖屏",
        "landscape": "横屏",
        "all": "全部",
        "skipConfigModalTitle": "跳过按钮配置",
        "skipConfigPrompt": "为{count}个视频应用配置：",
        "enableSkip": "启用跳过",
        "skipAfter": "跳过延迟（秒）",
        "textFr": "文本（法语）",
        "textEn": "文本（英语）"
      },
      "error": {
        "load": "加载视频广告失败"
      },
      "placeholders": {
        "filterDuration": "按时长筛选",
        "search": "搜索视频广告..."
      },
      "form": {
        "triggerMoment": "触发时机",
        "required": "必填",
        "targetType": "目标类型",
        "targetType_none": "无",
        "targetType_url": "URL",
        "targetType_deeplink": "深链接",
        "targetType_page": "页面",
        "targetType_app": "应用",
        "internalTitle": "内部标题",
        "titlePlaceholder": "用于识别广告的名称",
        "videoFile": "视频文件",
        "dragVideo": "将视频拖到这里",
        "currentUrl": "当前URL",
        "coverImage": "封面图片",
        "dragImage": "将图片拖到这里",
        "rewardApiUrl": "奖励API地址",
        "rewardHint": "观看后自动调用",
        "redirectUrl": "跳转URL",
        "redirectHint": "点击广告时打开",
        "displayOrder": "显示顺序",
        "activeAd": "广告启用",
        "forcedPlayback": "强制播放（不可跳过）",
        "orientation": "屏幕方向",
        "portrait": "竖屏",
        "landscape": "横屏",
        "all": "全部",
        "skipConfig": "跳过设置",
        "skipAfter": "几秒后可跳过",
        "start": "开始时间",
        "end": "结束时间",
        "textFR": "文本（法语）",
        "textEN": "文本（英语）"
      },
      "messages": {
        "coverUploaded": "封面图片上传成功",
        "deleteSuccess": "视频广告删除成功",
        "deleteError": "删除视频广告失败",
        "selectVideo": "请选择一个视频",
        "preparingUpload": "准备上传...",
        "uploadingVideoCover": "上传视频和封面...",
        "uploadingVideo": "上传视频...",
        "uploadInProgress": "上传中... {percent}%",
        "uploadTranscoding": "上传完成。正在服务器上转码...（请稍候）",
        "uploadSuccess": "上传完成！",
        "uploadSuccessHLS": "视频上传成功（加密HLS格式）！",
        "uploadSuccessRegular": "视频上传成功！",
        "uploadFailed": "上传失败",
        "uploadError": "上传错误",
        "uploadVideoError": "上传视频失败",
        "selectImage": "请选择一个图片",
        "uploadImageSuccess": "封面图片上传成功！",
        "uploadImageError": "上传图片失败",
        "uploadBeforeCreate": "创建广告前请先上传视频",
        "updateSuccess": "视频广告更新成功",
        "createSuccess": "视频广告创建成功",
        "submitError": "{action}视频广告时出错",
        "batchUpdateSuccess": "{count}个视频更新成功",
        "batchUpdateError": "更新失败：{error}",
        "loadError": "加载视频广告失败",
        "serverProcessing": "正在服务器处理..."
      }
    },
    "triggerHistory": {
      "noData": "未找到项目。",
      "noFiltered": "没有项目符合过滤条件。"
    },
    "adAgents": {
      "info_alert": "管理广告与代理/发布商之间的关联。控制哪些代理可以显示哪些广告。",
      "noData": "未找到项目。",
      "noFiltered": "没有项目符合过滤条件。",
      "select_ad_card": {
        "title": "选择广告",
        "label": "广告",
        "placeholder": "选择一个广告"
      },
      "agents_list": {
        "title": "👥 全局代理列表",
        "search_placeholder": "搜索代理...",
        "columns": {
          "association": "关联",
          "username": "代理",
          "code": "代码",
          "role": "角色"
        },
        "already_assigned": "已关联"
      },
      "active_ad_card": {
        "title": "活跃广告",
        "targeting_for": "定向目标：",
        "bulk_actions": "批量操作",
        "import_ids": "导入ID列表",
        "remove_all": "移除所有代理",
        "stats": {
          "assigned": "已分配",
          "available": "可用"
        }
      },
      "no_ad_selected": {
        "title": "未选择广告",
        "description": "选择一个广告以便通过复选框关联或移除代理。"
      },
      "bulk_add_modal": {
        "title": "批量添加代理",
        "select_agents": {
          "title": "选择代理",
          "label": "从列表中选择代理",
          "placeholder": "搜索或选择..."
        },
        "manual_input": {
          "title": "手动输入或快速导入",
          "import_file": "导入文件",
          "ids_label": "标识符列表 (ID)",
          "ids_placeholder": "在此粘贴您的ID，用逗号、空格或每行一个分隔",
          "formats_info": "格式：逗号、空格、分号、换行符",
          "clear_input": "清除输入"
        },
        "preview": {
          "title": "要添加的代理预览",
          "agent_count": "{count} 个代理",
          "warning_large": "您即将添加超过100个代理。这可能需要几秒钟。",
          "all_already_assigned": "所有指定的代理都已与此广告关联。",
          "id_prefix": "ID:",
          "more_count": "... 以及另外 {count} 个"
        },
        "footer": {
          "ready_to_add": "准备添加 {count} 个代理",
          "cancel": "取消",
          "add_button": "添加 {count} 个代理"
        }
      },
      "messages": {
        "error": "错误",
        "modification_failed": "修改失败",
        "attention": "注意",
        "bulk_add_confirm": "您即将添加 {count} 个代理。\n此操作可能需要时间。继续吗？",
        "yes_continue": "是的，继续",
        "cancel_button": "取消",
        "adding_progress": "正在添加...",
        "adding_progress_text": "正在添加 {count} 个代理。\n请稍候...",
        "success": "成功！",
        "agents_added": "{count} 个代理添加成功",
        "add_failed": "添加代理失败",
        "remove_confirm": "您确定吗？",
        "remove_text": "您要移除此代理吗？",
        "yes_remove": "是的，移除！",
        "removed": "已移除！",
        "agent_removed": "代理移除成功。",
        "remove_failed": "移除失败",
        "clear_all_confirm": "您确定吗？",
        "clear_all_text": "您要移除所有 {count} 个代理吗？",
        "yes_remove_all": "是的，移除全部！",
        "all_removed": "已移除！",
        "all_agents_removed": "所有代理都已被移除。",
        "file_imported": "文件已导入",
        "file_imported_text": "在文件中检测到 {count} 个代理"
      }
    }
  },
  "videoDurations": {
    "noData": "未找到项目。",
    "noFiltered": "没有项目符合过滤条件。",
    "buttons": {
      "add": "添加"
    },
    "status": {
      "active": "启用",
      "inactive": "禁用"
    },
    "validation": {
      "durationPositive": "时长必须为正数"
    },
    "messages": {
      "success": "成功",
      "error": "处理视频时长时发生错误"
    },
    "modal": {
      "titleEdit": "编辑标题",
      "titleCreate": "创建标题"
    },
    "form": {
      "durationLabel": "时长",
      "durationPositive": "时长必须为正数",
      "sortOrderLabel": "排序",
      "activeLabel": "启用",
      "descriptionLabel": "描述",
      "descriptionPlaceholder": "此时长的描述"
    },
    "search": {
      "placeholder": "搜索"
    },
    "columns": {
      "id": "ID",
      "seconds": "秒",
      "description": "描述",
      "order": "排序",
      "status": "状态",
      "actions": "操作"
    }
  },
  "wallet": {
    "title": "钱包管理",
    "subtitle": "管理用户余额和账户",
    "add_balance": "创建钱包",
    "add_title": "创建钱包",
    "edit_title": "编辑钱包",
    "stats": {
      "total_balance": "总余额",
      "total_users": "总用户数",
      "avg_balance": "平均余额"
    },
    "search": "搜索钱包...",
    "filters": {
      "all": "全部",
      "active": "活跃",
      "frozen": "冻结",
      "closed": "已关闭"
    },
    "pagination": {
      "items_per_page": "每页显示条目"
    },
    "table": {
      "user": "用户",
      "balance": "余额",
      "last_updated": "最后更新",
      "status": "状态",
      "actions": "操作"
    },
    "status": {
      "positive": "正数",
      "negative": "负数",
      "zero": "零"
    },
    "actions": {
      "charge": "充值",
      "close": "关闭",
      "edit": "编辑",
      "add_funds": "添加资金",
      "add_funds_prompt": "输入要添加的金额："
    },
    "form": {
      "user": "用户",
      "balance": "余额",
      "balance_placeholder": "输入余额",
      "search_user": "搜索用户...",
      "no_users_found": "未找到用户",
      "cancel": "取消",
      "create": "创建",
      "update": "更新"
    },
    "toasts": {
      "success": "成功",
      "error": "错误",
      "create_success": "钱包创建成功",
      "update_success": "钱包更新成功",
      "save_error": "保存时出错",
      "fetch_error": "获取钱包时出错",
      "funds_added": "资金添加成功"
    },
    "errors": {
      "user_already_has_wallet": "该用户已拥有钱包"
    },
    "modals": {
      "add_funds": {
        "title": "添加资金",
        "user": "用户",
        "current_balance": "当前余额",
        "amount_to_add": "要添加的金额",
        "amount_placeholder": "输入要添加的金额",
        "cancel": "取消",
        "confirm": "添加资金",
        "error_adding": "添加资金时出错",
        "invalid_amount": "请输入有效金额"
      },
      "charge": {
        "title": "充值钱包",
        "user": "用户",
        "current_balance": "当前余额",
        "amount": "充值金额（€）",
        "amount_placeholder": "输入充值金额",
        "description": "描述",
        "description_placeholder": "充值描述",
        "payment_method": "支付方式",
        "payment_methods": {
          "credit_card": "信用卡",
          "paypal": "PayPal",
          "bank_transfer": "银行转账",
          "crypto": "加密货币"
        },
        "cancel": "取消",
        "confirm": "充值",
        "success_message": "钱包已成功充值 {amount}€",
        "error_message": "充值钱包时出错",
        "auth_error": "认证错误 - 请重新登录",
        "permission_error": "没有权限执行此操作",
        "not_found_error": "未找到钱包",
        "server_error": "服务器错误 - 请稍后重试",
        "invalid_amount": "请输入有效金额"
      },
      "close": {
        "title": "关闭钱包",
        "user": "用户",
        "current_balance": "当前余额",
        "reason": "关闭原因",
        "reason_placeholder": "请说明关闭此钱包的原因",
        "cancel": "取消",
        "confirm": "关闭钱包",
        "reason_required": "请说明关闭钱包的原因",
        "success_message": "钱包已成功关闭",
        "error_message": "关闭钱包时出错",
        "auth_error": "认证错误 - 请重新登录",
        "permission_error": "没有权限执行此操作",
        "not_found_error": "未找到钱包",
        "server_error": "服务器错误 - 请稍后重试"
      }
    }
  },
  "withdrawPage": {
    "creditCard": "银行卡 / 支付宝",
    "title": "提现管理",
    "agentSubtitle": "管理您的收入和提现请求",
    "adminSubtitle": "批准或拒绝代理提现请求",
    "roleAgent": "代理",
    "roleAdmin": "管理员",
    "requestWithdrawal": "请求提现",
    "minimumAmounts": {
      "button": "最低金额",
      "title": "最低提现金额",
      "usdtLabel": "USDT 最低金额",
      "usdtPlaceholder": "输入 USDT 最低金额",
      "bankCardLabel": "银行卡最低金额",
      "bankCardPlaceholder": "输入银行卡最低金额"
    },
    "wallet": {
      "available": "可用余额",
      "total": "累计总额",
      "withdrawn": "已提现",
      "pending": "待处理",
      "approved": "已批准",
      "thisMonth": "本月",
      "thisWeek": "本周",
      "monthlyProgress": "月度进度"
    },
    "tabs": {
      "history": "历史记录",
      "commissions": "佣金",
      "settlement": "结算",
      "pending": "待处理请求"
    },
    "filters": {
      "all": "全部",
      "pending": "待处理",
      "approved": "已批准",
      "paid": "已提交",
      "rejected": "已拒绝"
    },
    "table": {
      "amount": "金额",
      "method": "支付方式",
      "status": "状态",
      "date": "日期",
      "requestDate": "申请日期",
      "approvalDate": "批准日期",
      "paymentDate": "支付日期",
      "actions": "操作",
      "view": "查看",
      "edit": "编辑",
      "approve": "批准",
      "reject": "拒绝",
      "pay": "支付",
      "agent": "代理",
      "commission": "佣金",
      "rate": "利率 (%)",
      "transactionId": "交易",
      "account": "账户",
      "beneficiary": "收款人",
      "beneficiary": "收款人",
      "comment": "评论"
    },
    "qr": {
      "button": {
        "changeImage": "更换图片",
        "uploadQrImage": "上传二维码图片"
      }
    },
    "upload": {
      "button": {
        "changeScreenshot": "更换截图",
        "uploadScreenshot": "上传截图"
      },
      "hint": {
        "imageFormats": "支持的格式：JPG、PNG、WebP（最大大小：5MB）",
        "screenshotFormats": "支持的格式：JPG、PNG、WebP（最大大小：10MB）"
      },
      "noImageSelected": "未选择图片",
      "qrPreviewAlt": "二维码预览",
      "screenshotPreviewAlt": "截图预览",
      "proofImageAlt": "转账凭证"
    },
    "modal": {
      "newWithdrawalRequest": "新提现申请",
      "fillInformation": "填写您的请求信息",
      "editRequest": "编辑申请",
      "reviewWithdrawal": "审核提现",
      "amount": "提现金额",
      "amountPlaceholder": "输入金额",
      "method": "支付方式",
      "selectMethod": "选择支付方式",
      "address": "收款地址",
      "addressPlaceholder": "输入钱包地址",
      "trc20Hint": "TRC20 USDT 地址",
      "bankAccount": "银行账户",
      "accountNumber": "账户号码",
      "accountName": "账户名称",
      "bankName": "银行名称",
      "bankNamePlaceholder": "例如：工商银行、建设银行 /支付宝",
      "iban": "银行卡号/支付宝账号",
      "ibanPlaceholder": "例如：FR76 XXXX XXXX XXXX XXXX XXXX XXX",
      "ibanHint": "国际标准格式",
      "proof": "支付凭证",
      "proofPlaceholder": "上传凭证图片/文件",
      "beneficiaryName": "收款人姓名",
      "fullName": "银行卡收款请填写真实姓名",
      "note": "备注（可选）",
      "notes": "备注（可选）",
      "notesPlaceholder": "添加备注...",
      "additionalInfo": "添加其他信息...",
      "approvalNotes": "批准备注",
      "approvalNotesPlaceholder": "添加批准备注...",
      "rejectionReason": "拒绝原因",
      "rejectionReasonPlaceholder": "解释拒绝原因...",
      "summary": "提现摘要",
      "requestedAmount": "申请金额",
      "newBalance": "新余额",
      "fees": "交易费用",
      "finalAmount": "最终金额",
      "cancel": "取消",
      "request": "请求提现",
      "submit": "提交",
      "approve": "批准",
      "reject": "拒绝",
      "save": "保存更改",
      "withdrawalPassword": "提现密码",
      "enterWithdrawalPassword": "输入提现密码",
      "withdrawalPasswordHint": "为了安全起见，需要输入提现密码",
      "qrCode": "二维码（可选）",
      "qrCodeLabel": "二维码：",
      "proofPreview": "凭证预览",
      "transferProof": "转账凭证",
      "close": "关闭"
    },
    "paymentMethods": {
      "usdt": "USDT (TRC20) 最低200",
      "bank": "银行卡 / 支付宝",
      "USDT": "USDT",
      "USDT_SHORT": "TRC20",
      "BANK": "银行卡 / 支付宝 最低100",
      "BANK_SHORT": "卡片",
      "BANK_TABLE": "银行卡 / 支付宝"
    },
    "paymentMethodsmin": {
      "usdt": "USDT (TRC20)"
    },
    "agentTable": {
      "withdrawal": "提现",
      "status": "状态",
      "timeline": "时间",
      "account": "账户",
      "date": "日期",
      "actions": "操作"
    },
    "status": {
      "PENDING": "待处理",
      "APPROVED": "已批准",
      "PAID": "已支付",
      "REJECTED": "已拒绝",
      "SETTLED": "已结算"
    },
    "empty": {
      "noWithdrawals": "未找到提现记录",
      "noHistory": "无提现历史",
      "noCommissions": "无佣金数据",
      "startWithdrawal": "开始您的首个提现申请",
      "startWithdrawing": "开始您的首个提现申请",
      "firstRequest": "提出首个请求",
      "noPending": "没有待处理的提现",
      "allProcessed": "所有提现已处理",
      "noApproved": "没有批准的提现",
      "approvedAppear": "批准的提现将显示在这里以便支付",
      "noHistory": "无提现历史",
      "processedAppear": "已处理的提现将显示在这里",
      "noData": "无可用数据"
    },
    "search": {
      "placeholder": "搜索提现...",
      "agentPlaceholder": "搜索代理...",
      "dateFrom": "从",
      "dateTo": "至",
      "filterPlaceholder": "筛选",
      "adminSearchPlaceholder": "搜索代理或请求...",
      "searchAgent": "搜索代理...",
      "searchApproved": "搜索已批准的提现...",
      "searchHistory": "搜索历史..."
    },
    "validation": {
      "amountRequired": "金额为必填项",
      "amountPositive": "金额必须为正数",
      "minimumAmountUSDT": "USDT(TRC20) 最低提现金额为 200",
      "minimumAmountBank": "银行卡最低提现金额为 100",
      "methodRequired": "请选择支付方式",
      "addressRequired": "钱包地址为必填项",
      "reasonRequired": "拒绝原因为必填项",
      "withdrawalPasswordRequired": "提现密码为必填项",
      "exceedsBalance": "金额超过可用余额"
    },
    "messages": {
      "success": "成功！",
      "error": "错误！",
      "withdrawalRequested": "提现申请已成功提交",
      "withdrawalApproved": "提现已成功批准",
      "withdrawalRejected": "提现已拒绝",
      "withdrawalPaid": "提现已标记为已支付",
      "withdrawalUpdated": "提现已成功更新",
      "withdrawalDeleted": "提现已成功删除",
      "pleaseSelectRequest": "请选择提现申请",
      "confirmApprove": "确定要批准此提现吗？",
      "confirmReject": "确定要拒绝此提现吗？",
      "confirmPay": "将此提现标记为已支付？",
      "confirmDelete": "删除此提现申请？",
      "maxWithdrawAmount": "您可以提现至本金额",
      "loadWithdrawalHistoryError": "加载提现历史失败。请重试。",
      "loadWithdrawalDataError": "加载提现数据失败。请重试。",
      "loadWithdrawalStatsError": "加载提现统计失败。",
      "loadWithdrawalStatsByChildrenError": "加载子账户提现统计失败。",
      "refreshSuccess": "数据刷新成功",
      "refreshError": "刷新数据时出错。请重试。",
      "loadWalletStatsError": "加载钱包统计失败。使用默认值。",
      "formLoadError": "加载表单数据时出错",
      "qrImageTooLarge": "二维码图像不能超过5MB",
      "acceptedFormats": "接受的格式：JPG、PNG、WebP",
      "copyError": "复制到剪贴板失败",
      "fillAllFields": "请正确填写所有必填字段",
      "commentRequired": "拒绝提现需要注释",
      "rejectionCommentPlaceholder": "拒绝提现需要注释...",
      "rejectionCommentRequired": "* 评论对于合理化拒绝是强制性的",
      "withdrawalRevertedToPending": "提现已恢复为待处理",
      "updateStatusError": "更新提现状态失败",
      "fileTooBig": "文件大小不能超过10MB",
      "invalidImage": "请选择有效的图像文件",
      "screenshotRequired": "请上传转账截图",
      "markedAsPaidSuccess": "提现已成功标记为已支付",
      "markAsPaidError": "标记提现为已支付时出错",
      "loadError": "加载提现数据失败。请刷新页面。"
    },
    "admin": {
      "pending": "待批准",
      "approved": "已批准",
      "history": "支付历史",
      "settledCycles": "已结算周期",
      "withdrawalDetails": "提现详情",
      "paidAt": "支付时间",
      "paid": "已支付",
      "date": "日期",
      "transferProof": "转账凭证",
      "process": "批准",
      "addComment": "添加评论（可选）",
      "approvalConfirmation": "批准确认",
      "approveConfirm": "您确定要批准此提现申请吗？",
      "rejectionConfirmation": "拒绝确认",
      "rejectConfirm": "您确定要拒绝此申请吗？建议为代理添加评论。",
      "cancel": "取消",
      "approve": "批准",
      "reject": "拒绝",
      "totalLabel": "总计",
      "pendingTab": "待处理",
      "pendingCount": "待处理",
      "approvedTab": "已批准",
      "approvedCount": "已批准",
      "markAsPaid": "标记为已支付",
      "markAsPaidDescription": "此提现将根据已上传的转账凭证标记为已支付。",
      "revertToPending": "恢复为待处理",
      "revertToPendingDescription": "此提现将恢复为“待处理”状态，后续可再次处理。",
      "errorTitle": "错误",
      "withdrawalNotFound": "未找到提现记录。ID：{id}",
      "total": "总计",
      "totalWitdrawals": "总提现额"
    },
    "agent": {
      "viewProof": "查看凭证",
      "viewDetails": "查看详情",
      "editWithdrawal": "编辑提现",
      "withdrawalDetails": "提现详情",
      "statusHistory": "状态历史",
      "editWithdrawalTitle": "编辑提现",
      "editWithdrawalSubtitle": "更新您的提现申请信息",
      "currentInfo": "当前信息",
      "confirmPasswordHint": "请使用提现密码确认",
      "editNotAllowed": "仅待处理状态的提现可编辑",
      "editSuccess": "提现修改成功",
      "saveChanges": "保存修改",
      "list": {
        "withdrawal": "提现",
        "status": "状态",
        "timeline": "时间",
        "account": "账户",
        "actions": "操作"
      }
    },
    "commissions": {
      "all": "全部",
      "settled": "已结算",
      "pending": "待处理",
      "order": "订单",
      "date": "日期",
      "orderAmount": "金额",
      "commission": "佣金",
      "status": "状态",
      "settledStatus": "已结算",
      "pendingStatus": "待处理"
    },
    "settlement": {
      "cycle": "结算周期",
      "cycleDescription": "结算在每月最后一天进行",
      "cycleDescriptionDetailed": "订单收益按月结算。每月的订单收益会在次月转换为可提现余额。",
      "nextSettlementTitle": "下次结算",
      "nextSettlementExample": "2026年2月的结算将于2026年3月1日可用。",
      "periods": {
        "january2026": {
          "month": "2026年1月",
          "status": "2月1日可提现"
        },
        "february2026": {
          "month": "2026年2月",
          "status": "进行中 - 3月1日可提现"
        },
        "march2026": {
          "month": "2026年3月",
          "status": "即将开放"
        }
      }
    },
    "pagination": {
      "showing": "显示第 {start} 到 {end} 条，共 {total} 条"
    },
    "common": {
      "copy": "复制"
    },
    "stats": {
      "title": "提现统计",
      "subtitle": "按子账户提现请求概览",
      "yesterday": "昨日提现 笔数/金额",
      "today": "今日提现 笔数/金额",
      "lastThreeDays": "最近3日提现",
      "unpaid": "未结算金额"
    },
    "maxButton": "最大"
  },
  "emoji": {
    "title": "表情符号管理",
    "addNew": "添加新表情符号",
    "addNewGroup": "添加新组",
    "updateEmoji": "更新表情符号",
    "confirmDelete": "确认删除",
    "code": "代码",
    "images": "图像（最多100）",
    "single": "单个",
    "multiple": "多个",
    "group": "组",
    "type": "类型",
    "groupName": "组名称",
    "description": "描述",
    "status": "状态",
    "newImage": "新图像",
    "cancel": "取消",
    "addEmoji": "添加表情符号",
    "addEmojis": "添加{count}个表情符号",
    "createGroup": "创建组",
    "save": "保存",
    "delete": "删除",
    "newGroup": "新组",
    "totalEmojis": "总表情符号数",
    "groups": "组",
    "svgEmojis": "SVG表情符号",
    "gifEmojis": "GIF表情符号",
    "jpgEmojis": "JPG表情符号",
    "filterByGroup": "按组过滤",
    "filterByType": "按类型过滤",
    "allGroups": "所有组",
    "allTypes": "所有类型",
    "reset": "重置",
    "loading": "正在加载表情符号...",
    "id": "ID",
    "image": "图像",
    "url": "URL",
    "actions": "操作",
    "selectAGroup": "选择一个组",
    "nameRequired": "名称是必填项",
    "codeRequired": "需要输入验证码",
    "noGroupFound": "⚠️ 未找到组。请先创建一个",
    "filesSelected": "已选择{count}个文件",
    "keepCurrentImage": "如果未选择文件，保持当前图像",
    "areYouSureDelete": "您确定要删除此表情符号吗",
    "emojiNumber": "表情符号 #{id}",
    "groupDescription": "组描述",
    "codePlaceholder": "例如：笑脸",
    "groupNamePlaceholder": "例如：情感",
    "groupCodePlaceholder": "例如：emotions",
    "groupDescriptionPlaceholder": "组描述",
    "svg": "SVG",
    "jpg": "JPG",
    "gif": "GIF",
    "imageRequired": "需要图像",
    "pleaseSelectImage": "请选择图像",
    "chooseFile": "选择文件",
    "noFileChosen": "未选择文件",
    "noEmojiAvailable": "没有可用的表情符号",
    "noResultForFilter": "过滤器无结果",
    "createGroupFirst": "先创建一个组",
    "tryModifyFilter": "尝试修改过滤器",
    "createAGroup": "创建一个组",
    "noGroup": "无组",
    "preview": "预览",
    "activated": "已激活",
    "deactivated": "已停用",
    "edit": "编辑",
    "emojiCreated": "已创建表情符号！",
    "emojiCreatedSuccess": "成功创建了{count}个表情符号！",
    "emojiDeleted": "已删除表情符号！",
    "errorUpdatingEmoji": "更新表情符号时出错",
    "emojiStatusUpdated": "表情符号状态已更新！",
    "emojiUpdated": "已更新表情符号！",
    "errorCreatingEmoji": "创建表情符号时出错",
    "errorCreatingGroup": "创建组时出错",
    "errorDeletingEmoji": "删除表情符号时出错",
    "errorLoadingEmoji": "加载表情符号时出错",
    "errorLoadingGroups": "加载组时出错",
    "errorUpdatingEmoji": "更新表情符号时出错",
    "errorUpdatingEmojiStatus": "更新表情符号状态时出错",
    "fileNotSupported": "不支持的文件。请使用JPEG、PNG、GIF、WebP或SVG。",
    "fileTooLarge": "文件太大（最大2MB）",
    "fileTooLargeMessage": "文件太大。最大2MB。",
    "fileTypeNotSupported": "不支持的文件类型",
    "groupCreated": "已创建组\"{name}\"！",
    "maximum100Files": "最多允许100个文件",
    "next": "下一个",
    "noEmojiSelected": "未选择表情符号",
    "onlyOneFileAllowed": "单文件模式下只允许一个文件",
    "page": "页面{page}",
    "pleaseCorrectErrors": "请纠正错误",
    "pleaseCreateGroup": "请先创建一个组",
    "previous": "上一个",
    "resetFilters": "重置过滤器",
    "emojiGroups": "表情符号组",
    "manageGroups": "管理您的表情符号组",
    "noGroupCreated": "未创建组",
    "createFirstGroupDesc": "创建您的第一个组以开始组织表情符号",
    "editGroupModal": "编辑组",
    "confirmDeletion": "确认删除",
    "deleteGroupConfirm": "您确定要删除组\"{name}\"吗？",
    "groupDeleteWarning": "⚠️ 您必须先删除该组中的所有表情符号，然后才能删除它。",
    "noGroupSelected": "未选择组",
    "groupUpdated": "已更新组\"{name}\"！",
    "errorUpdatingGroup": "更新组时出错",
    "cannotDeleteGroupWithEmojis": "无法删除包含表情符号的组。请先删除该组中的表情符号。",
    "groupDeleted": "已删除组\"{name}\"！",
    "errorDeletingGroup": "删除组时出错",
    "countEmojis": "表情符号数量",
    "noDescription": "-"
  },
  "common": {
    "all": "全部",
    "search": "搜索",
    "create": "创建",
    "clear": "清除",
    "showing": "显示",
    "active": "活跃",
    "inactive": "非活跃",
    "loading": "加载中",
    "save": "保存",
    "status": "状态",
    "actions": "操作",
    "details": "详情",
    "edit": "编辑",
    "approve": "批准",
    "reject": "拒绝",
    "deactivate": "停用",
    "delete": "删除",
    "yes": "是",
    "no": "否",
    "dates": "日期",
    "createdAt": "创建时间",
    "error": "发生错误",
    "updatedAt": "更新时间",
    "username": "用户名",
    "role": "角色",
    "code": "代码",
    "page": "第",
    "of": "页，共",
    "show": "显示",
    "cancel": "取消",
    "refresh": "刷新",
    "copied": "已复制",
    "close": "关闭"
  },
  "chatlog": {
    "title": "聊天记录",
    "columns": {
      "from": "来源",
      "to": "收件人",
      "agent_name": "坐席",
      "date": "日期"
    },
    "filters": {
      "userbyId": "按用户 ID 搜索",
      "user": "用户 ID",
      "keyword": "关键词",
      "date": "创建时间",
      "search_user": "按用户 ID 搜索...",
      "search_keyword": "搜索关键词..."
    },
    "noData": "暂无聊天记录"
  },
  "price_config": {
    "pageTitle": "价格配置",
    "filters": {
      "agentPlaceholder": "代理名称",
      "typePlaceholder": "选择配置类型",
      "searchButton": "搜索",
      "initializeAllAgentsButton": "初始化所有代理"
    },
    "typeOptions": {
      "home": "首页短视频",
      "video": "长视频",
      "post": "帖子"
    },
    "table": {
      "agentName": "代理名称",
      "type": "类型",
      "minPrice": "最低价格",
      "maxPrice": "最高价格",
      "createdAt": "创建时间",
      "updatedAt": "更新时间",
      "noData": "-",
      "edit": "编辑",
      "actions": "操作"
    },
    "messages": {
      "initSuccess": "所有代理的价格映射已成功初始化",
      "initFail": "初始化代理价格映射失败"
    },
    "editModal": {
      "title": "编辑价格配置",
      "typePlaceholder": "请选择类型",
      "minPricePlaceholder": "请输入最低价",
      "maxPricePlaceholder": "请输入最高价",
      "cancel": "取消",
      "save": "保存",
      "saveFailed": "保存失败，请稍后重试"
    }
  },
  "orders": {
    "title": "订单管理系统",
    "subtitle": "仪表板 · 操作面板",
    "error": {
      "fetchOrders": "获取支付订单失败"
    },
    "filters": {
      "title": "搜索与筛选",
      "agentName": "代理名称",
      "userId": "用户ID",
      "total": "总权限",
      "records": "记录",
      "orderType": "订单类型",
      "orderNumber": "订单号码",
      "paymentStatus": "付款状态",
      "paymentChannel": "付款渠道",
      "deduction": "是否扣量",
      "deductionYes": "是",
      "deductionNo": "否",
      "minimumOrderAmount": "最低订单金额",
      "orderTime": "下单时间",
      "advanced": "高级筛选",
      "fromApp": "来自应用",
      "userIp": "用户IP",
      "allAgents": "所有代理",
      "noAgentsFound": "未找到代理",
      "allTypes": "所有类型",
      "allStatuses": "所有状态",
      "allChannels": "所有渠道",
      "all": "全部",
      "mobile": "手机应用",
      "android": "安卓",
      "androidHint": "仅 Android 订单（不包含 iOS）。",
      "web": "网页",
      "placeholders": {
        "username": "请输入准确的用户名...",
        "agentSearch": "搜索代理...",
        "userId": "精确匹配…",
        "orderNumber": "最后6位或完整号码…",
        "minimumOrderAmount": "例如 200",
        "userIp": "例如: 192.168.1.1"
      }
    },
    "actions": {
      "search": "搜索",
      "reset": "重置",
      "export": "导出CSV",
      "retry": "重试",
      "lock": "锁定订单",
      "unlock": "解锁订单",
      "cancel": "取消订单",
      "block": "封锁代理",
      "blockAgent": "封禁代理",
      "blockUser": "封禁用户",
      "reactivateAgent": "解封代理",
      "reactivateUser": "解封用户",
      "lockOrder": "锁单",
      "confirmBlockOrder": "确定封禁该订单？",
      "confirmBlockAgentFromOrder": "确定封禁代理 {agentId} 吗？",
      "confirmBlockUserFromOrder": "确定封禁用户 {userId} 吗？",
      "confirmReactivateAgentFromOrder": "确定解封代理 {agentId} 吗？",
      "confirmReactivateUserFromOrder": "确定解封用户 {userId} 吗？",
      "revokeStolen": "撤销暗扣",
      "openAgentBackend": "跳转代理后台",
      "confirmLockOrder": "确定锁定该订单？",
      "confirmRevokeStolen": "确定撤销该订单的暗扣（扣量）？"
    },
    "table": {
      "total": "总计",
      "records": "记录",
      "headers": {
        "orderNumber": "订单号",
        "agentName": "代理",
        "userId": "用户id",
        "billingAddress": "支付地址",
        "paymentDuration": "支付耗时",
        "productName": "产品",
        "orderAmount": "金额",
        "orderStatus": "订单状态",
        "isStolen": "是否扣量",
        "paymentChannel": "支付通道",
        "orderType": "订单类型",
        "userIp": "IP",
        "fromApp": "来源",
        "userRegTime": "注册时间",
        "orderTime": "下单时间",
        "actions": "操作"
      },
      "noData": "未找到符合条件的订单.",
      "copyTooltip": "点击复制"
    },
    "sorting": {
      "newest": "最新",
      "oldest": "最旧",
      "amount": "金额",
      "amountAsc": "金额升序",
      "amountDesc": "金额降序"
    },
    "statuses": {
      "pending": "待支付",
      "success": "成功",
      "failed": "失败"
    },
    "orderTypes": {
      "recharge": "充值",
      "resource": "单片",
      "vip": "VIP",
      "time_package": "时间套餐"
    },
    "pagination": {
      "page": "第",
      "total": "页，共",
      "showing": "显示",
      "showingOf": "条，共",
      "rowsPerPage": "条/页"
    },
    "status": {
      "pending": "待处理",
      "completed": "已完成",
      "failed": "失败"
    },
    "messages": {
      "filtersApplied": "筛选条件已应用",
      "loading": "加载中...",
      "websocketConnectionFailed": "WebSocket 连接失败，实时更新功能可能不可用。",
      "filtersReset": "筛选条件已重置",
      "copySuccess": "✓ 已复制: {text}",
      "orderAction": "订单 {orderNumber} {action} 成功",
      "exportSuccess": "✓ CSV已导出 ({count} 行)",
      "loadingError": "加载订单时出错",
      "lockOrderSuccess": "锁单成功",
      "lockOrderFailed": "锁单失败",
      "revokeStolenSuccess": "已撤销暗扣",
      "revokeStolenFailed": "撤销暗扣失败",
      "noAgentId": "该订单无关联代理",
      "noUserId": "该订单无关联用户",
      "blockAgentSuccess": "代理 {agentId} 封禁成功",
      "blockAgentFailed": "封禁代理失败，请重试",
      "blockUserSuccess": "用户 {userId} 封禁成功",
      "blockUserFailed": "封禁用户失败，请重试",
      "reactivateAgentSuccess": "代理 {agentId} 解封成功",
      "reactivateAgentFailed": "解封代理失败，请重试",
      "reactivateUserSuccess": "用户 {userId} 解封成功",
      "reactivateUserFailed": "解封用户失败，请重试",
      "agentCredentialsMissing": "无法代登录：缺少代理账号或密码",
      "openAgentTabOpened": "已在新标签页打开代理后台",
      "openAgentFailed": "打开代理后台失败",
      "impersonateNotAgent": "该账号不是代理，无法进入代理后台",
      "missingOrderId": "缺少订单 ID，无法执行该操作"
    }
  },
  "common": {
    "all": "全部",
    "search": "搜索",
    "create": "创建",
    "add": "添加",
    "clear": "清除",
    "showing": "显示",
    "status": "状态",
    "active": "活跃",
    "inactive": "非活跃",
    "activate": "激活",
    "deactivate": "停用",
    "approve": "批准",
    "reject": "拒绝",
    "platformsList": "平台列表",
    "platform": "平台",
    "description": "描述",
    "actions": "操作",
    "details": "详情",
    "noDescriptionProvided": "暂无描述",
    "edit": "编辑",
    "delete": "删除",
    "save": "保存",
    "update": "更新",
    "apply": "应用",
    "loading": "加载中",
    "retry": "重试",
    "error": "发生错误",
    "success": "成功",
    "ok": "确定",
    "yes": "是",
    "no": "否",
    "confirmDelete": "您确定吗？",
    "dates": "日期",
    "createdAt": "创建时间",
    "updatedAt": "更新时间",
    "username": "用户名",
    "role": "角色",
    "code": "代码",
    "page": "第",
    "of": "页，共",
    "show": "显示",
    "cancel": "取消",
    "refresh": "刷新",
    "copied": "已复制",
    "close": "关闭"
  },
  "chatlog": {
    "title": "聊天记录",
    "columns": {
      "from": "来源",
      "to": "收件人",
      "agent_name": "坐席",
      "date": "日期"
    },
    "filters": {
      "user": "用户 ID",
      "keyword": "关键词",
      "date": "创建时间"
    },
    "noData": "暂无聊天记录"
  },
  "price_config": {
    "pageTitle": "价格配置",
    "filters": {
      "agentPlaceholder": "代理名称",
      "typePlaceholder": "选择配置类型",
      "searchButton": "搜索",
      "initializeAllAgentsButton": "初始化所有代理"
    },
    "code": "代码",
    "page": "第",
    "of": "页，共",
    "show": "显示",
    "cancel": "取消",
    "refresh": "刷新",
    "close": "关闭"
  },
  "chatlog": {
    "title": "聊天记录",
    "columns": {
      "from": "来源",
      "to": "收件人",
      "agent_name": "坐席",
      "date": "日期"
    },
    "filters": {
      "user": "用户 ID",
      "userbyId": "按用户 ID 搜索",
      "keyword": "关键词",
      "date": "创建时间"
    },
    "noData": "暂无聊天记录"
  },
  "price_config": {
    "pageTitle": "价格配置",
    "filters": {
      "agentPlaceholder": "代理名称",
      "typePlaceholder": "选择配置类型",
      "searchButton": "搜索",
      "initializeAllAgentsButton": "初始化所有代理"
    },
    "typeOptions": {
      "home": "首页短视频",
      "video": "长视频",
      "post": "帖子"
    },
    "table": {
      "agentName": "代理名称",
      "type": "类型",
      "minPrice": "最低价格",
      "maxPrice": "最高价格",
      "createdAt": "创建时间",
      "updatedAt": "更新时间",
      "noData": "-",
      "edit": "编辑",
      "actions": "操作"
    },
    "messages": {
      "initSuccess": "所有代理的价格映射已成功初始化",
      "initFail": "初始化代理价格映射失败",
      "promotionPlatform": {
        "title": "推广平台",
        "subtitle": "管理和配置您的推广平台",
        "addPlatform": "添加平台",
        "totalPlatforms": "平台总数",
        "active": "活跃",
        "platformsList": "平台列表",
        "platform": "平台",
        "description": "描述",
        "actions": "操作",
        "noDescriptionProvided": "暂无描述",
        "edit": "编辑",
        "delete": "删除",
        "noPlatformsFound": "未找到平台",
        "addFirstPlatform": "添加您的第一个平台以开始使用",
        "addNewPlatform": "添加新平台",
        "editPlatform": "编辑平台",
        "platformName": "平台名称",
        "platformNamePlaceholder": "输入平台名称...",
        "nameRequired": "名称为必填项",
        "descriptionOptional": "描述（可选）",
        "descriptionPlaceholder": "输入描述...",
        "saveFailed": "保存平台失败",
        "cancel": "取消",
        "createPlatform": "创建平台",
        "saveChanges": "保存更改",
        "nameIsRequired": "平台名称为必填项",
        "platformCreated": "平台创建成功",
        "platformUpdated": "平台更新成功",
        "platformDeleted": "平台删除成功",
        "confirmDeleteWithName": "您确定要删除平台\"{name}\"吗？",
        "confirmDelete": "您确定要删除该平台吗？",
        "loadingError": "加载平台失败"
      }
    },
    "orders": {
      "title": "订单管理系统",
      "subtitle": "仪表板 · 操作面板",
      "filters": {
        "title": "搜索与筛选",
        "agentName": "代理名称",
        "total": "总计",
        "noChannelsFound": "未找到渠道",
        "records": "记录",
        "userId": "用户ID",
        "orderType": "订单类型",
        "orderNumber": "订单号码",
        "paymentStatus": "付款状态",
        "paymentChannel": "付款渠道",
        "orderTime": "下单时间",
        "advanced": "高级筛选",
        "fromApp": "来自应用",
        "userIp": "用户IP",
        "allAgents": "所有代理",
        "noAgentsFound": "未找到代理",
        "allTypes": "所有类型",
        "allStatuses": "所有状态",
        "allChannels": "所有渠道",
        "all": "全部",
        "mobile": "手机应用",
        "android": "安卓",
        "androidHint": "仅 Android 订单（不包含 iOS）。",
        "web": "网页",
        "placeholders": {
          "agentSearch": "搜索代理...",
          "userId": "精确匹配…",
          "channelSearch": "搜索渠道...",
          "orderNumber": "最后6位或完整号码…",
          "userIp": "例如: 192.168.1.1"
        }
      },
      "actions": {
        "search": "搜索",
        "reset": "重置",
        "export": "导出CSV",
        "lockOrder": "锁单",
        "revokeStolen": "撤销暗扣",
        "openAgentBackend": "跳转代理后台",
        "confirmLockOrder": "确定锁定该订单？",
        "confirmRevokeStolen": "确定撤销该订单的暗扣（扣量）？"
      },
      "table": {
        "headers": {
          "orderNumber": "订单号",
          "agentName": "代理名",
          "userId": "用户ID",
          "productName": "产品名",
          "orderAmount": "订单金额",
          "orderStatus": "订单状态",
          "isStolen": "是否扣量",
          "paymentChannel": "付款渠道",
          "orderType": "订单类型",
          "userIp": "用户IP",
          "fromApp": "来自应用",
          "userRegTime": "注册时间",
          "orderTime": "下单时间",
          "actions": "操作"
        },
        "noData": "未找到符合条件的订单.",
        "copyTooltip": "点击复制"
      },
      "sorting": {
        "newest": "最新",
        "oldest": "最旧",
        "amount": "金额",
        "amountAsc": "金额升序",
        "amountDesc": "金额降序"
      },
      "pagination": {
        "page": "第",
        "total": "页，共",
        "showing": "显示",
        "showingOf": "条，共",
        "rowsPerPage": "条/页"
      },
      "status": {
        "pending": "待处理",
        "completed": "已完成",
        "failed": "失败"
      },
      "messages": {
        "filtersApplied": "筛选条件已应用",
        "filtersReset": "筛选条件已重置",
        "copySuccess": "✓ 已复制: {text}",
        "exportSuccess": "✓ CSV已导出 ({count} 行)",
        "loadingError": "加载订单时出错",
        "loading": "加载中...",
        "retry": "重试",
        "lockOrderSuccess": "锁单成功",
        "lockOrderFailed": "锁单失败",
        "revokeStolenSuccess": "已撤销暗扣",
        "revokeStolenFailed": "撤销暗扣失败",
        "noAgentId": "该订单无关联代理",
        "agentCredentialsMissing": "无法代登录：缺少代理账号或密码",
        "openAgentTabOpened": "已在新标签页打开代理后台",
        "openAgentFailed": "打开代理后台失败",
        "impersonateNotAgent": "该账号不是代理，无法进入代理后台",
        "missingOrderId": "缺少订单 ID，无法执行该操作"
      }
    },
    "common": {
      "all": "全部",
      "search": "搜索",
      "create": "创建",
      "clear": "清除",
      "showing": "显示",
      "active": "活跃",
      "inactive": "非活跃",
      "loading": "加载中",
      "save": "保存",
      "status": "状态",
      "actions": "操作",
      "details": "详情",
      "edit": "编辑",
      "deactivate": "停用",
      "delete": "删除",
      "yes": "是",
      "no": "否",
      "dates": "日期",
      "createdAt": "创建时间",
      "updatedAt": "更新时间",
      "username": "用户名",
      "role": "角色",
      "code": "代码",
      "page": "第",
      "of": "页，共",
      "show": "显示",
      "cancel": "取消",
      "refresh": "刷新",
      "close": "关闭"
    }
  },
  "agentIncomes": {
    "title": "代理收入",
    "exportCsv": "导出CSV",
    "agent": "代理",
    "type": "类型",
    "dateRange": "日期范围",
    "search": "搜索",
    "reset": "重置",
    "filteredTotal": "筛选总计",
    "colAgent": "代理",
    "colType": "类型",
    "colTime": "时间",
    "noData": "没有符合当前筛选条件的记录。",
    "pageOf": "第 {page} 页",
    "totalRecords": "共 {n} 条记录",
    "next": "下一页",
    "subtitle": "仪表板 · 运营面板",
    "agentPlaceholder": "输入ID / 姓名",
      "typeAllt": "所有类型",
      "amountOrder": "金额排序",
      "amountOrderDefault": "默认排序",
      "amountOrderDesc": "金额从高到低",
      "amountOrderAsc": "金额从低到高",
      "datePresetAll": "全部",
      "datePresetToday": "今天",
      "datePresetYesterday": "昨天",
      "colAmount": "金额",
    "colSubAgent": "下级代理",
    "prev": "上一页",
    "typeVideo": "视频",
    "typePosts": "帖子",
    "typeShortVideo": "短视频",
    "typeVIP": "VIP",
    "fetchError": "加载代理收入数据失败。请刷新页面重试。",
    "csvExported": "代理收入数据已成功导出为CSV文件。"
  },
  "domainRegistration": {
    "title": "域名申请",
    "deleteType": {
      "success": "域名类型删除成功",
      "error": "删除域名类型失败"
    },
    "delete": {
      "success": "发送成功！"
    },
    "list": "列表",
    "approve": {
      "success": "域名 {domain} 已成功批准"
    },
    "reject": {
      "success": "域名 {domain} 已成功拒绝"
    },
    "pagination": {
      "itemsPerPage": "每页 {count} 条",
      "perPage": "{count} 条/页",
      "page": "第",
      "of": "页，共",
      "show": "显示"
    },
    "editModal": {
      "success": "域名类型更新成功"
    },
    "status": {
      "success": "成功",
      "pending": "待处理",
      "rejected": "已拒绝"
    },
    "refreshing": "正在刷新数据...",
    "refreshSuccess": "数据刷新成功",
    "refreshError": "数据刷新失败",
    "setToPending": {
      "success": "域名 {domain} 已成功设置为待处理状态"
    },
    "tabs": {
      "domains": "短域名",
      "types": "域名类型"
    },
    "keyword": "关键词",
    "manageAddress": "地址解析管理",
    "addDomain": "添加域名",
    "search": "搜索",
    "delete": "删除",
    "actions": "操作",
    "serialNumber": "序号",
    "agentName": "代理商名称",
    "agentNumber": "代理商编号",
    "domainName": "申请域名",
    "parsingType": "解析类型",
    "resolvedAddress": "解析地址",
    "state": "状态",
    "creationTime": "创建时间",
    "noData": "暂无数据",
    "currentlyDisplaying": "当前显示第 {start} 至 {end} 项，共 {total} 项。",
    "eachPage": "每页",
    "dnsModal": {
      "title": "地址解析管理",
      "cnameAddress": "类型",
      "ipAddress": "网址或者DNS",
      "redirectAddress": "备注",
      "submit": "提交",
      "cancel": "取消",
      "success": "操作成功",
      "errors": {
        "cnameRequired": "类型不能为空",
        "invalidCname": "类型无效",
        "domainRequired": "域名必填",
        "parsingTypeRequired": "解析类型必填",
        "ipRequired": "网址或者DNS不能为空",
        "invalidIp": "网址或者DNS无效",
        "redirectRequired": "备注不能为空",
        "invalidRedirect": "备注无效",
        "invalidIpRange": "网址或者DNS每段数值必须在0到255之间",
        "invalidUrl": "请输入有效的URL（以http://或https://开头）",
        "fillRequiredFields": "请正确填写所有必填项"
      }
    },
    "addDomainModal": {
      "title": "创建域名申请",
      "domainNameLabel": "申请域名",
      "parsingTypeLabel": "解析类型",
      "selectOptions": "请选择",
      "cdn": "CDN(CNAME)",
      "btPanel": "BT面板 (IP地址)",
      "urlRedirection": "URL重定向",
      "required": "*",
      "success": "域名 {domain} 创建成功",
      "keep": "保留并继续创建",
      "saveAndCreate": "保存并创建下一个",
      "cancel": "取消",
      "errors": {
        "domainRequired": "域名不能为空",
        "domainMinLength": "域名长度至少为2个字符",
        "parsingTypeRequired": "解析类型不能为空",
        "RequiredFields": "请填写所有必填项",
        "invalidType": "解析类型无效",
        "noAdmin": "用户未认证",
        "fillRequiredFields": "请正确填写所有必填项"
      }
    },
    "rejectionModal": {
      "title": "拒绝原因",
      "reasonLabel": "拒绝理由",
      "placeholder": "请输入拒绝理由...",
      "cancel": "取消",
      "submit": "确认拒绝",
      "errors": {
        "reasonRequired": "请输入拒绝理由"
      }
    },
    "columns": {
      "serialNumber": "序号",
      "agentName": "代理商名称",
      "agentNumber": "代理商编号",
      "domainName": "域名",
      "parsingType": "解析类型",
      "resolvedAddress": "解析地址",
      "redirectAddress": "备注",
      "state": "状态",
      "domain": "域名",
      "action": "操作",
      "rejectionReason": "拒绝原因",
      "creationTime": "创建时间"
    },
    "typeColumns": {
      "id": "ID",
      "name": "名称",
      "ipAddress": "网址或者DNS",
      "redirectAddress": "备注",
      "createdAt": "创建时间"
    }
  },
  "impersonation": {
    "loading": "加载中...",
    "authenticating": "正在模拟身份验证",
    "goToLogin": "前往登录",
    "error": "错误",
    "closeTab": "关闭标签页",
    "redeemError": "模拟会话恢复失败",
    "checkingDomain": "正在检查重定向域名...",
    "domainUnreachable": "重定向域名无法访问",
    "fallbackMessage": "您将被重定向到默认应用程序。",
    "redirectingToFallback": "正在重定向到默认应用程序...",
    "redirecting": "重定向中..."
  },
  "userNotificationPage": {
    "title": "系统通知",
    "editNotification": "编辑通知",
    "subtitle": "管理并向用户发送通知",
    "newNotification": "新建通知",
    "total": "总计",
    "notifications": "条通知",
    "loadingHistory": "正在加载历史记录...",
    "empty": "未找到通知",
    "confirmDelete": "您确定要删除此通知吗？",
    "form": {
      "notificationTitle": "通知标题",
      "notificationTitlePlaceholder": "例如：计划维护",
      "notificationType": "通知类型",
      "chooseType": "请选择类型...",
      "recipient": "接收人",
      "allUsers": "所有用户",
      "specificUser": "指定用户",
      "userId": "用户 ID (user_id)",
      "userIdPlaceholder": "例如：12345",
      "deviceType": "设备类型",
      "allDevices": "所有设备",
      "actionUrlOptional": "操作链接（可选）",
      "messageContent": "消息内容",
      "messageContentPlaceholder": "通知详情..."
    },
    "actions": {
      "sending": "发送中...",
      "sendNotification": "发送通知",
      "reset": "重置",
      "edit": "编辑",
      "updateNotification": "更新通知",
      "refresh": "刷新",
      "markAsRead": "标记为已读",
      "delete": "删除",
      "cancel": "取消",
      "createNotification": "创建通知",
      "search": "搜索"
    },
    "table": {
      "type": "类型",
      "title": "标题",
      "recipient": "接收人",
      "device": "设备",
      "createdAt": "创建时间",
      "status": "状态",
      "actions": "操作",
      "allBroadcast": "全部（广播）",
      "idPrefix": "ID",
      "read": "已读",
      "unread": "未读"
    },
    "devices": {
      "all": "全部",
      "h5": "H5",
      "web": "网页",
      "ios": "iOS",
      "android": "Android"
    },
    "filters": {
      "searchPlaceholder": "搜索标题或内容...",
      "device": "设备类型"
    },
    "types": {
      "systemAlert": "系统警报",
      "groupInvitation": "群组邀请",
      "joinGroup": "加入群组",
      "invitationAccepted": "邀请已接受",
      "invitationApproved": "邀请已批准",
      "invitationDeclined": "邀请已拒绝",
      "invitationPending": "邀请待处理",
      "invitationToJoinRejected": "加入邀请被拒绝",
      "accountUpdate": "账户更新",
      "featureAnnouncement": "功能公告",
      "maintenance": "维护",
      "securityAlert": "安全警报"
    },
    "toasts": {
      "requiredFields": "标题和内容为必填项。",
      "sendSuccess": "通知发送成功！",
      "sendError": "发送通知失败。",
      "loadError": "加载通知失败。",
      "markedAsRead": "已标记为已读",
      "deleted": "通知已删除",
      "updateSuccess": "通知更新成功",
      "urlCopied": "链接已复制到剪贴板",
      "userIdRequired": "用户ID为必填项"
    },
    "pagination": {
      "previous": "上一页",
      "next": "下一页",
      "pageInfo": "第 {page} / {totalPages} 页",
      "limit": "每页条数"
    }
  },
  "revenue": {
    "title": "收入报表",
    "subtitle": "代理及下级用户收入概览",
    "filters": {
      "title": "筛选条件",
      "agent": "代理",
      "allAgents": "全部代理",
      "searchAgent": "搜索代理...",
      "noAgents": "未找到代理",
      "date": "日期",
      "vipLevel": "VIP等级",
      "allLevels": "全部等级"
    },
    "summary": {
      "totalAgents": "代理总数",
      "totalSubordinates": "下级用户总数",
      "todayRevenue": "今日收入",
      "yesterdayRevenue": "昨日收入",
      "totalVipShare": "平均VIP分成"
    },
    "table": {
      "total": "共",
      "records": "条记录",
      "todayRevenue": "今日收入",
      "yesterdayRevenue": "昨日收入",
      "subordinates": "下级",
      "rank": "排名",
      "agent": "代理",
      "code": "代码",
      "today": "今日",
      "yesterday": "昨日",
      "vipShareRate": "VIP分成比例",
      "subscription": "订阅",
      "action": "操作",
      "noSubordinates": "暂无下级用户",
      "noData": "暂无数据",
      "headers": {
        "subordinateName": "下级用户名称",
        "subordinateCode": "用户代码",
        "todayRevenue": "今日营业额",
        "yesterdayRevenue": "昨日营业额",
        "vipShareRate": "VIP分成比例",
        "vipLevel": "VIP等级",
        "registrationDate": "注册日期"
      }
    },
    "actions": {
      "search": "搜索",
      "reset": "重置",
      "retry": "重试",
      "export": "导出CSV"
    },
    "messages": {
      "loading": "正在加载收入数据...",
      "loadError": "加载收入数据失败",
      "searchApplied": "筛选条件已应用",
      "filtersReset": "筛选条件已重置",
      "exportSuccess": "导出成功（{count}行）"
    }
  }
}
